import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../api';
import DetailPanel from '../components/DetailPanel';
import { useAuth } from '../AuthContext';
import { OPERATIONS_TABS } from '../config/pages';

// ── Platform SVGs + Colors (shared with Planning.js) ────────
let _svgNonce = 0;
const PLATFORM_COLORS = {
  'Instagram':'#e8323c','Facebook':'#1877f2','LinkedIn':'#0a66c2','YouTube':'#e84545',
  'X / Twitter':'#1da1f2','WhatsApp':'#25d366','Google Ads':'#4285f4','Meta Ads':'#1877f2',
  'Pinterest':'#e60023','TikTok':'#010101','Snapchat':'#fffc00','Telegram':'#229ed9',
  'Email / CRM':'#e87830','Amazon Ads':'#ff9900','Flipkart Ads':'#2874f0','Spotify':'#1db954',
  'Quora Ads':'#a82400','Reddit':'#ff4500','Discord':'#5865f2','Threads':'#000000',
};

// Platform SVG icons
const PLATFORM_SVG = {
  'Instagram': `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><defs><radialGradient id="ig_g1" cx="30%" cy="107%" r="150%"><stop offset="0%" stop-color="#fdf497"/><stop offset="5%" stop-color="#fdf497"/><stop offset="45%" stop-color="#fd5949"/><stop offset="60%" stop-color="#d6249f"/><stop offset="90%" stop-color="#285AEB"/></radialGradient></defs><rect width="24" height="24" rx="5" fill="url(#ig_g1)"/><circle cx="12" cy="12" r="4.5" stroke="white" stroke-width="1.8" fill="none"/><circle cx="17" cy="7" r="1.2" fill="white"/></svg>`,
  'Facebook':  `<svg viewBox="0 0 24 24" fill="#1877f2" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="5" fill="#1877f2"/><path d="M16 8h-2a1 1 0 0 0-1 1v2h3l-.5 3H13v7h-3v-7H8v-3h2V9a4 4 0 0 1 4-4h2v3z" fill="white"/></svg>`,
  'LinkedIn':  `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="4" fill="#0a66c2"/><path d="M7 10h2v7H7v-7zm1-3a1.2 1.2 0 1 1 0 2.4A1.2 1.2 0 0 1 8 7zm4 3h2v1h.03A2.5 2.5 0 0 1 16.5 10c2 0 2.5 1.3 2.5 3v4h-2v-3.5c0-.8 0-1.9-1.2-1.9S14 12.6 14 13.5V17h-2v-7z" fill="white"/></svg>`,
  'YouTube':   `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="5" fill="#ff0000"/><path d="M19.6 7.8s-.2-1.4-.8-2c-.7-.8-1.5-.8-1.9-.8C14.8 5 12 5 12 5s-2.8 0-4.9.1c-.4 0-1.2 0-1.9.8-.6.6-.8 2-.8 2S4 9.4 4 11v1.5c0 1.6.2 3.2.2 3.2s.2 1.4.8 2c.7.8 1.7.7 2.1.8C8.6 18.7 12 18.7 12 18.7s2.8 0 4.9-.2c.4 0 1.2 0 1.9-.8.6-.6.8-2 .8-2s.4-1.6.4-3.2V11c0-1.6-.4-3.2-.4-3.2zM10 14.5V9l5 2.8-5 2.7z" fill="white"/></svg>`,
  'WhatsApp':  `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="5" fill="#25d366"/><path d="M12 4a8 8 0 0 0-6.9 12l-1 3.6 3.7-1A8 8 0 1 0 12 4zm4.4 11.4c-.2.5-1 1-1.4 1-.4 0-.8.1-2.4-.5s-2.7-2.3-2.8-2.4c-.1-.1-1-1.3-1-2.5s.6-1.8.9-2c.2-.2.5-.3.7-.3h.5c.2 0 .4 0 .5.4.2.5.7 1.7.7 1.8 0 .1 0 .3-.1.4l-.3.4c-.1.1-.2.3-.1.5.2.3.8 1.2 1.6 1.8.8.6 1.4.8 1.7 1 .2.1.4 0 .6-.2l.4-.5c.2-.3.4-.2.6-.1l1.5.7c.2.1.4.2.4.3.1.4-.1 1.1-.5 1.4z" fill="white"/></svg>`,
  'X / Twitter':`<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="5" fill="#000"/><path d="M17.7 4h2.6L14 10.7 21 20h-5.5l-4-5.2-4.5 5.2H4.4l6.7-7.7L4 4h5.6l3.6 4.7L17.7 4zm-.9 14.4h1.4L7.4 5.4H5.9l10.9 13z" fill="white"/></svg>`,
  'TikTok':    `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="5" fill="#010101"/><path d="M16.6 5.8c-.7-.8-1.1-1.9-1.1-3h-2.4v13.6c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.2 0 .4 0 .6.1V12c-.2 0-.4 0-.6 0-2.4 0-4.4 2-4.4 4.4s2 4.4 4.4 4.4 4.4-2 4.4-4.4V9.3c.9.6 2 1 3.1 1V8c-.7 0-1.5-.8-2-2.2z" fill="white"/></svg>`,
  'Telegram':  `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#229ed9"/><path d="M5 12l2.5 7.5 2-2.5 4 3 5.5-13-14 5z" fill="white" opacity="0.6"/><path d="M7.5 19.5l.8-5.7 8-7.5-9 5.4.2 7.8z" fill="white"/></svg>`,
  'Pinterest': `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#e60023"/><path d="M12 3C7 3 3 7 3 12c0 3.8 2.3 7 5.6 8.5-.1-.7-.1-1.7.1-2.5l1-4.2s-.3-.5-.3-1.3c0-1.2.7-2.1 1.6-2.1.8 0 1.1.6 1.1 1.2 0 .7-.5 1.9-.7 2.9-.2.9.4 1.6 1.2 1.6 1.4 0 2.3-1.7 2.3-4.2 0-1.8-1.2-3-3-3-2.1 0-3.3 1.6-3.3 3.2 0 .6.2 1.3.5 1.7.1.1.1.2 0 .3l-.3 1.1c0 .2-.2.2-.3.1-1.1-.5-1.7-2-1.7-3.3 0-2.7 2-5.2 5.8-5.2 3 0 5.4 2.2 5.4 5.1 0 3-1.9 5.5-4.6 5.5-.9 0-1.7-.5-2-.9l-.5 2.2c-.2.8-.7 1.7-1 2.3.8.2 1.6.3 2.4.3 5 0 9-4 9-9s-4-9-9-9z" fill="white"/></svg>`,
  'Google Ads':`<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="5" fill="#fff"/><circle cx="6.5" cy="17" r="3.5" fill="#fbbc04"/><circle cx="17.5" cy="17" r="3.5" fill="#34a853"/><circle cx="12" cy="7" r="3.5" fill="#4285f4"/></svg>`,
  'Meta Ads':  `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="5" fill="#0668e1"/><path d="M4 14c0 1.7.4 3 1 3.8.6.7 1.4 1 2 .7.7-.3 1.2-1.2 1.4-2.4l.8-4.5c.3-1.8 1-3 1.7-3.6.7-.6 1.5-.6 2.2 0 .7.6 1.2 1.8 1.5 3.4l.4 2.4c.2 1 .5 1.8.9 2.3.4.5.9.6 1.3.4.5-.2.9-.8 1.2-1.7.3-1 .4-2.1.4-3.3 0-1.6-.4-2.9-1.1-3.8-.7-.9-1.7-1.4-2.8-1.4-.8 0-1.6.3-2.3.8-.7.5-1.3 1.3-1.8 2.3-.3-1-.7-1.8-1.3-2.3-.6-.5-1.3-.8-2-.8-1.1 0-2 .5-2.7 1.4C4.4 8.9 4 10.2 4 12v2z" fill="white"/></svg>`,
  'Snapchat':  `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="5" fill="#fffc00"/><path d="M12 3c-2.5 0-4.5 2-4.5 4.5v3.1c-.3.1-.8.3-1.3.3s-.7-.1-.9-.1c-.1 0-.2 0-.2.1 0 .4.5.9 1.3 1.1.1 0 .2.1.2.2-.1.3-.5.8-1.1.8-.1 0-.3 0-.5-.1 0 .1 0 .2.1.3.4.7 1.5 1.1 2.1 1.2.1 0 .1.1.1.2-.3.3-.9.5-1.5.6.3.4 1.3.7 2.3.7 1.2 0 2-.4 2.5-1 .4.6 1.3 1 2.5 1 1 0 2-.3 2.3-.7-.6-.1-1.2-.3-1.5-.6 0-.1 0-.2.1-.2.6-.1 1.7-.5 2.1-1.2.1-.1.1-.2.1-.3-.2.1-.4.1-.5.1-.6 0-1-.5-1.1-.8 0-.1.1-.2.2-.2.8-.2 1.3-.7 1.3-1.1 0-.1-.1-.1-.2-.1-.2 0-.4.1-.9.1-.5 0-1-.2-1.3-.3V7.5C16.5 5 14.5 3 12 3z" fill="#111"/></svg>`,
  'Email / CRM':`<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="5" fill="#e87830"/><path d="M4 8l8 5 8-5V7H4v1zm0 2.5V17h16V10.5l-8 5-8-5z" fill="white"/></svg>`,
  'Spotify':   `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#1db954"/><path d="M16.7 10.8c-2.5-1.5-6.7-1.6-9-.9-.4.1-.8-.1-.9-.5s.1-.8.5-.9c2.6-.8 7.2-.6 10 1.1.3.2.4.6.2.9-.2.4-.6.5-.8.3zM16.3 13c-.2.3-.5.4-.8.2-2.1-1.3-5.3-1.7-7.7-.9-.3.1-.6-.1-.7-.4-.1-.3.1-.6.4-.7 2.8-.8 6.3-.4 8.7 1.1.3.2.4.5.1.7zm-.9 2.2c-.1.2-.4.3-.6.2-1.8-1.1-4.1-1.4-6.8-.7-.2.1-.5-.1-.5-.3-.1-.2.1-.5.3-.5 2.9-.7 5.5-.4 7.5.8.2.1.3.3.1.5z" fill="white"/></svg>`,
  'Amazon Ads':`<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="5" fill="#ff9900"/><path d="M14.7 13.3c-.9.7-2.1 1-3.2 1-1.5 0-2.9-.6-3.9-1.5-.1-.1 0-.2.1-.1 1.1.6 2.4 1 3.8 1 .9 0 1.9-.2 2.8-.6.1-.1.3.1.4.2zm.6.8c-.1-.1-.8-.1-1.2 0-.1 0-.1.1 0 .1l.4.4c.1.1.2.1.3.1.3-.1.7-.4.7-.4.1-.1 0-.2-.2-.2zM7.5 8.1C6.8 9 6.5 10.3 6.5 11.5c0 3 2.4 5.5 5.5 5.5s5.5-2.5 5.5-5.5S15 6 12 6c-.8 0-1.6.2-2.3.5l-.2.1-.2-.2C9.1 6.2 9 6 9 5.9c-.1-.1-.3 0-.4.1-.2.5-.2.9-.1 1.5l.1.1c-.3.2-.9.5-1.1.5z" fill="#232f3e"/></svg>`,
};

const getPlatformSvg = (name) => {
  const svg = PLATFORM_SVG[name];
  if (!svg) return null;
  const nonce = 'cc' + (++_svgNonce);
  return svg
    .replace(/id="([a-zA-Z][\w-]*)"/g, (_, id) => `id="${id}_${nonce}"`)
    .replace(/url\(#([a-zA-Z][\w-]*)\)/g, (_, id) => `url(#${id}_${nonce})`);
};

// ── Constants ─────────────────────────────────────────────
const MONTHS_LONG = ['January','February','March','April','May','June','July','August','September','October','November','December'];

const STATUS_COLORS = {
  'Draft':            'var(--text3)',
  'Pending Internal': '#e87830',
  'Pending Client':   '#6c58f0',
  'Approved':         '#1db87a',
  'Rejected':         '#e84545',
};
const STATUS_BORDER = {
  'Draft':            'var(--border2)',
  'Pending Internal': '#e87830',
  'Pending Client':   '#6c58f0',
  'Approved':         '#1db87a',
  'Rejected':         '#e84545',
};
const STATUS_ICONS = {
  'Draft':            '📝',
  'Pending Internal': '🔒',
  'Pending Client':   '👔',
  'Approved':         '✅',
  'Rejected':         '❌',
};

const clientName = (c) => (c && typeof c === 'object') ? (c.name || '') : (c || '');

// ── Stage Date Banner (outside component — pure function) ─
function StageDateBanner({ schedulingDate, eventDate, tab, sc, wo }) {
  // Check if WO's campaign type has a Scheduling phase
  const hasSchedulingPhase = (() => {
    const phases = wo?.campaign_type?.phases || wo?.campaignType?.phases || [];
    const arr = Array.isArray(phases) ? phases : (typeof phases === 'string' ? JSON.parse(phases) : []);
    return arr.some(p => {
      const name = (p.name || '').toLowerCase();
      const linked = (p.linked_page_id || p.linkedPageId || '').toLowerCase();
      return name.includes('sched') || linked.includes('sched');
    });
  })();
  // ── Approved tab: show client approval date ───────────────────────────────
  if (tab === 'approved') {
    const versions = sc?.versions || [];
    // Try finding Client Approved version first
    const approvedVer = [...versions].reverse().find(v =>
      ['Client Approved','Approved','approved_client'].includes(v.action)
    );
    const approvedAt = approvedVer?.at
      ? approvedVer.at
      : sc?.client_approved_at || sc?.internal_approved_at || sc?.updated_at;
    const approvedBy = approvedVer?.by || sc?.client_approved_by || sc?.internal_approved_by || '';
    const d = approvedAt ? new Date(approvedAt) : null;
    const fmt = d => `${d.toLocaleDateString('en-IN',{weekday:'short',day:'2-digit',month:'short',year:'numeric'})} · ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')} ${d.getHours()>=12?'PM':'AM'}`;
    return (
      <div style={{margin:'0 0 12px',padding:'8px 14px',background:'rgba(34,196,122,0.05)',borderLeft:'3px solid #22c47a',borderRadius:6,display:'flex',alignItems:'center',gap:10}}>
        <div style={{flex:1}}>
          <div style={{fontSize:'0.65rem',fontWeight:600,color:'#22c47a',textTransform:'uppercase',letterSpacing:'0.4px',marginBottom:1}}>Client Approved</div>
          {d ? (
            <div style={{fontSize:'0.82rem',fontWeight:600,color:'var(--text)'}}>
              {fmt(d)}
              {approvedBy && <span style={{fontSize:'0.72rem',fontWeight:400,color:'var(--text3)',marginLeft:8}}>by {approvedBy}</span>}
            </div>
          ) : (
            <div style={{fontSize:'0.76rem',color:'var(--text3)',fontStyle:'italic'}}>Approval date not recorded</div>
          )}
        </div>
        <span style={{fontSize:'0.7rem',fontWeight:600,color:'#22c47a'}}>
          {hasSchedulingPhase ? '✓ Ready for Scheduling' : '✓ Approved'}
        </span>
      </div>
    );
  }
  if (!schedulingDate && !eventDate) return null;
  const today = new Date(); today.setHours(0,0,0,0);
  const tD = eventDate      ? new Date(eventDate+'T00:00:00')      : null;
  const sD = schedulingDate ? new Date(schedulingDate+'T00:00:00') : null;

  const fmt = d => d ? d.toLocaleDateString('en-IN', { weekday:'short', day:'2-digit', month:'short', year:'numeric' }) : '—';

  let diffDays = tD ? Math.round((tD - today) / 86400000) : null;
  let startDiff = sD ? Math.round((sD - today) / 86400000) : null;

  let urgencyLabel = diffDays !== null ? (
    diffDays < 0  ? `⚠ Overdue by ${Math.abs(diffDays)}d` :
    diffDays === 0 ? '🔥 Due Today' :
    diffDays === 1 ? '⚡ Due Tomorrow' :
    `${diffDays} days to event`
  ) : null;

  // Pill shows days to START
  let pillLabel = startDiff !== null ? (
    startDiff < 0  ? `Started ${Math.abs(startDiff)}d ago` :
    startDiff === 0 ? 'Starts Today' :
    startDiff === 1 ? 'Starts Tomorrow' :
    `Starts in ${startDiff} days`
  ) : urgencyLabel;

  // Color theme based on urgency
  let borderColor = '#3b7ef0';
  let labelColor  = '#3b7ef0';
  let pillBg      = 'rgba(59,126,240,0.08)';
  let pillTextColor = '#3b7ef0';
  if (diffDays !== null && diffDays < 0)    { borderColor='#ef4444'; labelColor='#ef4444'; pillBg='rgba(239,68,68,0.08)'; pillTextColor='#ef4444'; }
  else if (diffDays === 0)                   { borderColor='#f97316'; labelColor='#f97316'; pillBg='rgba(249,115,22,0.08)'; pillTextColor='#f97316'; }
  else if (diffDays !== null && diffDays<=3) { borderColor='#f59e0b'; labelColor='#f59e0b'; pillBg='rgba(245,158,11,0.08)'; pillTextColor='#f59e0b'; }

  return (
    <div style={{
      margin:'0 0 12px',
      padding:'10px 16px',
      background:'var(--bg3)',
      borderRadius:8,
      borderLeft:`3px solid ${borderColor}`,
      display:'flex',alignItems:'center',
      gap:16, overflow:'hidden',
    }}>
      {/* Start date */}
      <div style={{flexShrink:0}}>
        <div style={{fontSize:'0.62rem',fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.4px',marginBottom:2}}>Start Date</div>
        <div style={{fontSize:'0.88rem',fontWeight:600,color:'var(--text)',whiteSpace:'nowrap'}}>{fmt(sD)}</div>
      </div>

      {/* Arrow */}
      <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="var(--text3)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}>
        <path d="M3 8h10M9 4l4 4-4 4"/>
      </svg>

      {/* Deadline */}
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:'0.62rem',fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.4px',marginBottom:2}}>Deadline</div>
        <div style={{fontSize:'0.88rem',fontWeight:600,color:'var(--text)',whiteSpace:'nowrap'}}>{fmt(tD)}</div>
      </div>

      {/* Days pill */}
      {pillLabel && (
        <span style={{
          padding:'4px 10px',
          background:pillBg,
          borderRadius:4,
          fontSize:'0.72rem',fontWeight:600,color:pillTextColor,
          whiteSpace:'nowrap',flexShrink:0,
        }}>
          {pillLabel}
        </span>
      )}
    </div>
  );
}


// ── Sketch Canvas Modal (Fabric.js powered) ─────────────────────────────────
function SketchModal({ onSave, onClose }) {
  const LANG_FONTS = {
    'Latin / English': ['Arial','Georgia','Times New Roman','Courier New','Verdana','Trebuchet MS','Comic Sans MS','Impact','Roboto','Open Sans'],
    'Hindi / Devanagari': ['Noto Sans','Noto Serif','Poppins','Hind','Mukta','Tiro Devanagari Hindi'],
    'Malayalam': ['Noto Sans','Noto Serif','Noto Sans Malayalam','Manjari','Chilanka','Gayathri'],
    'Tamil': ['Noto Sans','Noto Serif','Noto Sans Tamil','Catamaran','Arima Madurai'],
    'Telugu': ['Noto Sans','Noto Serif','Noto Sans Telugu','Ramabhadra','Mandali'],
    'Kannada': ['Noto Sans','Noto Serif','Noto Sans Kannada','Hubballi'],
    'Arabic / Urdu': ['Noto Sans Arabic','Amiri','Scheherazade New','Cairo','Tajawal'],
    'Chinese Simplified': ['Noto Sans SC','Noto Serif SC','ZCOOL XiaoWei','Ma Shan Zheng'],
    'Chinese Traditional': ['Noto Sans TC','Noto Serif TC'],
    'Japanese': ['Noto Sans JP','Noto Serif JP','Kosugi Maru','M PLUS Rounded 1c'],
    'Korean': ['Noto Sans KR','Noto Serif KR','Black Han Sans','Nanum Gothic'],
    'Bengali': ['Noto Sans Bengali','Noto Serif Bengali','Hind Siliguri','Baloo Da 2'],
    'Gujarati': ['Noto Sans Gujarati','Noto Serif Gujarati','Hind Vadodara'],
    'Punjabi / Gurmukhi': ['Noto Sans Gurmukhi','Noto Serif Gurmukhi'],
    'Greek': ['Noto Sans','Noto Serif','GFS Didot','Alegreya'],
    'Cyrillic / Russian': ['Noto Sans','Noto Serif','Roboto','Open Sans','PT Sans'],
    'Thai': ['Noto Sans Thai','Noto Serif Thai','Sarabun','Kanit'],
  };

  const canvasRef    = React.useRef(null);
  const fabricRef    = React.useRef(null);
  const fileInputRef = React.useRef(null);
  const [tool,       setTool]       = React.useState('draw');
  const [color,      setColor]      = React.useState('#1a1a2e');
  const [brushSize,  setBrushSize]  = React.useState(3);
  const [font,       setFont]       = React.useState('Arial');
  const [fontSize,   setFontSize]   = React.useState(20);
  const [shape,      setShape]      = React.useState('rect');
  const [loaded,     setLoaded]     = React.useState(false);
  const [lang,       setLang]       = React.useState('Latin / English');
  const [textInput,  setTextInput]  = React.useState('');
  const [showTextBar,setShowTextBar]= React.useState(false);
  const [listening,  setListening]  = React.useState(false);
  const srRef = React.useRef(null);
  const FONTS = LANG_FONTS[lang] || LANG_FONTS['Latin / English'];

  // Load Google Fonts for current language
  React.useEffect(() => {
    const fonts = LANG_FONTS[lang] || [];
    const query = fonts.map(f => `family=${f.replace(/ /g,'+')}`).join('&');
    const id = 'sketch-lang-fonts';
    let link = document.getElementById(id);
    if (!link) { link = document.createElement('link'); link.id=id; link.rel='stylesheet'; document.head.appendChild(link); }
    link.href = `https://fonts.googleapis.com/css2?${query}&display=swap`;
  }, [lang]);

  // Load Fabric.js
  React.useEffect(() => {
    if (window.fabric) { initCanvas(); return; }
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/fabric.js/5.3.1/fabric.min.js';
    script.onload = () => { setLoaded(true); };
    document.head.appendChild(script);
    return () => {};
  }, []);

  React.useEffect(() => { if (loaded) initCanvas(); }, [loaded]);

  const initCanvas = () => {
    if (fabricRef.current) return;
    const fc = new window.fabric.Canvas(canvasRef.current, {
      width: 1100, height: 620,
      backgroundColor: '#ffffff',
      isDrawingMode: true,
    });
    fc.freeDrawingBrush.color = '#1a1a2e';
    fc.freeDrawingBrush.width = 3;
    fabricRef.current = fc;
    // Track last selected object so Delete button works after clicking away
    fc.on('selection:created', e => { lastSelected.current = e.selected?.[0] || null; });
    fc.on('selection:updated', e => { lastSelected.current = e.selected?.[0] || null; });
    fc.on('selection:cleared', ()  => { lastSelected.current = null; });
    // Save snapshot after every change
    fc.on('object:added',    () => saveSnapshotRef.current?.());
    fc.on('object:removed',  () => saveSnapshotRef.current?.());
    fc.on('object:modified', () => saveSnapshotRef.current?.());
    fc.on('path:created',    () => saveSnapshotRef.current?.());
    // Save initial blank state
    setTimeout(() => saveSnapshotRef.current?.(), 100);
    // Paste from clipboard
    const onPaste = async (e) => {
      const items = (e.clipboardData || window.clipboardData).items;
      for (const item of items) {
        if (item.type.startsWith('image/')) {
          const blob = item.getAsFile();
          const url  = URL.createObjectURL(blob);
          window.fabric.Image.fromURL(url, img => {
            img.scaleToWidth(Math.min(400, fc.width * 0.6));
            fc.add(img); fc.setActiveObject(img); fc.renderAll();
          });
        }
      }
    };
    window.addEventListener('paste', onPaste);
    fc._pasteCleanup = () => window.removeEventListener('paste', onPaste);
  };

  React.useEffect(() => {
    const handler = (e) => {
      if (e.key === 'Escape') { onClose(); return; }
      // Ctrl+Z = Undo
      if ((e.ctrlKey||e.metaKey) && e.key==='z' && !e.shiftKey) { e.preventDefault(); undo(); return; }
      // Ctrl+Y or Ctrl+Shift+Z = Redo
      if ((e.ctrlKey||e.metaKey) && (e.key==='y'||(e.key==='z'&&e.shiftKey))) { e.preventDefault(); redo(); return; }
      // Delete/Backspace removes selected object — but only if not typing in text input
      if ((e.key === 'Delete' || e.key === 'Backspace') && document.activeElement?.tagName !== 'INPUT') {
        const fc = fabricRef.current; if (!fc) return;
        const obj = fc.getActiveObject();
        if (!obj) return;
        // Don't delete if editing text on canvas
        if (obj.isEditing) return;
        if (obj.type === 'activeSelection') obj.getObjects().forEach(o=>fc.remove(o));
        else fc.remove(obj);
        fc.discardActiveObject(); fc.renderAll();
        e.preventDefault();
      }
    };
    document.addEventListener('keydown', handler);
    return () => {
      document.removeEventListener('keydown', handler);
      if (fabricRef.current?._pasteCleanup) fabricRef.current._pasteCleanup();
      if (fabricRef.current) { fabricRef.current.dispose(); fabricRef.current = null; }
    };
  }, [onClose]);

  const applyTool = (t) => {
    const fc = fabricRef.current; if (!fc) return;
    setTool(t);
    fc.isDrawingMode = (t === 'draw' || t === 'eraser');
    fc.selection     = (t === 'select');
    if (t === 'draw') {
      fc.freeDrawingBrush = new window.fabric.PencilBrush(fc);
      fc.freeDrawingBrush.color = color;
      fc.freeDrawingBrush.width = brushSize;
    }
    if (t === 'eraser') {
      fc.freeDrawingBrush = new window.fabric.PencilBrush(fc);
      fc.freeDrawingBrush.color = '#ffffff';
      fc.freeDrawingBrush.width = brushSize * 5;
    }
  };

  const applyColor = (c) => {
    setColor(c);
    const fc = fabricRef.current; if (!fc) return;
    if (tool === 'draw') fc.freeDrawingBrush.color = c;
    const obj = fc.getActiveObject();
    if (obj) {
      if (obj.type === 'i-text' || obj.type === 'text') obj.set('fill', c);
      else obj.set('stroke', c);
      fc.renderAll();
    }
  };

  const addText = (customText) => {
    const fc = fabricRef.current; if (!fc) return;
    const txt = customText || textInput || 'Type here...';
    const t = new window.fabric.IText(txt, {
      left: 100 + Math.random()*200, top: 100 + Math.random()*100,
      fontFamily: font, fontSize, fill: color,
      editable: true, selectable: true,
    });
    fc.add(t); fc.setActiveObject(t); fc.isDrawingMode = false;
    if (!customText && !textInput) { t.enterEditing(); t.selectAll(); }
    fc.renderAll();
    setTool('select');
    if (textInput) setTextInput('');
  };

  const addShape = (sh) => {
    const fc = fabricRef.current; if (!fc) return;
    let obj;
    if (sh === 'rect')    obj = new window.fabric.Rect({ left:150,top:150,width:160,height:100,fill:'transparent',stroke:color,strokeWidth:2,selectable:true });
    if (sh === 'circle')  obj = new window.fabric.Circle({ left:150,top:150,radius:60,fill:'transparent',stroke:color,strokeWidth:2,selectable:true });
    if (sh === 'triangle')obj = new window.fabric.Triangle({ left:150,top:100,width:120,height:110,fill:'transparent',stroke:color,strokeWidth:2,selectable:true });
    if (sh === 'line')    obj = new window.fabric.Line([50,150,300,150], { stroke:color,strokeWidth:2,selectable:true });
    if (sh === 'arrow') {
      obj = new window.fabric.Path('M 0 0 L 100 0 L 80 -10 M 100 0 L 80 10', { left:150,top:180,stroke:color,strokeWidth:2,fill:'transparent',selectable:true });
    }
    if (obj) { fc.add(obj); fc.setActiveObject(obj); fc.isDrawingMode=false; fc.renderAll(); setTool('select'); }
  };

  const addEmoji = (emoji) => {
    const fc = fabricRef.current; if (!fc) return;
    const t = new window.fabric.IText(emoji, { left:200,top:200,fontSize:40,selectable:true,editable:false });
    fc.add(t); fc.setActiveObject(t); fc.isDrawingMode=false; fc.renderAll(); setTool('select');
  };

  const insertImage = (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    const reader = new FileReader();
    reader.onload = ev => {
      const fc = fabricRef.current; if (!fc) return;
      window.fabric.Image.fromURL(ev.target.result, img => {
        img.scaleToWidth(Math.min(400, fc.width * 0.5));
        img.set({ left:80, top:80 });
        fc.add(img); fc.setActiveObject(img); fc.isDrawingMode=false; fc.renderAll();
        setTool('select');
      });
    };
    reader.readAsDataURL(file);
    e.target.value = '';
  };

  const lastSelected = React.useRef(null);

  const deleteSelected = () => {
    const fc = fabricRef.current; if (!fc) return;
    // Try active object first, fall back to last selected
    const obj = fc.getActiveObject() || lastSelected.current;
    if (!obj) { alert('Select an object first'); return; }
    if (obj.type === 'activeSelection') obj.getObjects().forEach(o=>fc.remove(o));
    else fc.remove(obj);
    fc.discardActiveObject(); fc.renderAll();
    lastSelected.current = null;
  };

  const historyRef  = React.useRef([]);
  const historyIdx  = React.useRef(-1);
  const skipHistory = React.useRef(false);
  const saveSnapshotRef = React.useRef(null);
  const [canUndo, setCanUndo] = React.useState(false);
  const [canRedo, setCanRedo] = React.useState(false);

  const saveSnapshot = React.useCallback(() => {
    const fc = fabricRef.current; if (!fc || skipHistory.current) return;
    const json = fc.toJSON();
    historyRef.current = historyRef.current.slice(0, historyIdx.current + 1);
    historyRef.current.push(json);
    historyIdx.current = historyRef.current.length - 1;
    setCanUndo(historyIdx.current > 0);
    setCanRedo(false);
  }, []);

  // Keep ref in sync so initCanvas can call it before React renders
  React.useEffect(() => { saveSnapshotRef.current = saveSnapshot; }, [saveSnapshot]);

  const undo = () => {
    const fc = fabricRef.current; if (!fc) return;
    if (historyIdx.current <= 0) return;
    historyIdx.current--;
    const snap = historyRef.current[historyIdx.current];
    skipHistory.current = true;
    fc.loadFromJSON(snap, () => {
      fc.renderAll();
      skipHistory.current = false;
      setCanUndo(historyIdx.current > 0);
      setCanRedo(historyIdx.current < historyRef.current.length - 1);
    });
  };

  const redo = () => {
    const fc = fabricRef.current; if (!fc) return;
    if (historyIdx.current >= historyRef.current.length - 1) return;
    historyIdx.current++;
    const snap = historyRef.current[historyIdx.current];
    skipHistory.current = true;
    fc.loadFromJSON(snap, () => {
      fc.renderAll();
      skipHistory.current = false;
      setCanUndo(historyIdx.current > 0);
      setCanRedo(historyIdx.current < historyRef.current.length - 1);
    });
  };

  const clear = () => {
    const fc = fabricRef.current; if (!fc) return;
    if (!window.confirm('Clear the entire canvas?')) return;
    fc.clear(); fc.backgroundColor = '#ffffff'; fc.renderAll();
  };

  const handleSave = () => {
    const fc = fabricRef.current; if (!fc) return;
    const dataUrl = fc.toDataURL({ format:'png', quality:0.92 });
    onSave(dataUrl); onClose();
  };

  const COLORS = ['#1a1a2e','#ef4444','#3b7ef0','#22c47a','#f59e0b','#8b5cf6','#ec4899','#14b8a6','#f97316','#64748b','#000000','#ffffff'];
  const EMOJIS  = ['😊','👍','❤️','🎉','⭐','🔥','✅','❌','📌','💡','🎯','📣','⚠️','💬','🖼️','📷'];
  const SHAPES  = [
    {id:'rect',label:'▭'},
    {id:'circle',label:'○'},
    {id:'triangle',label:'△'},
    {id:'line',label:'—'},
    {id:'arrow',label:'→'},
  ];
  const TOOLS = [
    {id:'draw',   label:'✏️', title:'Free Draw'},
    {id:'select', label:'⬚',  title:'Select & Move'},
    {id:'eraser', label:'⊘',  title:'Eraser'},
  ];

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.75)',zIndex:99999,display:'flex',alignItems:'center',justifyContent:'center',padding:12}}
      onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
      <div style={{background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:14,display:'flex',flexDirection:'column',width:'min(1200px,98vw)',maxHeight:'96vh',boxShadow:'0 24px 64px rgba(0,0,0,0.4)'}}>

        {/* ── Toolbar ── */}
        <div style={{padding:'10px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:8,flexWrap:'wrap',flexShrink:0,background:'var(--bg3)',borderRadius:'14px 14px 0 0'}}>

          {/* Title */}
          <span style={{fontWeight:700,fontSize:'0.88rem',color:'var(--text)',marginRight:4}}>🎨 Sketch</span>

          {/* Tools */}
          <div style={{display:'flex',gap:3,padding:'3px',background:'var(--bg2)',borderRadius:8,border:'1px solid var(--border)'}}>
            {TOOLS.map(t=>(
              <button key={t.id} onClick={()=>applyTool(t.id)} title={t.title}
                style={{width:30,height:28,borderRadius:6,border:'none',background:tool===t.id?'var(--accent)':'transparent',cursor:'pointer',fontSize:'0.88rem',color:tool===t.id?'#fff':'var(--text2)'}}>
                {t.label}
              </button>
            ))}
          </div>

          {/* Text */}
          <button onClick={()=>setShowTextBar(v=>!v)} title="Add Text"
            style={{padding:'4px 10px',fontSize:'0.75rem',fontWeight:700,borderRadius:6,border:`1px solid ${showTextBar?'var(--accent)':'var(--border)'}`,background:showTextBar?'var(--accent)':'var(--bg2)',color:showTextBar?'#fff':'var(--text2)',cursor:'pointer'}}>
            T Text
          </button>

          {/* Shapes */}
          <div style={{display:'flex',gap:3}}>
            {SHAPES.map(s=>(
              <button key={s.id} onClick={()=>addShape(s.id)} title={s.id}
                style={{width:28,height:28,borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',cursor:'pointer',fontSize:'1rem',color:color,display:'flex',alignItems:'center',justifyContent:'center'}}>
                {s.label}
              </button>
            ))}
          </div>

          {/* Divider */}
          <div style={{width:1,height:24,background:'var(--border)',flexShrink:0}}/>

          {/* Language selector */}
          <select value={lang} onChange={e=>{setLang(e.target.value); setFont(LANG_FONTS[e.target.value]?.[0]||'Arial');}}
            style={{padding:'3px 6px',fontSize:'0.72rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)',maxWidth:140}}
            title="Select language for font options">
            {Object.keys(LANG_FONTS).map(l=><option key={l}>{l}</option>)}
          </select>

          {/* Font — filtered by language */}
          <select value={font} onChange={e=>{setFont(e.target.value);const fc=fabricRef.current;const obj=fc?.getActiveObject();if(obj&&(obj.type==='i-text'||obj.type==='text')){obj.set('fontFamily',e.target.value);fc.renderAll();}}}
            style={{padding:'3px 6px',fontSize:'0.72rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)',maxWidth:140}}>
            {FONTS.map(f=><option key={f} style={{fontFamily:f}}>{f}</option>)}
          </select>

          {/* Font size */}
          <input type="number" value={fontSize} min={8} max={120}
            onChange={e=>{const s=parseInt(e.target.value)||16;setFontSize(s);const fc=fabricRef.current;const obj=fc?.getActiveObject();if(obj&&(obj.type==='i-text'||obj.type==='text')){obj.set('fontSize',s);fc.renderAll();}}}
            style={{width:52,padding:'3px 6px',fontSize:'0.72rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)'}} />

          {/* Brush size */}
          <input type="range" min={1} max={30} value={brushSize}
            onChange={e=>{const s=parseInt(e.target.value);setBrushSize(s);const fc=fabricRef.current;if(fc?.isDrawingMode)fc.freeDrawingBrush.width=tool==='eraser'?s*5:s;}}
            style={{width:70,accentColor:'var(--accent)'}} title="Brush size"/>

          {/* Colors */}
          <div style={{display:'flex',gap:3,flexWrap:'wrap',maxWidth:160}}>
            {COLORS.map(c=>(
              <button key={c} onClick={()=>applyColor(c)}
                style={{width:20,height:20,borderRadius:4,background:c,border:`2px solid ${color===c?'var(--accent)':c==='#ffffff'?'var(--border2)':'transparent'}`,cursor:'pointer',flexShrink:0}}/>
            ))}
          </div>

          {/* Custom color */}
          <input type="color" value={color} onChange={e=>applyColor(e.target.value)}
            style={{width:28,height:28,borderRadius:5,border:'1px solid var(--border)',cursor:'pointer',padding:2,background:'none'}} title="Custom color"/>

          {/* Divider */}
          <div style={{width:1,height:24,background:'var(--border)',flexShrink:0}}/>

          {/* Emojis */}
          <div style={{display:'flex',gap:2,flexWrap:'wrap',maxWidth:180}}>
            {EMOJIS.map(e=>(
              <button key={e} onClick={()=>addEmoji(e)} title={`Add ${e}`}
                style={{width:24,height:24,border:'none',background:'transparent',cursor:'pointer',fontSize:'0.85rem',padding:0,display:'flex',alignItems:'center',justifyContent:'center'}}>
                {e}
              </button>
            ))}
          </div>

          {/* Divider */}
          <div style={{width:1,height:24,background:'var(--border)',flexShrink:0}}/>

          {/* Insert image */}
          <button onClick={()=>fileInputRef.current?.click()} title="Insert Image"
            style={{padding:'4px 10px',fontSize:'0.72rem',fontWeight:600,borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text2)',cursor:'pointer'}}>
            🖼 Image
          </button>
          <input ref={fileInputRef} type="file" accept="image/*" style={{display:'none'}} onChange={insertImage}/>

          {/* Actions */}
          <div style={{marginLeft:'auto',display:'flex',gap:6,alignItems:'center'}}>
            <button onClick={deleteSelected} title="Delete selected (Del)"
              style={{padding:'4px 8px',fontSize:'0.72rem',background:'rgba(239,68,68,0.08)',border:'1px solid rgba(239,68,68,0.25)',borderRadius:6,cursor:'pointer',color:'var(--red)'}}>
              🗑 Del
            </button>
            <button onClick={undo} disabled={!canUndo} title="Undo (Ctrl+Z)"
              style={{padding:'4px 8px',fontSize:'0.72rem',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:6,cursor:canUndo?'pointer':'not-allowed',color:canUndo?'var(--text2)':'var(--text3)',opacity:canUndo?1:0.5}}>
              ↩ Undo
            </button>
            <button onClick={redo} disabled={!canRedo} title="Redo (Ctrl+Y)"
              style={{padding:'4px 8px',fontSize:'0.72rem',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:6,cursor:canRedo?'pointer':'not-allowed',color:canRedo?'var(--text2)':'var(--text3)',opacity:canRedo?1:0.5}}>
              ↪ Redo
            </button>
            <button onClick={clear}
              style={{padding:'4px 8px',fontSize:'0.72rem',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:6,cursor:'pointer',color:'var(--text2)'}}>
              🗑 Clear
            </button>
            <button onClick={onClose}
              style={{padding:'4px 10px',fontSize:'0.72rem',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:6,cursor:'pointer',color:'var(--text2)'}}>
              Cancel
            </button>
            <button onClick={handleSave}
              style={{padding:'5px 14px',fontSize:'0.78rem',fontWeight:700,background:'linear-gradient(135deg,#4f7cf7,#7c5cf6)',color:'#fff',border:'none',borderRadius:7,cursor:'pointer'}}>
              ✓ Save Sketch
            </button>
          </div>
        </div>

        {/* Tip bar */}
        <div style={{padding:'5px 14px',background:'rgba(59,126,240,0.04)',borderBottom:'1px solid var(--border)',fontSize:'0.68rem',color:'var(--text3)',flexShrink:0,display:'flex',gap:16,flexWrap:'wrap'}}>
          <span>📋 <b>Paste</b> image from clipboard (Ctrl+V)</span>
          <span>⬚ <b>Select</b> tool to move/resize objects</span>
          <span>🖼 <b>Insert Image</b> from file</span>
          <span>🗑 <b>Del</b> to remove selected</span>
          <span>Double-click text to edit</span>
          <span>🌐 <b>Any language</b> — type in Hindi, Arabic, Malayalam, Chinese etc. after adding text. Use <b>Noto Sans</b> font for best multilingual support.</span>
        </div>

        {/* Text input bar — full multilingual support via browser IME + Speech */}
        {showTextBar && (
          <div style={{padding:'8px 14px',borderBottom:'1px solid var(--border)',background:'var(--bg2)',display:'flex',gap:8,alignItems:'center',flexShrink:0}}>
            <span style={{fontSize:'0.72rem',fontWeight:700,color:'var(--text2)',whiteSpace:'nowrap'}}>✍️ Type text:</span>
            <input
              value={textInput}
              onChange={e=>setTextInput(e.target.value)}
              onKeyDown={e=>{ if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();addText();}}}
              placeholder={`Type or speak in ${lang}... then click Add or press Enter`}
              style={{flex:1,padding:'6px 10px',fontSize:'0.9rem',fontFamily:font,borderRadius:6,border:'1px solid var(--border)',background:'var(--bg3)',color:'var(--text)',outline:'none'}}
              autoFocus
              lang={lang.toLowerCase().includes('arabic')||lang.toLowerCase().includes('urdu')?'ar':
                    lang.toLowerCase().includes('hindi')?'hi':
                    lang.toLowerCase().includes('malayalam')?'ml':
                    lang.toLowerCase().includes('tamil')?'ta':
                    lang.toLowerCase().includes('telugu')?'te':
                    lang.toLowerCase().includes('kannada')?'kn':
                    lang.toLowerCase().includes('bengali')?'bn':
                    lang.toLowerCase().includes('gujarati')?'gu':
                    lang.toLowerCase().includes('chinese simplified')?'zh-CN':
                    lang.toLowerCase().includes('chinese traditional')?'zh-TW':
                    lang.toLowerCase().includes('japanese')?'ja':
                    lang.toLowerCase().includes('korean')?'ko':
                    lang.toLowerCase().includes('thai')?'th':
                    lang.toLowerCase().includes('greek')?'el':
                    lang.toLowerCase().includes('russian')?'ru':'en'}
              dir={lang.toLowerCase().includes('arabic')||lang.toLowerCase().includes('urdu')?'rtl':'ltr'}
            />
            {/* Speech to text mic button */}
            {(()=>{
              const langCode =
                lang.toLowerCase().includes('arabic')||lang.toLowerCase().includes('urdu') ? 'ar-AE' :
                lang.toLowerCase().includes('hindi')    ? 'hi-IN' :
                lang.toLowerCase().includes('malayalam')? 'ml-IN' :
                lang.toLowerCase().includes('tamil')    ? 'ta-IN' :
                lang.toLowerCase().includes('telugu')   ? 'te-IN' :
                lang.toLowerCase().includes('kannada')  ? 'kn-IN' :
                lang.toLowerCase().includes('bengali')  ? 'bn-IN' :
                lang.toLowerCase().includes('gujarati') ? 'gu-IN' :
                lang.toLowerCase().includes('punjabi')  ? 'pa-IN' :
                lang.toLowerCase().includes('chinese simplified') ? 'zh-CN' :
                lang.toLowerCase().includes('chinese traditional') ? 'zh-TW' :
                lang.toLowerCase().includes('japanese') ? 'ja-JP' :
                lang.toLowerCase().includes('korean')   ? 'ko-KR' :
                lang.toLowerCase().includes('thai')     ? 'th-TH' :
                lang.toLowerCase().includes('greek')    ? 'el-GR' :
                lang.toLowerCase().includes('russian')  ? 'ru-RU' : 'en-IN';

              const startListening = () => {
                const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
                if (!SR) { alert('Speech recognition not supported. Please use Chrome.'); return; }
                const sr = new SR();
                sr.lang = langCode;
                sr.continuous = true;
                sr.interimResults = true;
                srRef.current = sr;
                sr.onresult = (e) => {
                  const transcript = Array.from(e.results).map(r=>r[0].transcript).join('');
                  setTextInput(transcript);
                };
                sr.onerror = () => setListening(false);
                sr.onend   = () => setListening(false);
                sr.start();
                setListening(true);
              };

              const stopListening = () => { srRef.current?.stop(); setListening(false); };

              return (
                <button onClick={listening ? stopListening : startListening}
                  title={listening ? `Listening in ${lang}... click to stop` : `Speak in ${lang}`}
                  style={{width:36,height:36,borderRadius:'50%',border:'none',cursor:'pointer',
                    background:listening?'#ef4444':'rgba(59,126,240,0.1)',
                    display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,
                    boxShadow:listening?'0 0 0 4px rgba(239,68,68,0.25)':'none',transition:'all 0.2s'}}>
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none"
                    stroke={listening?'#fff':'#3b7ef0'} strokeWidth="2" strokeLinecap="round">
                    <rect x="9" y="2" width="6" height="11" rx="3"/>
                    <path d="M5 10a7 7 0 0014 0"/>
                    <line x1="12" y1="17" x2="12" y2="21"/>
                    <line x1="8"  y1="21" x2="16" y2="21"/>
                  </svg>
                </button>
              );
            })()}
            <button onClick={()=>addText()}
              style={{padding:'6px 14px',fontSize:'0.78rem',fontWeight:700,background:'var(--accent)',color:'#fff',border:'none',borderRadius:6,cursor:'pointer',whiteSpace:'nowrap'}}>
              + Add to Canvas
            </button>
            <span style={{fontSize:'0.68rem',color:'var(--text3)',whiteSpace:'nowrap'}}>Enter ↵ to add</span>
          </div>
        )}

        {/* Canvas */}
        <div style={{flex:1,overflow:'auto',padding:12,background:'#e8eaf0',display:'flex',alignItems:'flex-start',justifyContent:'center'}}>
          {!window.fabric && !loaded && (
            <div style={{padding:40,color:'var(--text3)',textAlign:'center'}}>
              <div style={{fontSize:'1.5rem',marginBottom:8}}>⏳</div>
              Loading sketch tools...
            </div>
          )}
          <canvas ref={canvasRef} style={{borderRadius:6,boxShadow:'0 4px 20px rgba(0,0,0,0.15)',display:'block'}} />
        </div>
      </div>
    </div>
  );
}

// ── References Block (outside component) ─────────────────
function ReferencesBlock({ woId, refs, canEdit, onAdd, onDelete }) {
  const [linkUrl,   setLinkUrl]   = useState('');
  const [linkLabel, setLinkLabel] = useState('');
  const [showLink,   setShowLink]   = useState(false);
  const [showSketch, setShowSketch] = useState(false);
  const fileRef = useRef();

  const handleFile = (e) => {
    const files = Array.from(e.target.files);
    files.forEach(file => {
      const isImage = file.type.startsWith('image/');
      const reader = new FileReader();
      reader.onload = ev => {
        if (isImage && file.size > 200000) {
          const img = new Image();
          img.onload = () => {
            const MAX=800; let w=img.width, h=img.height;
            if(w>MAX){h=Math.round(h*MAX/w);w=MAX;}
            const canvas=document.createElement('canvas'); canvas.width=w; canvas.height=h;
            canvas.getContext('2d').drawImage(img,0,0,w,h);
            onAdd(woId,{type:'image',name:file.name,data:canvas.toDataURL('image/jpeg',0.72)});
          };
          img.src=ev.target.result;
        } else {
          onAdd(woId,{type:isImage?'image':'file',name:file.name,data:ev.target.result});
        }
      };
      reader.readAsDataURL(file);
    });
    e.target.value='';
  };

  const addLink = () => {
    if(!linkUrl.trim()){alert('Enter a URL');return;}
    onAdd(woId,{type:'link',url:linkUrl.trim(),label:linkLabel.trim()||linkUrl.trim()});
    setLinkUrl(''); setLinkLabel(''); setShowLink(false);
  };

  return (
    <>
    <div style={{marginBottom:'12px',background:'var(--bg2)',border:'1.5px solid var(--border2)',borderRadius:'10px',overflow:'hidden'}}>
      {/* Header */}
      <div style={{display:'flex',alignItems:'center',gap:'8px',padding:'8px 14px',background:'var(--bg3)',borderBottom:'1px solid var(--border)',flexWrap:'wrap'}}>
        <div style={{display:'flex',alignItems:'center',gap:6}}>
          <div style={{width:28,height:28,borderRadius:7,background:'rgba(59,126,240,0.1)',border:'1px solid rgba(59,126,240,0.2)',display:'flex',alignItems:'center',justifyContent:'center'}}>
            <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="#3b7ef0" strokeWidth="1.6" strokeLinecap="round"><path d="M4 2h8a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V3a1 1 0 011-1z"/><line x1="5" y1="6" x2="11" y2="6"/><line x1="5" y1="9" x2="9" y2="9"/></svg>
          </div>
          <span style={{fontSize:'0.76rem',fontWeight:700,color:'var(--text)',letterSpacing:'0.2px'}}>References</span>
          <span style={{fontSize:'0.67rem',color:'var(--text3)',fontWeight:400}}>(Optional)</span>
        </div>
        {canEdit && (
          <div style={{display:'flex',gap:6,marginLeft:'auto'}}>
            <label style={{display:'inline-flex',alignItems:'center',gap:'5px',padding:'4px 10px',background:'var(--bg2)',border:'1px solid var(--border2)',borderRadius:'7px',fontSize:'0.72rem',fontWeight:600,color:'var(--text2)',cursor:'pointer',transition:'all 0.15s'}}
              onMouseOver={e=>{e.currentTarget.style.borderColor='var(--accent)';e.currentTarget.style.color='var(--accent)';}}
              onMouseOut={e=>{e.currentTarget.style.borderColor='var(--border2)';e.currentTarget.style.color='var(--text2)';}}>
              <svg viewBox="0 0 14 14" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M7 1v12M1 7h12"/></svg>
              Upload
              <input ref={fileRef} type="file" multiple accept="image/*,.pdf,.doc,.docx,.txt,.csv,.xlsx,.ppt,.pptx" style={{display:'none'}} onChange={handleFile} />
            </label>
            <button onClick={()=>setShowLink(v=>!v)}
              style={{padding:'4px 10px',background:'var(--bg2)',border:'1px solid var(--border2)',borderRadius:'7px',fontSize:'0.72rem',fontWeight:600,color:'var(--text2)',cursor:'pointer',transition:'all 0.15s',display:'flex',alignItems:'center',gap:5}}
              onMouseOver={e=>{e.currentTarget.style.borderColor='var(--accent)';e.currentTarget.style.color='var(--accent)';}}
              onMouseOut={e=>{e.currentTarget.style.borderColor='var(--border2)';e.currentTarget.style.color='var(--text2)';}}>
              <svg viewBox="0 0 14 14" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M5 9l4-4M8.5 3l1.5-1.5a2.1 2.1 0 013 3L11.5 6M5.5 8l-1.5 1.5a2.1 2.1 0 01-3-3L2.5 5"/></svg>
              Add Link
            </button>
            <button onClick={()=>setShowSketch(true)}
              style={{padding:'4px 10px',background:'var(--bg2)',border:'1px solid var(--border2)',borderRadius:'7px',fontSize:'0.72rem',fontWeight:600,color:'var(--text2)',cursor:'pointer',transition:'all 0.15s',display:'flex',alignItems:'center',gap:5}}
              onMouseOver={e=>{e.currentTarget.style.borderColor='#8b5cf6';e.currentTarget.style.color='#8b5cf6';}}
              onMouseOut={e=>{e.currentTarget.style.borderColor='var(--border2)';e.currentTarget.style.color='var(--text2)';}}>
              <svg viewBox="0 0 14 14" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M2 10l1.5-1.5L10 2l2 2-6.5 6.5L2 12z"/><line x1="8" y1="4" x2="10" y2="6"/></svg>
              Sketch
            </button>
          </div>
        )}
      </div>
      {/* Body */}
      <div style={{padding:'10px 14px'}}>
        {showLink && (
          <div style={{display:'flex',gap:'6px',marginBottom:'10px',flexWrap:'wrap'}}>
            <input className="form-input" style={{flex:1,minWidth:'140px',fontSize:'0.78rem',padding:'6px 10px'}} placeholder="https://..." value={linkUrl} onChange={e=>setLinkUrl(e.target.value)} />
            <input className="form-input" style={{flex:1,minWidth:'100px',fontSize:'0.78rem',padding:'6px 10px'}} placeholder="Label (optional)" value={linkLabel} onChange={e=>setLinkLabel(e.target.value)} />
            <button onClick={addLink} className="btn btn-primary" style={{fontSize:'0.72rem',padding:'5px 12px'}}>Add</button>
            <button onClick={()=>setShowLink(false)} className="btn btn-secondary" style={{fontSize:'0.72rem',padding:'5px 10px'}}>✕</button>
          </div>
        )}
        <div style={{display:'flex',flexWrap:'wrap',gap:'8px',alignItems:'flex-start',minHeight:36}}>
          {(!refs||!refs.length) ? (
            <span style={{fontSize:'0.74rem',color:'var(--text3)',fontStyle:'italic',paddingTop:4}}>
              {canEdit ? 'No references yet — upload images or add links above' : 'No references'}
            </span>
          ) : refs.map((r,i) => (
            r.type==='image' ? (
              <div key={i} style={{position:'relative',display:'inline-block'}}>
                <img src={r.data} alt={r.name}
                  style={{width:'64px',height:'64px',objectFit:'cover',borderRadius:'7px',border:'2px solid var(--border)',cursor:'zoom-in',transition:'transform 0.15s,box-shadow 0.15s'}}
                  onClick={()=>{
                    const overlay=document.createElement('div');
                    overlay.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,0.92);z-index:99999;display:flex;align-items:center;justify-content:center;cursor:zoom-out;';
                    const img=document.createElement('img');
                    img.src=r.data; img.alt=r.name;
                    img.style.cssText='max-width:92vw;max-height:88vh;border-radius:8px;object-fit:contain;box-shadow:0 8px 48px rgba(0,0,0,0.6);';
                    const close=()=>document.body.removeChild(overlay);
                    overlay.addEventListener('click',close);
                    const esc=e=>{if(e.key==='Escape'){close();document.removeEventListener('keydown',esc);}};
                    document.addEventListener('keydown',esc);
                    const label=document.createElement('div');
                    label.textContent=r.name;
                    label.style.cssText='position:absolute;bottom:20px;color:rgba(255,255,255,0.6);font-size:12px;';
                    overlay.appendChild(img); overlay.appendChild(label);
                    document.body.appendChild(overlay);
                  }}
                  onMouseOver={e=>{e.currentTarget.style.transform='scale(1.06)';e.currentTarget.style.boxShadow='0 4px 12px rgba(0,0,0,0.2)';}}
                  onMouseOut={e=>{e.currentTarget.style.transform='scale(1)';e.currentTarget.style.boxShadow='none';}}
                  title="Click to view full size" />
                {canEdit && <button onClick={()=>onDelete(woId,i)} style={{position:'absolute',top:'-5px',right:'-5px',width:'18px',height:'18px',borderRadius:'50%',background:'#ef4444',color:'#fff',border:'2px solid var(--bg2)',cursor:'pointer',fontSize:'0.65rem',lineHeight:1,display:'flex',alignItems:'center',justifyContent:'center'}}>✕</button>}
              </div>
            ) : r.type==='link' ? (
              <div key={i} style={{display:'inline-flex',alignItems:'center',gap:'6px',padding:'5px 12px',background:'rgba(59,126,240,0.06)',border:'1px solid rgba(59,126,240,0.2)',borderRadius:'8px',fontSize:'0.74rem',fontWeight:600,maxWidth:'240px',overflow:'hidden',transition:'all 0.15s',cursor:'pointer'}}
                onMouseOver={e=>{e.currentTarget.style.background='rgba(59,126,240,0.12)';e.currentTarget.style.borderColor='rgba(59,126,240,0.4)';}}
                onMouseOut={e=>{e.currentTarget.style.background='rgba(59,126,240,0.06)';e.currentTarget.style.borderColor='rgba(59,126,240,0.2)';}}>
                <svg viewBox="0 0 12 12" width="11" height="11" fill="none" stroke="#3b7ef0" strokeWidth="1.5"><path d="M5 2H2a1 1 0 00-1 1v7a1 1 0 001 1h7a1 1 0 001-1V7"/><path d="M8 1h3v3"/><line x1="11" y1="1" x2="5" y2="7"/></svg>
                <a href={/^https?:\/\//i.test(r.url)?r.url:'https://'+r.url} target="_blank" rel="noopener noreferrer"
                  style={{color:'var(--accent)',textDecoration:'none',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                  {r.label||r.url}
                </a>
                {canEdit && <span onClick={e=>{e.stopPropagation();onDelete(woId,i);}} style={{color:'var(--text3)',cursor:'pointer',flexShrink:0,marginLeft:2,fontSize:'0.7rem'}}>✕</span>}
              </div>
            ) : (
              <div key={i} style={{display:'inline-flex',alignItems:'center',gap:'5px',padding:'5px 10px',background:'var(--bg3)',border:'1px solid var(--border)',borderRadius:'8px',fontSize:'0.72rem'}}>
                📄 <span style={{maxWidth:'130px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{r.name}</span>
                <a href={r.data} download={r.name} style={{color:'var(--accent)',textDecoration:'none'}} title="Download">⬇</a>
                {canEdit && <span onClick={()=>onDelete(woId,i)} style={{color:'var(--text3)',cursor:'pointer'}}>✕</span>}
              </div>
            )
          ))}
        </div>
      </div>
    </div>
    {showSketch && (
      <SketchModal
        onSave={(dataUrl) => {
          const name = 'Sketch-' + new Date().toISOString().slice(0,16).replace('T',' ') + '.png';
          onAdd(woId, { type:'image', data:dataUrl, name });
        }}
        onClose={() => setShowSketch(false)}
      />
    )}
    </>
  );
}

// ── Voice Languages ───────────────────────────────────────
const VOICE_LANGS = [
  // Indian languages
  { code:'en-IN',  label:'🇮🇳 English (India)'   },
  { code:'ml-IN',  label:'🇮🇳 Malayalam'          },
  { code:'hi-IN',  label:'🇮🇳 Hindi'              },
  { code:'ta-IN',  label:'🇮🇳 Tamil'              },
  { code:'te-IN',  label:'🇮🇳 Telugu'             },
  { code:'kn-IN',  label:'🇮🇳 Kannada'            },
  { code:'mr-IN',  label:'🇮🇳 Marathi'            },
  { code:'gu-IN',  label:'🇮🇳 Gujarati'           },
  { code:'pa-IN',  label:'🇮🇳 Punjabi'            },
  { code:'bn-IN',  label:'🇮🇳 Bengali (India)'    },
  { code:'or-IN',  label:'🇮🇳 Odia'               },
  { code:'ur-IN',  label:'🇮🇳 Urdu (India)'       },
  // Global English
  { code:'en-US',  label:'🇺🇸 English (US)'       },
  { code:'en-GB',  label:'🇬🇧 English (UK)'       },
  { code:'en-AU',  label:'🇦🇺 English (Australia)'},
  // Other global
  { code:'ar-SA',  label:'🇸🇦 Arabic'             },
  { code:'zh-CN',  label:'🇨🇳 Chinese (Mandarin)' },
  { code:'fr-FR',  label:'🇫🇷 French'             },
  { code:'de-DE',  label:'🇩🇪 German'             },
  { code:'ja-JP',  label:'🇯🇵 Japanese'           },
  { code:'ko-KR',  label:'🇰🇷 Korean'             },
  { code:'pt-BR',  label:'🇧🇷 Portuguese (Brazil)'},
  { code:'es-ES',  label:'🇪🇸 Spanish'            },
];

const DEFAULT_FAVORITES = ['en-IN','ml-IN','hi-IN','ta-IN','en-US'];

function getVoiceLang()   { return localStorage.getItem('workops_voiceLang') || 'en-IN'; }
function setVoiceLang(v)  { localStorage.setItem('workops_voiceLang', v); }
function getVoiceFavs()   { try { return JSON.parse(localStorage.getItem('workops_voiceFavs')||JSON.stringify(DEFAULT_FAVORITES)); } catch(e){ return DEFAULT_FAVORITES; } }
function setVoiceFavs(v)  { localStorage.setItem('workops_voiceFavs', JSON.stringify(v)); }

// ── Voice Language Selector (shared, shown once per card) ─
function VoiceLangBar({ lang, onLangChange }) {
  const [open,    setOpen]    = useState(false);
  const [search,  setSearch]  = useState('');
  const [favs,    setFavs]    = useState(getVoiceFavs);
  const ref = useRef();

  useEffect(() => {
    const handler = e => { if(ref.current && !ref.current.contains(e.target)) setOpen(false); };
    if(open) document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const toggleFav = (code, e) => {
    e.stopPropagation();
    const newFavs = favs.includes(code) ? favs.filter(f=>f!==code) : [...favs, code];
    setFavs(newFavs); setVoiceFavs(newFavs);
  };

  const select = (code) => { onLangChange(code); setOpen(false); setSearch(''); };

  const filtered = VOICE_LANGS.filter(l => l.label.toLowerCase().includes(search.toLowerCase()) || l.code.toLowerCase().includes(search.toLowerCase()));
  const favLangs = VOICE_LANGS.filter(l => favs.includes(l.code));
  const current  = VOICE_LANGS.find(l=>l.code===lang) || VOICE_LANGS[0];

  return (
    <div ref={ref} style={{position:'relative',display:'inline-block'}}>
      <button onClick={()=>setOpen(v=>!v)}
        style={{display:'flex',alignItems:'center',gap:'4px',padding:'2px 8px',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:'6px',fontSize:'0.72rem',fontWeight:600,color:'var(--text)',cursor:'pointer',whiteSpace:'nowrap'}}>
        {current.label} <span style={{fontSize:'0.6rem',opacity:0.5}}>▾</span>
      </button>
      {open && (
        <div style={{position:'absolute',top:'100%',left:0,marginTop:'4px',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:'8px',boxShadow:'0 8px 24px rgba(0,0,0,0.2)',zIndex:9999,width:'240px',maxHeight:'320px',display:'flex',flexDirection:'column'}}>
          {/* Search */}
          <div style={{padding:'8px 10px',borderBottom:'1px solid var(--border)',flexShrink:0}}>
            <input autoFocus className="form-input" style={{padding:'4px 8px',fontSize:'0.75rem',width:'100%'}}
              placeholder="Search language..." value={search} onChange={e=>setSearch(e.target.value)} />
          </div>
          <div style={{overflowY:'auto',flex:1}}>
            {/* Favorites */}
            {!search && favLangs.length>0 && (
              <div>
                <div style={{padding:'6px 10px 2px',fontSize:'0.65rem',fontWeight:700,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.5px'}}>⭐ Favorites</div>
                {favLangs.map(l=>(
                  <div key={l.code} onClick={()=>select(l.code)}
                    style={{display:'flex',alignItems:'center',gap:'6px',padding:'6px 10px',cursor:'pointer',fontSize:'0.78rem',fontWeight:lang===l.code?700:400,background:lang===l.code?'var(--accent)11':'transparent',color:lang===l.code?'var(--accent)':'var(--text)'}}>
                    <span style={{flex:1}}>{l.label}</span>
                    <span onClick={e=>toggleFav(l.code,e)} title="Remove from favorites" style={{color:'#f7c34f',cursor:'pointer',fontSize:'0.8rem'}}>⭐</span>
                    {lang===l.code&&<span style={{color:'var(--accent)',fontSize:'0.7rem'}}>✓</span>}
                  </div>
                ))}
                <div style={{height:'1px',background:'var(--border)',margin:'4px 0'}} />
              </div>
            )}
            {/* All languages */}
            {!search && <div style={{padding:'6px 10px 2px',fontSize:'0.65rem',fontWeight:700,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.5px'}}>All Languages</div>}
            {filtered.map(l=>(
              <div key={l.code} onClick={()=>select(l.code)}
                style={{display:'flex',alignItems:'center',gap:'6px',padding:'6px 10px',cursor:'pointer',fontSize:'0.78rem',fontWeight:lang===l.code?700:400,background:lang===l.code?'var(--accent)11':'transparent',color:lang===l.code?'var(--accent)':'var(--text)'}}>
                <span style={{flex:1}}>{l.label}</span>
                <span onClick={e=>toggleFav(l.code,e)} title={favs.includes(l.code)?'Remove from favorites':'Add to favorites'}
                  style={{color:favs.includes(l.code)?'#f7c34f':'var(--text3)',cursor:'pointer',fontSize:'0.8rem',opacity:favs.includes(l.code)?1:0.4}}>
                  {favs.includes(l.code)?'⭐':'☆'}
                </span>
                {lang===l.code&&<span style={{color:'var(--accent)',fontSize:'0.7rem'}}>✓</span>}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ── Text case transform ─────────────────────────────────────
const CASE_MODES = [
  { id:'none',      label:'As spoken',     icon:'Aa' },
  { id:'sentence',  label:'Sentence case',  icon:'A•' },
  { id:'title',     label:'Title Case',     icon:'T•' },
  { id:'upper',     label:'ALL CAPS',       icon:'AA' },
  { id:'lower',     label:'lowercase',      icon:'aa' },
];

function applyCase(text, mode) {
  if (!text) return text;
  switch(mode) {
    case 'sentence': return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    case 'title':    return text.replace(/\b\w/g, c=>c.toUpperCase());
    case 'upper':    return text.toUpperCase();
    case 'lower':    return text.toLowerCase();
    default:         return text; // as spoken
  }
}

function getCaseMode()  { return localStorage.getItem('workops_voiceCase') || 'sentence'; }
function saveCaseMode(v){ localStorage.setItem('workops_voiceCase', v); }

// ── Voice Mic Button — clear record/stop pill with live preview ──
function VoiceMicBtn({ onResult, onInterim, lang, fieldLabel }) {
  const [state,    setState]   = useState('idle'); // idle | recording | stopping
  const [interim,  setInterim] = useState('');
  const [caseMode, setCaseMode] = useState(getCaseMode);
  const [showCase, setShowCase] = useState(false);
  const recRef = useRef(null);
  const supported = ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window);

  if (!supported) return null;

  const start = (e) => {
    e.stopPropagation();
    if (state !== 'idle') return;
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    const rec = new SR();
    rec.lang            = lang || 'en-IN';
    rec.continuous      = true;   // keep recording
    rec.interimResults  = true;   // real-time text as you speak

    rec.onresult = (ev) => {
      let interimText = '';
      let finalText   = '';
      for (let i = ev.resultIndex; i < ev.results.length; i++) {
        const t = ev.results[i][0].transcript;
        if (ev.results[i].isFinal) finalText += t + ' ';
        else interimText += t;
      }
      setInterim(interimText);
      if (finalText) { onResult(applyCase(finalText.trim(), caseMode)); if(onInterim) onInterim(''); }
      else if (onInterim) onInterim(interimText);
    };
    rec.onend   = () => { setState('idle'); setInterim(''); };
    rec.onerror = () => { setState('idle'); setInterim(''); };
    rec.start();
    recRef.current = rec;
    setState('recording');
  };

  const stop = (e) => {
    e.stopPropagation();
    setState('stopping');
    recRef.current?.stop();
  };

  const currentCase = CASE_MODES.find(m=>m.id===caseMode)||CASE_MODES[0];

  // ── Idle state — mic pill + case selector ──
  if (state === 'idle') {
    return (
      <span style={{display:'inline-flex',alignItems:'center',gap:'4px',flexShrink:0,position:'relative'}}>
        {/* Case mode selector */}
        <span style={{position:'relative'}}>
          <button onMouseDown={e=>{e.stopPropagation();setShowCase(v=>!v);}}
            title={`Text case: ${currentCase.label}`}
            style={{display:'inline-flex',alignItems:'center',gap:'3px',padding:'2px 6px',background:'var(--bg3)',border:'1px solid var(--border)',borderRadius:'6px',cursor:'pointer',fontSize:'0.65rem',fontWeight:700,color:'var(--text3)',lineHeight:1.4,fontFamily:'monospace'}}>
            {currentCase.icon}
          </button>
          {showCase && (
            <div style={{position:'absolute',top:'100%',right:0,marginTop:'3px',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:'8px',boxShadow:'0 6px 20px rgba(0,0,0,0.2)',zIndex:9999,minWidth:'150px',padding:'4px'}}>
              {CASE_MODES.map(m=>(
                <div key={m.id} onMouseDown={e=>{e.stopPropagation();setCaseMode(m.id);saveCaseMode(m.id);setShowCase(false);}}
                  style={{display:'flex',alignItems:'center',gap:'8px',padding:'6px 10px',borderRadius:'5px',cursor:'pointer',fontSize:'0.75rem',fontWeight:caseMode===m.id?700:400,background:caseMode===m.id?'var(--accent)11':'transparent',color:caseMode===m.id?'var(--accent)':'var(--text)'}}>
                  <span style={{fontFamily:'monospace',fontWeight:700,fontSize:'0.7rem',width:'20px',color:'var(--text3)'}}>{m.icon}</span>
                  {m.label}
                  {caseMode===m.id&&<span style={{marginLeft:'auto',color:'var(--accent)',fontSize:'0.7rem'}}>✓</span>}
                </div>
              ))}
            </div>
          )}
        </span>
        {/* Record button */}
        <button onMouseDown={start} title={`Record voice input — ${fieldLabel||'this field'} (${currentCase.label})`}
          style={{display:'inline-flex',alignItems:'center',gap:'4px',padding:'2px 8px',background:'var(--bg3)',border:'1px solid var(--border)',borderRadius:'20px',cursor:'pointer',fontSize:'0.7rem',fontWeight:600,color:'var(--text2)',lineHeight:1.4}}>
          <span style={{fontSize:'0.85rem'}}>🎙️</span>
          <span>Record</span>
        </button>
      </span>
    );
  }

  // ── Recording state — red pulsing pill ──
  return (
    <span style={{display:'inline-flex',alignItems:'center',gap:'6px',flexWrap:'wrap'}}>
      {/* Live interim preview */}
      {interim && (
        <span style={{fontSize:'0.7rem',color:'var(--text3)',fontStyle:'italic',maxWidth:'200px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
          {interim}
        </span>
      )}
      <button onMouseDown={stop} title="Stop recording"
        style={{display:'inline-flex',alignItems:'center',gap:'5px',padding:'3px 10px',
          background:'#e84545',border:'none',borderRadius:'20px',cursor:'pointer',
          fontSize:'0.72rem',fontWeight:700,color:'#fff',flexShrink:0,
          boxShadow:'0 0 0 0 rgba(232,69,69,0.5)',
          animation:'voicePulse 1.2s ease-in-out infinite'}}>
        <span style={{width:'8px',height:'8px',borderRadius:'50%',background:'#fff',display:'inline-block',flexShrink:0}} />
        {state==='stopping'?'Stopping...':'Recording... tap to stop'}
      </button>
      <style>{`@keyframes voicePulse{0%,100%{box-shadow:0 0 0 0 rgba(232,69,69,0.5)}50%{box-shadow:0 0 0 6px rgba(232,69,69,0)}}`}</style>
    </span>
  );
}

// ── Output Formats Dropdown — search + favorites, matches Edit Entry style ──
const PLATFORM_COLORS_FMT = {
  'Instagram':'#e1306c','Facebook':'#1877f2','LinkedIn':'#0077b5','YouTube':'#ff0000',
  'WhatsApp':'#25d366','Pinterest':'#e60023','Google Ads':'#4285f4','X / Twitter':'#000000',
  'Telegram':'#2ca5e0','Snapchat':'#fffc00','TikTok':'#000000','Email / CRM':'#ea4335',
  'Amazon Ads':'#ff9900','Flipkart Ads':'#2874f0','Spotify':'#1db954','Meta Ads':'#0668e1',
  'Threads':'#000000','Discord':'#5865f2','Reddit':'#ff4500','Quora Ads':'#a82400',
};
function getFmtFavs()   { try { return JSON.parse(localStorage.getItem('workops_fmtFavs')||'[]'); } catch(e){ return []; } }
function saveFmtFavs(v) { localStorage.setItem('workops_fmtFavs', JSON.stringify(v)); }

function OutputFormatsDropdown({ outputFormats, selected, onChange, onClose }) {
  const [favs,   setFavs]     = useState(getFmtFavs);
  const ref = useRef();

  useEffect(() => {
    const handler = e => { if(ref.current && !ref.current.contains(e.target)) onClose(); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  const toggleFav = (key, e) => {
    e.stopPropagation();
    const n = favs.includes(key) ? favs.filter(f=>f!==key) : [...favs,key];
    setFavs(n); saveFmtFavs(n);
  };
  // Simple name match — both Edit Entry and ContentCalendar now store format names
  const isSelected = (f) => (selected||[]).includes(typeof f === 'string' ? f : fmtKey(f));
  const toggle = (f) => {
    const key = typeof f === 'string' ? f : fmtKey(f);
    if (!key) return;
    if ((selected||[]).includes(key)) onChange((selected||[]).filter(s => s !== key));
    else onChange([...(selected||[]), key]);
  };

  const fmtKey = (f) => f.platform ? `${f.platform} ${f.name||f.label||f.format_name||''}` : (f.name||f.label||f.format_name||'');
  const allFmts   = (outputFormats||[]).filter(f=>f.enabled!==false&&f.is_active!==false);
  const favFmts   = allFmts.filter(f=>favs.includes(fmtKey(f)));

  return (
    <div ref={ref} style={{position:'absolute',top:'100%',left:0,marginTop:'4px',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:'10px',boxShadow:'0 8px 28px rgba(0,0,0,0.18)',zIndex:200,width:'340px',maxHeight:'380px',display:'flex',flexDirection:'column'}}>
      {/* Header */}
      <div style={{padding:'10px 12px',borderBottom:'1px solid var(--border)',flexShrink:0}}>
        <div style={{fontSize:'0.72rem',fontWeight:700,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.5px'}}>📐 Output Formats — search and select · ☆ to favorite</div>
      </div>
      <div style={{overflowY:'auto',flex:1}}>
        {/* Favorites */}
        {favFmts.length>0 && (<>
          <div style={{padding:'6px 12px 2px',fontSize:'0.62rem',fontWeight:700,color:'#f7c34f',textTransform:'uppercase',letterSpacing:'0.5px'}}>⭐ Favorites (click ⭐ to remove)</div>
          {favFmts.map(f=>{
            const fname=f.name||f.label||f.format_name||'';
            const fkey=fmtKey(f);
            const checked=isSelected(fkey);
            const pcolor=PLATFORM_COLORS_FMT[f.platform]||'var(--text3)';
            return (
              <label key={'fav-'+f.id} style={{display:'flex',alignItems:'center',gap:'8px',padding:'6px 12px',cursor:'pointer',background:checked?`${pcolor}0a`:'transparent',borderLeft:checked?`3px solid ${pcolor}`:'3px solid transparent'}}>
                <input type="checkbox" checked={checked} onChange={()=>toggle(fkey)}
                  style={{accentColor:pcolor,width:'14px',height:'14px',flexShrink:0}} />
                <span style={{fontSize:'0.72rem',fontWeight:700,color:pcolor,flexShrink:0,minWidth:'60px'}}>{f.platform||''}</span>
                <span style={{fontSize:'0.78rem',flex:1}}>{fname}</span>
                {f.dimensions&&<span style={{fontSize:'0.62rem',color:'var(--text3)',whiteSpace:'nowrap'}}>{f.dimensions}</span>}
                <span onClick={e=>toggleFav(fkey,e)} style={{color:'#f7c34f',cursor:'pointer',fontSize:'0.85rem',flexShrink:0}}>⭐</span>
              </label>
            );
          })}
          <div style={{height:'1px',background:'var(--border)',margin:'4px 0'}} />
        </>)}
        {/* All formats */}
        {<div style={{padding:'6px 12px 2px',fontSize:'0.62rem',fontWeight:700,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.5px'}}>All Formats — click ⭐ to favorite</div>}
        {allFmts.map(f=>{
          const fname=f.name||f.label||f.format_name||'';
          const fkey=fmtKey(f);
          const checked=isSelected(fkey);
          const isFav=favs.includes(fkey);
          const pcolor=PLATFORM_COLORS_FMT[f.platform]||'var(--text3)';
          return (
            <label key={f.id} style={{display:'flex',alignItems:'center',gap:'8px',padding:'6px 12px',cursor:'pointer',background:checked?`${pcolor}0a`:'transparent',borderLeft:checked?`3px solid ${pcolor}`:'3px solid transparent'}}>
              <input type="checkbox" checked={checked} onChange={()=>toggle(fkey)}
                style={{accentColor:pcolor,width:'14px',height:'14px',flexShrink:0}} />
              <span style={{fontSize:'0.72rem',fontWeight:700,color:pcolor,flexShrink:0,minWidth:'60px'}}>{f.platform||''}</span>
              <span style={{fontSize:'0.78rem',flex:1}}>{fname}</span>
              {f.dimensions&&<span style={{fontSize:'0.62rem',color:'var(--text3)',whiteSpace:'nowrap'}}>{f.dimensions}</span>}
              <span onClick={e=>toggleFav(fkey,e)} style={{color:isFav?'#f7c34f':'var(--text3)',cursor:'pointer',fontSize:'0.85rem',flexShrink:0,opacity:isFav?1:0.3}}>⭐</span>
            </label>
          );
        })}
        {allFmts.length===0&&<div style={{padding:'20px',textAlign:'center',color:'var(--text3)',fontSize:'0.78rem'}}>No formats found</div>}
      </div>
      {/* Footer */}
      <div style={{padding:'8px 12px',borderTop:'1px solid var(--border)',display:'flex',justifyContent:'space-between',alignItems:'center',flexShrink:0}}>
        <span style={{fontSize:'0.72rem',color:'var(--text3)'}}><strong style={{color:'var(--accent)'}}>{(selected||[]).length}</strong> selected</span>
        <button onClick={onClose} className="btn btn-secondary" style={{fontSize:'0.72rem',padding:'3px 12px'}}>Done</button>
      </div>
    </div>
  );
}


// ── PlatformsFormatsStrip — platform logos + format chips ──
function PlatformsFormatsStrip({ platforms: platsList, outputFormats: fmtsList, woPlats, woFmts }) {
  if (!woPlats.length && !woFmts.length) return null;
  return (
    <div style={{marginBottom:'12px',display:'flex',flexDirection:'column',gap:'6px'}}>
      {woPlats.length > 0 && (
        <div style={{display:'flex',flexWrap:'wrap',gap:'5px',alignItems:'center'}}>
          <span className="text-xs fw-700 text-muted" style={{marginRight:'2px'}}>📱 PLATFORMS</span>
          {woPlats.map(p => {
            const svg   = getPlatformSvg(p);
            const color = PLATFORM_COLORS[p] || '#6b7280';
            return (
              <span key={p} title={p} style={{display:'inline-flex',alignItems:'center',gap:'5px',padding:'2px 9px 2px 4px',background:`${color}12`,border:`1px solid ${color}55`,borderRadius:'14px',fontSize:'0.7rem',color,fontWeight:700,whiteSpace:'nowrap'}}>
                {svg
                  ? <span style={{width:'18px',height:'18px',flexShrink:0,borderRadius:'4px',overflow:'hidden',display:'inline-flex',alignItems:'center',justifyContent:'center'}} dangerouslySetInnerHTML={{__html:svg}} />
                  : <span style={{fontSize:'0.9rem'}}>📱</span>}
                {p}
              </span>
            );
          })}
        </div>
      )}
      {woFmts.length > 0 && (
        <div style={{display:'flex',flexWrap:'wrap',gap:'5px',alignItems:'center'}}>
          <span className="text-xs fw-700 text-muted" style={{marginRight:'2px'}}>📐 FORMATS</span>
          {woFmts.map(f => {
            const parts   = f.split(' ');
            const platform = parts[0];
            const fname   = parts.slice(1).join(' ');
            const color   = PLATFORM_COLORS[platform] || '#6b7280';
            return (
              <span key={f} title={f} style={{display:'inline-flex',alignItems:'center',gap:'5px',padding:'3px 9px',background:'var(--bg2)',border:`1px solid ${color}55`,borderLeft:`3px solid ${color}`,borderRadius:'6px',fontSize:'0.7rem',whiteSpace:'nowrap'}}>
                <span style={{fontSize:'0.62rem',fontWeight:700,color,textTransform:'uppercase',letterSpacing:'0.3px'}}>{platform}</span>
                <span style={{fontWeight:600,color:'var(--text)'}}>{fname}</span>
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ── VersionHistoryItem — each version row (needs useState so must be a component) ──
function VersionHistoryItem({ v, i, total, isClient }) {
  // Client-friendly label mapping — hide internal terminology
  const clientLabels = {
    'Internal Approved':  'Sent for Your Review',
    'Internal Submitted': 'Sent for Your Review',
    'Rejected':           'Revision Requested',
    'Submitted':          'Draft Submitted',
  };
  const displayAction = isClient ? (clientLabels[v.action] || v.action) : (v.action || '?');
  const [showSnap, setShowSnap] = React.useState(false);
  const ACTION_STYLE = {
    'Submitted':             { color:'var(--accent)',  icon:'📤' },
    'Internal Approved':     { color:'#e87830',        icon:'✓'  },
    'Internal Submitted':    { color:'#6c58f0',        icon:'✓'  },
    'Sent for Your Review':  { color:'#6c58f0',        icon:'✓'  },
    'Pending Client':        { color:'#6c58f0',        icon:'👔' },
    'Client Approved':       { color:'#1db87a',        icon:'✅' },
    'Rejected':              { color:'#e84545',        icon:'↩'  },
    'Revision Requested':    { color:'#e84545',        icon:'↩'  },
    'Rejected Internal':     { color:'#e84545',        icon:'↩'  },
    'Rejected Client':       { color:'#e84545',        icon:'↩'  },
  };
  const st = ACTION_STYLE[displayAction] || ACTION_STYLE[v.action] || { color:'var(--text3)', icon:'•' };
  const isLast = i === total - 1;
  const d = v.at ? new Date(v.at) : null;
  const dateStr = d ? `${String(d.getDate()).padStart(2,'0')}-${String(d.getMonth()+1).padStart(2,'0')}-${d.getFullYear()} ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}` : '—';
  return (
    <div style={{display:'flex',gap:'10px',padding:'8px 0',borderBottom:isLast?'none':'1px solid var(--border)'}}>
      <div style={{display:'flex',flexDirection:'column',alignItems:'center',flexShrink:0}}>
        <div style={{width:'26px',height:'26px',borderRadius:'50%',background:`${st.color}22`,border:`2px solid ${st.color}`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'0.7rem',fontWeight:700,color:st.color}}>
          {v.version||total-i}
        </div>
        {!isLast && <div style={{width:'2px',flex:1,minHeight:'10px',background:'var(--border)',marginTop:'2px'}} />}
      </div>
      <div style={{flex:1,minWidth:0}}>
        <div style={{display:'flex',alignItems:'center',gap:'8px',flexWrap:'wrap',marginBottom:'4px'}}>
          <span style={{fontSize:'0.72rem',fontWeight:700,color:st.color}}>{st.icon} {displayAction}</span>
          <span className="mono text-xs text-muted">{dateStr}</span>
        </div>
        {v.rejectionReason && (
          <div style={{fontSize:'0.75rem',color:'#e84545',padding:'4px 8px',background:'#ff000008',borderRadius:'4px',marginBottom:'4px'}}>↩ {v.rejectionReason}</div>
        )}
        {v.voiceNote?.audio && (
          <div style={{display:'flex',alignItems:'center',gap:'6px',padding:'4px 8px',background:'rgba(59,126,240,0.06)',borderRadius:'6px',marginBottom:'4px',flexWrap:'wrap'}}>
            <span style={{fontSize:'0.65rem',fontWeight:700,color:'var(--accent)'}}>🎙️ Voice feedback</span>
            <audio controls src={v.voiceNote.audio} style={{height:'28px',flex:1,minWidth:'160px',maxWidth:'260px'}} />
            {v.voiceNote.duration && <span style={{fontSize:'0.62rem',color:'var(--text3)'}}>{Math.floor(v.voiceNote.duration/60)}:{String(Math.round(v.voiceNote.duration)%60).padStart(2,'0')}</span>}
          </div>
        )}
        <div onClick={()=>setShowSnap(s=>!s)} style={{fontSize:'0.68rem',color:'var(--accent)',cursor:'pointer',marginBottom:'2px'}}>
          📄 View snapshot {showSnap?'▲':'▾'}
        </div>
        {showSnap && (
          <div style={{padding:'8px',background:'var(--bg3)',borderRadius:'6px',fontSize:'0.72rem'}}>
            {v.hook    && <div><b>Caption:</b> {v.hook}</div>}
            {v.message && <div><b>Sub Caption:</b> {v.message}</div>}
            {v.script  && <div><b>Body Text:</b> {v.script}</div>}
            {v.visual  && <div><b>Visual:</b> {v.visual}</div>}
            {v.cta     && <div><b>CTA:</b> {v.cta}</div>}
          </div>
        )}
      </div>
    </div>
  );
}

// ── VersionHistory — collapsible, used in all 4 tabs ──
function VersionHistory({ sc, isClient }) {
  const [open, setOpen] = React.useState(false);
  const allVersions = sc?.versions || [];

  // Client only sees versions at their stage — no internal back-and-forth
  const versions = isClient
    ? allVersions.filter(v => {
        const stage = v.stage || 'internal';
        const action = v.action || '';
        if (stage !== 'client') return false; // hide all internal
        // Client sees: what was sent to them, their rejections, final approval
        if (['Internal Approved', 'Client Approved'].includes(action)) return true;
        if (action === 'Rejected' && stage === 'client') return true;
        if (action === 'Revision Requested' && stage === 'client') return true;
        // Hide Internal Submitted — it's just a routing action, not meaningful to client
        if (action === 'Internal Submitted') return false;
        return false;
      })
    : allVersions;

  if (!versions.length) return null;

  return (
    <div style={{marginTop:'14px'}}>
      <div onClick={()=>setOpen(v=>!v)}
        style={{display:'flex',alignItems:'center',gap:'8px',cursor:'pointer',padding:'6px 0',borderTop:'1px solid var(--border)'}}>
        <span className="text-xs fw-700 text-muted">📜 Version History</span>
        <span style={{fontSize:'0.65rem',color:'var(--text3)'}}>{versions.length} submission{versions.length!==1?'s':''}</span>
        <span style={{fontSize:'0.65rem',color:'var(--text3)',marginLeft:'auto'}}>{open?'▼':'▶'}</span>
      </div>
      {open && (
        <div style={{paddingTop:'4px'}}>
          {[...versions].reverse().map((v, i) => (
            <VersionHistoryItem key={i} v={v} i={i} total={versions.length} isClient={isClient} />
          ))}
        </div>
      )}
    </div>
  );
}

// ── VoiceMicInline — speech-to-text mic for inline fields ──
function VoiceMicInline({ onResult, lang }) {
  const [active, setActive] = React.useState(false);
  const recRef = React.useRef(null);
  if (!('webkitSpeechRecognition' in window || 'SpeechRecognition' in window)) return null;
  const toggle = (e) => {
    e.stopPropagation();
    if (active) { recRef.current?.stop(); setActive(false); return; }
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    const rec = new SR();
    rec.lang = lang || 'en-IN';
    rec.continuous = true; rec.interimResults = false;
    rec.onresult = ev => { for(let i=ev.resultIndex;i<ev.results.length;i++) if(ev.results[i].isFinal) onResult(ev.results[i][0].transcript+' '); };
    rec.onend = () => setActive(false);
    rec.start(); recRef.current = rec; setActive(true);
  };
  return (
    <button onMouseDown={toggle} title={active?'Stop recording':'Record voice'}
      style={{display:'inline-flex',alignItems:'center',gap:'4px',padding:'2px 8px',
        background:active?'#e84545':'var(--bg3)',border:`1px solid ${active?'#e84545':'var(--border)'}`,
        borderRadius:'12px',cursor:'pointer',fontSize:'0.7rem',fontWeight:600,
        color:active?'#fff':'var(--text2)',flexShrink:0}}>
      {active ? '⏹ Stop' : '🎙️'}
    </button>
  );
}

// ── ActionVoiceRecorder — records audio to attach to an approval action ──
// Shows as a compact "Record voice feedback" section before action buttons
function ActionVoiceRecorder({ onAudioReady }) {
  const [state,    setState]    = React.useState('idle'); // idle|recording|recorded
  const [audioUrl, setAudioUrl] = React.useState(null);
  const [audioB64, setAudioB64] = React.useState(null);
  const [duration, setDuration] = React.useState(0);
  const [timer,    setTimer]    = React.useState(0);
  const mediaRef  = React.useRef(null);
  const chunksRef = React.useRef([]);
  const timerRef  = React.useRef(null);

  const fmtTime = s => `${Math.floor(s/60)}:${String(s%60).padStart(2,'0')}`;

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream, {
        mimeType: MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' : 'audio/ogg'
      });
      chunksRef.current = [];
      mr.ondataavailable = e => { if (e.data.size > 0) chunksRef.current.push(e.data); };
      mr.onstop = () => {
        stream.getTracks().forEach(t => t.stop());
        const blob = new Blob(chunksRef.current, { type: mr.mimeType });
        const url  = URL.createObjectURL(blob);
        setAudioUrl(url);
        setDuration(timer);
        const reader = new FileReader();
        reader.onload = ev => {
          setAudioB64(ev.target.result);
          onAudioReady({ audio: ev.target.result, duration: timer });
        };
        reader.readAsDataURL(blob);
        setState('recorded');
        clearInterval(timerRef.current);
      };
      mr.start();
      mediaRef.current = mr;
      setState('recording');
      setTimer(0);
      timerRef.current = setInterval(() => setTimer(t => t + 1), 1000);
    } catch(e) {
      alert('Microphone access denied.');
    }
  };

  const stop = () => { mediaRef.current?.stop(); clearInterval(timerRef.current); };

  const discard = () => {
    setAudioUrl(null); setAudioB64(null); setDuration(0); setTimer(0);
    setState('idle');
    onAudioReady(null);
  };

  return (
    <div style={{marginBottom:'10px'}}>
      {state === 'idle' && (
        <button onClick={start}
          style={{display:'inline-flex',alignItems:'center',gap:'6px',padding:'4px 12px',
            background:'var(--bg3)',border:'1px dashed var(--border)',borderRadius:'8px',
            cursor:'pointer',fontSize:'0.72rem',color:'var(--text3)'}}>
          <span style={{width:'8px',height:'8px',borderRadius:'50%',background:'#e84545',display:'inline-block'}} />
          Add voice feedback (optional)
        </button>
      )}
      {state === 'recording' && (
        <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
          <div style={{display:'flex',alignItems:'center',gap:'6px',padding:'4px 12px',
            background:'#e8454508',border:'1px solid #e84545',borderRadius:'8px',
            animation:'voicePulse 1.2s ease-in-out infinite'}}>
            <span style={{width:'8px',height:'8px',borderRadius:'50%',background:'#e84545',display:'inline-block'}} />
            <span style={{fontSize:'0.72rem',fontWeight:700,color:'#e84545'}}>Recording {fmtTime(timer)}</span>
          </div>
          <button onClick={stop}
            style={{padding:'4px 12px',background:'#e84545',color:'#fff',border:'none',
              borderRadius:'8px',cursor:'pointer',fontSize:'0.72rem',fontWeight:700}}>
            ⏹ Stop
          </button>
        </div>
      )}
      {state === 'recorded' && (
        <div style={{display:'flex',alignItems:'center',gap:'8px',flexWrap:'wrap',
          padding:'6px 10px',background:'#1db87a08',border:'1px solid #1db87a44',borderRadius:'8px'}}>
          <span style={{fontSize:'0.68rem',fontWeight:600,color:'#1db87a'}}>🎙️ Voice feedback ready</span>
          <audio controls src={audioUrl} style={{height:'28px',flex:1,minWidth:'160px',maxWidth:'260px'}} />
          <span style={{fontSize:'0.65rem',color:'var(--text3)'}}>{fmtTime(duration)}</span>
          <button onClick={start} style={{padding:'2px 8px',fontSize:'0.68rem',background:'var(--bg3)',
            border:'1px solid var(--border)',borderRadius:'6px',cursor:'pointer',color:'var(--text2)'}}>
            🔄 Re-record
          </button>
          <button onClick={discard} style={{padding:'2px 8px',fontSize:'0.68rem',background:'none',
            border:'1px solid var(--border)',borderRadius:'6px',cursor:'pointer',color:'var(--text3)'}}>
            ✕ Remove
          </button>
        </div>
      )}
    </div>
  );
}

// ── VoiceNoteRecorder — real audio recording, save to DB ──
function VoiceNoteRecorder({ woId, tab, voiceNotes, onSaved, shareWithClient, onToggleShare, canShare }) {
  const [state,     setState]     = React.useState('idle'); // idle|recording|recorded|saving
  const [audioUrl,  setAudioUrl]  = React.useState(null);
  const [audioB64,  setAudioB64]  = React.useState(null);
  const [duration,  setDuration]  = React.useState(0);
  const [timer,     setTimer]     = React.useState(0);
  const mediaRef  = React.useRef(null);
  const chunksRef = React.useRef([]);
  const timerRef  = React.useRef(null);

  // Show notes based on workflow — each stage sees relevant notes from other stages
  const tabNotes = (() => {
    const all = voiceNotes || [];
    if (tab === 'scripts') {
      // Writer sees: own notes + internal feedback (after rejection) + client feedback (after rejection)
      return all.filter(n =>
        n.tab === 'scripts' ||
        n.tab === 'internal' ||  // reviewer feedback flows back
        n.tab === 'client'       // client feedback flows back
      );
    }
    if (tab === 'internal') {
      // Reviewer sees: writer's explanation + own notes + client feedback (if any)
      return all.filter(n =>
        n.tab === 'scripts' ||   // writer's explanation
        n.tab === 'internal' ||  // own notes
        n.tab === 'client'       // client feedback if rejected back
      );
    }
    if (tab === 'client') {
      // Client sees: own notes + internal notes marked share + writer notes if internal shared them
      return all.filter(n =>
        n.tab === 'client' ||
        (n.tab === 'internal' && n.share_with_client) ||
        (n.tab === 'scripts'  && n.share_with_client)
      );
    }
    return all.filter(n => n.tab === tab);
  })();

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream, { mimeType: MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' : 'audio/ogg' });
      chunksRef.current = [];
      mr.ondataavailable = e => { if (e.data.size > 0) chunksRef.current.push(e.data); };
      mr.onstop = () => {
        stream.getTracks().forEach(t => t.stop());
        const blob = new Blob(chunksRef.current, { type: mr.mimeType });
        const url  = URL.createObjectURL(blob);
        setAudioUrl(url);
        setDuration(timer);
        // Convert to base64 for storage
        const reader = new FileReader();
        reader.onload = ev => setAudioB64(ev.target.result);
        reader.readAsDataURL(blob);
        setState('recorded');
        clearInterval(timerRef.current);
      };
      mr.start();
      mediaRef.current = mr;
      setState('recording');
      setTimer(0);
      timerRef.current = setInterval(() => setTimer(t => t + 1), 1000);
    } catch(e) {
      alert('Microphone access denied. Please allow microphone access and try again.');
    }
  };

  const stopRecording = () => {
    mediaRef.current?.stop();
    clearInterval(timerRef.current);
  };

  const discard = () => {
    setAudioUrl(null); setAudioB64(null); setDuration(0); setTimer(0);
    setState('idle');
  };

  const save = async () => {
    if (!audioB64) return;
    setState('saving');
    try {
      const newNote = {
        id:   Date.now().toString(),
        tab,
        by:   'Me', // server will use auth user name
        at:   new Date().toISOString(),
        audio: audioB64,
        duration,
        // scripts: writer can optionally share with client
        // internal: reviewer controls sharing with client
        // client: always visible to team
        share_with_client: tab === 'client' ? true : !!shareWithClient,
      };
      const updated = [...(voiceNotes||[]), newNote];
      await onSaved(updated);
      setAudioUrl(null); setAudioB64(null); setDuration(0); setState('idle');
    } catch(e) {
      alert('Failed to save: ' + e.message);
      setState('recorded');
    }
  };

  const deleteNote = async (id) => {
    if (!window.confirm('Delete this voice note?')) return;
    const updated = (voiceNotes||[]).filter(n => n.id !== id);
    await onSaved(updated);
  };

  const fmtTime = s => `${Math.floor(s/60)}:${String(s%60).padStart(2,'0')}`;

  return (
    <div style={{marginBottom:'14px',padding:'12px 14px',background:'rgba(59,126,240,0.04)',border:'1px solid rgba(59,126,240,0.18)',borderRadius:'10px'}}>

      {/* Header */}
      <div style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'10px',flexWrap:'wrap'}}>
        <span style={{fontSize:'0.72rem',fontWeight:700,color:'var(--accent)',textTransform:'uppercase',letterSpacing:'0.5px'}}>🎙️ Voice Notes</span>
        {tab==='scripts'&&<span style={{fontSize:'0.65rem',color:'var(--text3)'}}>Add a voice note explaining your content</span>}
        {tab==='internal'&&<span style={{fontSize:'0.65rem',color:'var(--text3)'}}>Record feedback for the team</span>}
        {tab==='client'&&<span style={{fontSize:'0.65rem',color:'var(--text3)'}}>Record your feedback</span>}
        {/* Share toggle — scripts and internal tabs */}
        {(tab==='internal' || tab==='scripts') && canShare && (
          <label style={{display:'flex',alignItems:'center',gap:'5px',fontSize:'0.72rem',cursor:'pointer',marginLeft:'auto',fontWeight:500,color:'var(--text2)'}}>
            <input type="checkbox" checked={!!shareWithClient} onChange={e=>onToggleShare(e.target.checked)}
              style={{accentColor:'var(--accent)',width:'13px',height:'13px'}} />
            Share with client
          </label>
        )}
      </div>

      {/* Existing voice notes */}
      {tabNotes.length > 0 && (
        <div style={{marginBottom:'10px',display:'flex',flexDirection:'column',gap:'6px'}}>
          {tabNotes.map((n,i) => (
            <div key={n.id||i} style={{display:'flex',alignItems:'center',gap:'8px',padding:'6px 10px',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:'8px',flexWrap:'wrap'}}>
              <div style={{display:'flex',alignItems:'center',gap:'5px',flexWrap:'wrap',fontSize:'0.68rem',color:'var(--text3)',fontWeight:600}}>
                {n.tab==='scripts'  && <span style={{padding:'1px 6px',borderRadius:'8px',background:'rgba(59,126,240,0.1)',color:'var(--accent)',fontSize:'0.6rem',fontWeight:700}}>✍️ Writer</span>}
                {n.tab==='internal' && <span style={{padding:'1px 6px',borderRadius:'8px',background:'rgba(232,120,48,0.1)',color:'#e87830',fontSize:'0.6rem',fontWeight:700}}>🔒 Reviewer</span>}
                {n.tab==='client'   && <span style={{padding:'1px 6px',borderRadius:'8px',background:'rgba(108,88,240,0.1)',color:'#6c58f0',fontSize:'0.6rem',fontWeight:700}}>👔 Client</span>}
                <span>{n.by||'Team'}</span>
                <span style={{fontWeight:400}}>· {n.at?new Date(n.at).toLocaleDateString('en-IN',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'}):''}</span>
                {n.share_with_client&&<span style={{color:'#1db87a',fontSize:'0.6rem'}}>📤 shared</span>}
              </div>
              {n.audio && <audio controls src={n.audio} style={{height:'32px',flex:1,minWidth:'180px',maxWidth:'300px'}} />}
              {n.duration&&<span style={{fontSize:'0.65rem',color:'var(--text3)'}}>{fmtTime(Math.round(n.duration))}</span>}
              <button onClick={()=>deleteNote(n.id)} title="Delete note"
                style={{background:'none',border:'none',cursor:'pointer',color:'#e84545',fontSize:'0.75rem',flexShrink:0,padding:'2px 4px'}}>✕</button>
            </div>
          ))}
        </div>
      )}

      {/* Recording controls */}
      {state === 'idle' && (
        <button onClick={startRecording}
          style={{display:'inline-flex',alignItems:'center',gap:'6px',padding:'6px 14px',background:'var(--bg2)',border:'1.5px solid var(--border)',borderRadius:'20px',cursor:'pointer',fontSize:'0.78rem',fontWeight:600,color:'var(--text2)'}}>
          <span style={{width:'10px',height:'10px',borderRadius:'50%',background:'#e84545',flexShrink:0,display:'inline-block'}} />
          Record Voice Note
        </button>
      )}

      {state === 'recording' && (
        <div style={{display:'flex',alignItems:'center',gap:'10px',flexWrap:'wrap'}}>
          <div style={{display:'flex',alignItems:'center',gap:'8px',padding:'6px 14px',background:'#e8454508',border:'1.5px solid #e84545',borderRadius:'20px',animation:'voicePulse 1.2s ease-in-out infinite'}}>
            <span style={{width:'10px',height:'10px',borderRadius:'50%',background:'#e84545',flexShrink:0,display:'inline-block'}} />
            <span style={{fontSize:'0.78rem',fontWeight:700,color:'#e84545'}}>Recording {fmtTime(timer)}</span>
          </div>
          <button onClick={stopRecording}
            style={{padding:'6px 14px',background:'#e84545',color:'#fff',border:'none',borderRadius:'20px',cursor:'pointer',fontSize:'0.78rem',fontWeight:700}}>
            ⏹ Stop
          </button>
          <style>{`@keyframes voicePulse{0%,100%{box-shadow:0 0 0 0 rgba(232,69,69,0.4)}50%{box-shadow:0 0 0 6px rgba(232,69,69,0)}}`}</style>
        </div>
      )}

      {state === 'recorded' && (
        <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
          <div style={{display:'flex',alignItems:'center',gap:'8px',flexWrap:'wrap'}}>
            <audio controls src={audioUrl} style={{height:'36px',flex:1,minWidth:'200px',maxWidth:'320px'}} />
            <span style={{fontSize:'0.72rem',color:'var(--text3)'}}>{fmtTime(duration)}</span>
          </div>
          <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
            <button onClick={save}
              style={{padding:'6px 16px',background:'#1db87a',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'0.78rem',fontWeight:700}}>
              💾 Save Note
            </button>
            <button onClick={startRecording}
              style={{padding:'6px 14px',background:'var(--bg3)',color:'var(--text2)',border:'1px solid var(--border)',borderRadius:'8px',cursor:'pointer',fontSize:'0.78rem',fontWeight:600}}>
              🎙️ Re-record
            </button>
            <button onClick={discard}
              style={{padding:'6px 14px',background:'none',color:'var(--text3)',border:'1px solid var(--border)',borderRadius:'8px',cursor:'pointer',fontSize:'0.78rem'}}>
              Discard
            </button>
          </div>
        </div>
      )}

      {state === 'saving' && (
        <div style={{fontSize:'0.78rem',color:'var(--text3)',fontStyle:'italic'}}>Saving voice note...</div>
      )}
    </div>
  );
}

// ── ApprovalCard — read-only view for Internal & Client Approval tabs ──
const ApprovalCard = React.memo(function ApprovalCard({
  wo, tab, sc,
  campaignTypes, platforms, outputFormats,
  selected, onToggleSel,
  onApproveInternal, onApproveClient, onRejectEntry, onSkipToClient,
  onAddRef, onDeleteRef,
  onSaveScript, onSaveVoiceNotes,
}) {
  const status      = sc?.approval_status || sc?.approvalStatus || 'Draft';
  const accentColor = tab === 'internal' ? '#e87830' : '#6c58f0';
  const d           = wo.event_date || wo.date || wo.scheduled_date || '';
  const cn          = clientName(wo.client);

  const [rejectReason,   setRejectReason]   = React.useState('');
  const [rejectError,    setRejectError]    = React.useState(false);
  const [shareVoiceNote, setShareVoiceNote] = React.useState(false);
  const [actionVoice,    setActionVoice]    = React.useState(null); // voice attached to current action

  const fmtDate = (dt) => { if(!dt) return '—'; const [y,m,day]=dt.split('-'); return `${day}-${m}-${y}`; };
  const dayName = (dt) => { if(!dt) return ''; return ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][new Date(dt+'T12:00:00').getDay()]; };

  const fmtKeyFn = (f) => f && f.platform ? `${f.platform} ${f.name||''}` : (f?.name||'');
  const woFmts = (() => {
    const raw = Array.isArray(wo.output_formats) ? wo.output_formats : [];
    return raw.map(v => {
      if (typeof v === 'number' || (typeof v === 'string' && /^\d+$/.test(v))) {
        const found = (outputFormats||[]).find(f => String(f.id) === String(v));
        return found ? fmtKeyFn(found) : null;
      }
      const asKey = (outputFormats||[]).find(f => fmtKeyFn(f) === v);
      if (asKey) return v;
      const byName = (outputFormats||[]).find(f => (f.name||'') === v);
      return byName ? fmtKeyFn(byName) : v;
    }).filter(Boolean);
  })();
  const woPlats = Array.isArray(wo.platforms) ? wo.platforms : [];
  const ct      = wo.campaign_type_id ? campaignTypes.find(x=>String(x.id)===String(wo.campaign_type_id)) : null;
  const wfName  = wo.workflow_type || ct?.name || null;
  const refs    = sc?.references || [];

  const FIELD_GRAD = {
    '📝 Caption':         {bg:'linear-gradient(135deg,#eff6ff 0%,#f0fdf4 100%)',border:'#bfdbfe'},
    '📄 Sub Caption':     {bg:'linear-gradient(135deg,#f5f3ff 0%,#eff6ff 100%)',border:'#ddd6fe'},
    '📋 Body Text':       {bg:'linear-gradient(135deg,#fff7ed 0%,#fffbeb 100%)',border:'#fed7aa'},
    '📢 Call to Action':  {bg:'linear-gradient(135deg,#fdf2f8 0%,#fce7f3 100%)',border:'#f9a8d4'},
    '🎨 Visual Direction':{bg:'linear-gradient(135deg,#f0fdf4 0%,#ecfdf5 100%)',border:'#a7f3d0'},
  };
  const Field = ({ label, value }) => {
    const g = FIELD_GRAD[label] || {bg:'var(--bg3)',border:'var(--border)'};
    return (
      <div>
        <div className="text-xs fw-700 text-muted" style={{marginBottom:'4px',textTransform:'uppercase',letterSpacing:'0.5px'}}>{label}</div>
        <div style={{padding:'8px 10px',background:g.bg,border:`1px solid ${g.border}`,borderRadius:'6px',fontSize:'0.82rem',whiteSpace:'pre-wrap',minHeight:'36px',color:value?'var(--text)':'var(--text3)',fontStyle:value?'normal':'italic'}}>
          {value || 'Not filled'}
        </div>
      </div>
    );
  };

  const handleReject = () => {
    if (!rejectReason.trim()) { setRejectError(true); return; }
    setRejectError(false);
    onRejectEntry(wo, rejectReason, actionVoice);
    setActionVoice(null);
  };

  const handleApprove = () => {
    if (tab === 'internal') onApproveInternal(wo, actionVoice);
    else onApproveClient(wo, actionVoice);
    setActionVoice(null);
  };


  return (
    <div style={{background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:10,marginBottom:'16px',overflow:'hidden',boxShadow:'0 1px 3px rgba(0,0,0,0.04)'}}>

      {/* ── Header ── */}
      <div style={{padding:'10px 16px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
        <input type="checkbox" checked={selected} onChange={()=>onToggleSel(wo.id)}
          style={{accentColor,width:'14px',height:'14px',cursor:'pointer',flexShrink:0}} />
        <span style={{fontWeight:700,color:'var(--accent)',fontSize:'0.85rem'}}>{wo.wo_number||`WO-${wo.id}`}</span>
        <span style={{padding:'2px 8px',background:'var(--accent)0d',border:'1px solid var(--accent)22',borderRadius:4,fontSize:'0.7rem',fontWeight:600,color:'var(--accent)'}}>{cn}</span>
        {d && <span style={{fontSize:'0.78rem',color:'var(--text3)',display:'flex',alignItems:'center',gap:4}}>
          <svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="3" width="12" height="11" rx="1.5"/><line x1="5" y1="1" x2="5" y2="4"/><line x1="11" y1="1" x2="11" y2="4"/><line x1="2" y1="7" x2="14" y2="7"/></svg>
          {dayName(d)}, {fmtDate(d)}
        </span>}
        {(wo.title||wo.day_name) && <span style={{fontWeight:600,fontSize:'0.88rem',color:'var(--text)'}}>{wo.title||wo.day_name}</span>}
        <div style={{marginLeft:'auto',display:'flex',alignItems:'center',gap:8}}>
          <span style={{padding:'3px 10px',background:`${accentColor}0d`,border:`1px solid ${accentColor}33`,borderRadius:4,fontSize:'0.7rem',fontWeight:600,color:accentColor}}>
            {tab==='internal' ? 'Pending Internal Review' : 'Pending Client Approval'}
          </span>
        </div>
      </div>

      {/* ── Two-column body ── */}
      <div style={{display:'grid',gridTemplateColumns:'1fr 260px',alignItems:'start'}}>

        {/* ── Left: content ── */}
        <div style={{borderRight:'1px solid var(--border)',padding:'16px 20px'}}>

          {/* Submission Date Bar */}
          {(()=>{
            const versions = sc?.versions || [];
            // Internal tab: find last time content was submitted
            // Client tab: find last time it was approved internally (= sent to client)
            const submittedVer = tab === 'internal'
              ? [...versions].reverse().find(v =>
                  ['Submitted','Internal Submitted','Draft Submitted','sent_internal'].includes(v.action)
                )
              : [...versions].reverse().find(v =>
                  ['Internal Approved','Approved Internal','Sent to Client','sent_client'].includes(v.action)
                );
            // Multi-level fallback for date
            const subDate = submittedVer?.at
              ? new Date(submittedVer.at)
              : tab === 'client' && sc?.internal_approved_at
                ? new Date(sc.internal_approved_at)
                : tab === 'internal' && sc?.submitted_at
                  ? new Date(sc.submitted_at)
                  : tab === 'internal' && sc?.updated_at
                    ? new Date(sc.updated_at)
                    : sc?.created_at
                      ? new Date(sc.created_at)
                      : null;
            const subBy = submittedVer?.by
              || (tab==='client' ? sc?.internal_approved_by : sc?.created_by_name)
              || '';
            const fmtSub = d => `${d.toLocaleDateString('en-IN',{weekday:'short',day:'2-digit',month:'short',year:'numeric'})} · ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')} ${d.getHours()>=12?'PM':'AM'}`;
            const bgColor    = tab==='internal' ? 'rgba(59,126,240,0.06)' : 'rgba(108,88,240,0.06)';
            const borderColor= tab==='internal' ? 'rgba(59,126,240,0.18)' : 'rgba(108,88,240,0.18)';
            const iconColor  = tab==='internal' ? '#3b7ef0' : '#6c58f0';
            const label      = tab==='internal' ? 'Submitted for Internal Review' : 'Sent to Client for Approval';
            return (
              <div style={{margin:'0 0 12px',padding:'8px 14px',background:bgColor,borderLeft:`3px solid ${iconColor}`,borderRadius:6,display:'flex',alignItems:'center',gap:10}}>
                <div style={{flex:1}}>
                  <div style={{fontSize:'0.65rem',fontWeight:600,color:iconColor,textTransform:'uppercase',letterSpacing:'0.4px',marginBottom:1}}>{label}</div>
                  {subDate ? (
                    <div style={{fontSize:'0.82rem',fontWeight:600,color:'var(--text)'}}>
                      {fmtSub(subDate)}
                      {subBy && <span style={{fontSize:'0.72rem',fontWeight:400,color:'var(--text3)',marginLeft:8}}>by {subBy}</span>}
                    </div>
                  ) : (
                    <div style={{fontSize:'0.76rem',color:'var(--text3)',fontStyle:'italic'}}>Submission date not recorded</div>
                  )}
                </div>
              </div>
            );
          })()}

          {/* Platforms + Formats strip */}
          <PlatformsFormatsStrip woPlats={woPlats} woFmts={woFmts} platforms={platforms} outputFormats={outputFormats} />

          {/* References — internal only */}
          {tab==='internal' && (
            <ReferencesBlock woId={wo.id} refs={refs} canEdit={false} onAdd={onAddRef} onDelete={onDeleteRef} />
          )}

          {/* Script fields — read-only */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:10}}>
            {[
              {label:'Caption (Main)',  color:'#3b7ef0', val:sc?.hook},
              {label:'Sub-Caption',     color:'#8b5cf6', val:sc?.message},
            ].map(f=>(
              <div key={f.label}>
                <div style={{display:'flex',alignItems:'center',gap:5,marginBottom:4}}>
                  <span style={{width:2,height:12,borderRadius:1,background:f.color,display:'inline-block',flexShrink:0}}/>
                  <span style={{fontSize:'0.68rem',fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.4px'}}>{f.label}</span>
                </div>
                <div style={{padding:'8px 10px',background:'var(--bg3)',border:'1px solid var(--border)',borderRadius:6,fontSize:'0.82rem',color:f.val?'var(--text)':'var(--text3)',fontStyle:f.val?'normal':'italic',minHeight:36}}>
                  {f.val||'Not filled'}
                </div>
              </div>
            ))}
          </div>

          <div style={{marginBottom:10}}>
            <div style={{display:'flex',alignItems:'center',gap:5,marginBottom:4}}>
              <span style={{width:2,height:12,borderRadius:1,background:'#f59e0b',display:'inline-block',flexShrink:0}}/>
              <span style={{fontSize:'0.68rem',fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.4px'}}>Body Text</span>
            </div>
            <div style={{padding:'8px 10px',background:'var(--bg3)',border:'1px solid var(--border)',borderRadius:6,fontSize:'0.82rem',color:sc?.script?'var(--text)':'var(--text3)',fontStyle:sc?.script?'normal':'italic',minHeight:48,whiteSpace:'pre-wrap'}}>
              {sc?.script||'Not filled'}
            </div>
          </div>

          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:12}}>
            {[
              {label:'Call to Action',   color:'#ec4899', val:sc?.cta},
              {label:'Visual Direction', color:'#14b8a6', val:sc?.visual},
            ].map(f=>(
              <div key={f.label}>
                <div style={{display:'flex',alignItems:'center',gap:5,marginBottom:4}}>
                  <span style={{width:2,height:12,borderRadius:1,background:f.color,display:'inline-block',flexShrink:0}}/>
                  <span style={{fontSize:'0.68rem',fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.4px'}}>{f.label}</span>
                </div>
                <div style={{padding:'8px 10px',background:'var(--bg3)',border:'1px solid var(--border)',borderRadius:6,fontSize:'0.82rem',color:f.val?'var(--text)':'var(--text3)',fontStyle:f.val?'normal':'italic',minHeight:36}}>
                  {f.val||'Not filled'}
                </div>
              </div>
            ))}
          </div>

          {/* Brand Details — read-only */}
          <BrandDetailsBlock key={wo.id} wo={wo} sc={sc} isReadOnly={true} onUpdate={()=>{}} />

          {/* Writer voice note */}
          {(()=>{
            const writerNotes = (sc?.voice_notes||[]).filter(n=>n.tab==='scripts');
            const latest = writerNotes[writerNotes.length-1];
            if (!latest) return null;
            if (tab==='client' && !latest.share_with_client) return null;
            return (
              <div style={{marginBottom:10,background:'var(--bg2)',border:'1.5px solid var(--border2)',borderRadius:10,overflow:'hidden'}}>
                <div style={{padding:'8px 14px',background:'var(--bg3)',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:8}}>
                  <div style={{width:24,height:24,borderRadius:6,background:'rgba(59,126,240,0.1)',border:'1px solid rgba(59,126,240,0.2)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                    <svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="#3b7ef0" strokeWidth="1.6" strokeLinecap="round"><rect x="5" y="1" width="6" height="9" rx="3"/><path d="M3 8a5 5 0 0010 0"/><line x1="8" y1="13" x2="8" y2="15"/><line x1="5" y1="15" x2="11" y2="15"/></svg>
                  </div>
                  <span style={{fontSize:'0.74rem',fontWeight:700,color:'#3b7ef0'}}>Writer's Voice Note</span>
                  {tab==='internal' && (
                    <label style={{display:'inline-flex',alignItems:'center',gap:5,marginLeft:'auto',padding:'3px 8px',background:latest.share_with_client?'rgba(22,163,74,0.1)':'var(--bg2)',border:'1px solid',borderColor:latest.share_with_client?'#16a34a':'var(--border)',borderRadius:6,cursor:'pointer'}}>
                      <input type="checkbox" checked={!!latest.share_with_client}
                        onChange={async e=>{const updated=(sc?.voice_notes||[]).map(n=>n.id===latest.id?{...n,share_with_client:e.target.checked}:n);await onSaveVoiceNotes(updated);}}
                        style={{accentColor:'var(--accent)',width:'13px',height:'13px',cursor:'pointer'}} />
                      <span style={{fontSize:'0.68rem',fontWeight:600,color:latest.share_with_client?'#16a34a':'var(--text2)',whiteSpace:'nowrap'}}>
                        {latest.share_with_client?'✓ Shared with client':'Share with client'}
                      </span>
                    </label>
                  )}
                </div>
                <div style={{padding:'10px 14px',display:'flex',alignItems:'center',gap:8}}>
                  <audio controls src={latest.audio} style={{height:'28px',flex:1,minWidth:140,maxWidth:280}} />
                  <span style={{fontSize:'0.62rem',color:'var(--text3)',fontFamily:'inherit'}}>{latest.at?new Date(latest.at).toLocaleDateString('en-IN',{day:'2-digit',month:'short',hour:'2-digit',minute:'2-digit'}):''}</span>
                </div>
              </div>
            );
          })()}

          {/* Reviewer voice note — internal only */}
          {tab==='internal' && (()=>{
            const lastWithVoice = [...(sc?.versions||[])].reverse().find(v=>v.voiceNote?.audio);
            if (!lastWithVoice) return null;
            return (
              <div style={{marginBottom:10,background:'var(--bg2)',border:'1.5px solid rgba(232,120,48,0.3)',borderRadius:10,overflow:'hidden'}}>
                <div style={{padding:'8px 14px',background:'rgba(232,120,48,0.05)',borderBottom:'1px solid rgba(232,120,48,0.2)',display:'flex',alignItems:'center',gap:8}}>
                  <span style={{fontSize:'0.74rem',fontWeight:700,color:'#e87830'}}>🎙 Latest Reviewer Feedback</span>
                  <span style={{fontSize:'0.68rem',color:'var(--text3)'}}>{lastWithVoice.action} · {lastWithVoice.by}</span>
                  <label style={{display:'inline-flex',alignItems:'center',gap:5,marginLeft:'auto',padding:'3px 8px',background:lastWithVoice.voiceNote.share_with_client?'rgba(22,163,74,0.1)':'var(--bg2)',border:'1px solid',borderColor:lastWithVoice.voiceNote.share_with_client?'#16a34a':'var(--border)',borderRadius:6,cursor:'pointer'}}>
                    <input type="checkbox" checked={!!lastWithVoice.voiceNote.share_with_client}
                      onChange={async e=>{const updated=(sc?.versions||[]).map(v=>v===lastWithVoice?{...v,voiceNote:{...v.voiceNote,share_with_client:e.target.checked}}:v);try{await api.put('/content-calendar/'+wo.id+'/script',{versions:updated});}catch(err){alert('Failed: '+err.message);}}}
                      style={{accentColor:'#e87830',width:'13px',height:'13px',cursor:'pointer'}} />
                    <span style={{fontSize:'0.68rem',fontWeight:600,color:lastWithVoice.voiceNote.share_with_client?'#16a34a':'var(--text2)',whiteSpace:'nowrap'}}>
                      {lastWithVoice.voiceNote.share_with_client?'✓ Shared':'Share with client'}
                    </span>
                  </label>
                </div>
                <div style={{padding:'10px 14px',display:'flex',alignItems:'center',gap:8}}>
                  <audio controls src={lastWithVoice.voiceNote.audio} style={{height:'28px',flex:1,minWidth:140,maxWidth:280}} />
                </div>
              </div>
            );
          })()}

          {/* Client shared note — client tab only */}
          {tab==='client' && (()=>{
            const shared=(sc?.voice_notes||[]).filter(n=>n.tab==='internal'&&n.share_with_client);
            const latest=shared[shared.length-1];
            if(!latest) return null;
            return (
              <div style={{marginBottom:10,background:'rgba(22,163,74,0.04)',border:'1.5px solid rgba(22,163,74,0.25)',borderRadius:10,overflow:'hidden'}}>
                <div style={{padding:'8px 14px',background:'rgba(22,163,74,0.06)',borderBottom:'1px solid rgba(22,163,74,0.15)'}}>
                  <span style={{fontSize:'0.74rem',fontWeight:700,color:'#16a34a'}}>📤 Note from Internal Team</span>
                </div>
                <div style={{padding:'10px 14px',display:'flex',alignItems:'center',gap:8}}>
                  <audio controls src={latest.audio} style={{height:'28px',flex:1,minWidth:140,maxWidth:280}} />
                  <span style={{fontSize:'0.62rem',color:'var(--text3)'}}>{latest.at?new Date(latest.at).toLocaleDateString('en-IN',{day:'2-digit',month:'short'}):''}</span>
                </div>
              </div>
            );
          })()}

          {/* Rejection reason */}
          <div style={{marginBottom:10}}>
            <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:5}}>
              <span style={{width:2,height:12,borderRadius:1,background:'#ef4444',display:'inline-block'}}/>
              <span style={{fontSize:'0.68rem',fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.4px'}}>Revision / Rejection Notes</span>
              <span style={{fontSize:'0.65rem',color:'var(--text3)',fontWeight:400}}>(required to reject)</span>
              <VoiceMicInline onResult={t=>setRejectReason(v=>(v+' '+t).trim())} />
            </div>
            <div>
              <input className="form-input" value={rejectReason}
                onChange={e=>{setRejectReason(e.target.value);setRejectError(false);}}
                placeholder="Describe what needs to change..."
                style={{fontSize:'0.82rem',borderColor:rejectError?'#ef4444':undefined}} />
              {rejectError && <div style={{fontSize:'0.7rem',color:'#ef4444',marginTop:4}}>⚠️ Please enter a reason before rejecting</div>}
            </div>
          </div>

          {/* Action Voice Recorder */}
          <div style={{marginBottom:10,fontSize:'0.66rem',color:'var(--text3)'}}>
            Optionally record a voice note — it will be attached to your Approve or Reject action
          </div>
          <ActionVoiceRecorder onAudioReady={setActionVoice} />

          {/* Action buttons */}
          <div style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'center',paddingTop:4}}>
            <button onClick={handleApprove}
              style={{display:'inline-flex',alignItems:'center',gap:6,padding:'7px 16px',fontSize:'0.8rem',fontWeight:600,background:'#16a34a',color:'#fff',border:'none',borderRadius:6,cursor:'pointer',transition:'all 0.15s',fontFamily:'inherit'}}
              onMouseOver={e=>e.currentTarget.style.opacity='0.9'}
              onMouseOut={e=>e.currentTarget.style.opacity='1'}>
              <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M2.5 8.5l3.5 3.5 7-7"/>
              </svg>
              {tab==='internal' ? <>Approve → Send to Client{actionVoice?' + Voice':''}</> : <>Approve{actionVoice?' + Voice':''}</>}
            </button>
            <button onClick={handleReject}
              style={{display:'inline-flex',alignItems:'center',gap:6,padding:'7px 14px',fontSize:'0.78rem',fontWeight:600,background:'var(--bg2)',color:'#ef4444',border:'1px solid rgba(239,68,68,0.25)',borderRadius:6,cursor:'pointer',transition:'all 0.15s',fontFamily:'inherit'}}
              onMouseOver={e=>{e.currentTarget.style.background='rgba(239,68,68,0.04)';}}
              onMouseOut={e=>{e.currentTarget.style.background='var(--bg2)';}}>
              ↩ Request Revision{actionVoice?' + Voice':''}
            </button>
            {tab==='internal' && (
              <button onClick={()=>onSkipToClient(wo)}
                style={{display:'inline-flex',alignItems:'center',gap:5,padding:'7px 12px',fontSize:'0.76rem',fontWeight:600,background:'var(--bg3)',color:'#6c58f0',border:'1px solid rgba(108,88,240,0.2)',borderRadius:6,cursor:'pointer',fontFamily:'inherit',transition:'all 0.15s'}}
                onMouseOver={e=>e.currentTarget.style.background='rgba(108,88,240,0.06)'}
                onMouseOut={e=>e.currentTarget.style.background='var(--bg3)'}>
                → Skip to Client
              </button>
            )}
          </div>

          {/* Version History */}
          <VersionHistory sc={sc} isClient={tab==='client'} />
        </div>

        {/* ── Right Panel ── */}
        <div style={{padding:'14px',display:'flex',flexDirection:'column',gap:14,background:'var(--bg3)'}}>

          {/* Publishing Summary */}
          <div>
            <div style={{fontSize:'0.68rem',fontWeight:600,color:'var(--text2)',textTransform:'uppercase',letterSpacing:'0.4px',marginBottom:8}}>Publishing Summary</div>
            {woPlats.length>0 && (
              <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:8}}>
                <span style={{fontSize:'0.68rem',color:'var(--text3)',minWidth:72}}>Platforms</span>
                <div style={{display:'flex',gap:4,flexWrap:'wrap'}}>
                  {woPlats.map(p=>(
                    <div key={p} title={p} style={{padding:'2px 6px',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:5,fontSize:'0.62rem',fontWeight:600,color:'var(--text2)'}}>
                      {p.slice(0,2).toUpperCase()}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {woFmts.length>0 && (
              <div style={{display:'flex',alignItems:'flex-start',gap:8,marginBottom:8}}>
                <span style={{fontSize:'0.68rem',color:'var(--text3)',minWidth:72,paddingTop:2}}>Formats</span>
                <div style={{display:'flex',gap:3,flexWrap:'wrap'}}>
                  {woFmts.map((f,i)=>(
                    <span key={i} style={{padding:'2px 6px',background:'rgba(108,88,240,0.08)',border:'1px solid rgba(108,88,240,0.2)',borderRadius:8,fontSize:'0.6rem',fontWeight:600,color:'var(--accent2)'}}>
                      {f.length>18?f.slice(0,16)+'…':f}
                    </span>
                  ))}
                </div>
              </div>
            )}
            {wfName && (
              <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:6}}>
                <span style={{fontSize:'0.68rem',color:'var(--text3)',minWidth:72}}>Campaign</span>
                <span style={{fontSize:'0.72rem',color:'var(--text2)',fontWeight:500}}>{wfName}</span>
              </div>
            )}
            <div style={{display:'flex',alignItems:'center',gap:8}}>
              <span style={{fontSize:'0.68rem',color:'var(--text3)',minWidth:72}}>Client</span>
              <span style={{fontSize:'0.72rem',color:'var(--text2)',fontWeight:500}}>{cn}</span>
            </div>
          </div>

          <div style={{height:1,background:'var(--border)'}}/>

          {/* Approval Workflow */}
          <div>
            <div style={{fontSize:'0.68rem',fontWeight:600,color:'var(--text2)',textTransform:'uppercase',letterSpacing:'0.4px',marginBottom:8}}>Approval Workflow</div>
            {[
              {n:1, label:'Internal Approval',
               sub: tab==='internal' ? 'Pending your review'
                  : tab==='client'   ? 'Completed'           // client sees no names
                  : 'Approved',
               done: tab!=='internal', active: tab==='internal'},
              ...(tab==='client' ? [
                {n:2, label:'Client Approval', sub:'Pending your review', done:false, active:true},
                {n:3, label:'Final Approved',  sub:'Ready for scheduling', done:false, active:false},
              ] : [
                {n:2, label:'Client Approval', sub:'Next after your approval', done:false, active:false},
                {n:3, label:'Final Approved',  sub:'Ready for scheduling',     done:false, active:false},
              ]),
            ].map((step,si)=>(
              <div key={step.n} style={{display:'flex',alignItems:'flex-start',gap:8,marginBottom:si<2?12:0,position:'relative'}}>
                {si<2 && <div style={{position:'absolute',left:10,top:22,width:1.5,height:14,background:'var(--border)'}}/>}
                <div style={{width:22,height:22,borderRadius:'50%',flexShrink:0,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'0.65rem',fontWeight:800,
                  background:step.done?'#22c47a':step.active?accentColor:'var(--bg4)',
                  color:step.done||step.active?'#fff':'var(--text3)',
                  border:step.done||step.active?'none':'1.5px solid var(--border2)'}}>
                  {step.done?'✓':step.n}
                </div>
                <div style={{flex:1,paddingTop:1}}>
                  <div style={{fontSize:'0.76rem',fontWeight:600,color:step.done?'#22c47a':step.active?accentColor:'var(--text2)'}}>{step.label}</div>
                  <div style={{fontSize:'0.66rem',color:'var(--text3)',marginTop:1}}>{step.sub}</div>
                </div>
              </div>
            ))}
          </div>

          <div style={{height:1,background:'var(--border)'}}/>

          {/* Version History */}
          {(()=>{
            const versions = tab==='client'
              ? (sc?.versions||[]).filter(v => {
                  const stage = v.stage || 'internal';
                  const action = v.action || '';
                  if (stage !== 'client') return false;
                  if (['Internal Approved', 'Client Approved'].includes(action)) return true;
                  if (action === 'Rejected' && stage === 'client') return true;
                  if (action === 'Revision Requested' && stage === 'client') return true;
                  if (action === 'Internal Submitted') return false;
                  return false;
                })
              : (sc?.versions||[]);
            if (!versions.length) return null;
            return (
              <div>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
                  <span style={{fontSize:'0.68rem',fontWeight:600,color:'var(--text2)',textTransform:'uppercase',letterSpacing:'0.4px'}}>Version History</span>
                  <span style={{fontSize:'0.62rem',color:'var(--text3)'}}>{versions.length} submission{versions.length!==1?'s':''}</span>
                </div>
                {[...versions].reverse().slice(0,4).map((v,i)=>{
                  const clientLabelMap = {'Internal Approved':'Sent for Your Review','Internal Submitted':'Sent for Review','Rejected':'Revision Requested'};
                  const vLabel = (tab==='client' && clientLabelMap[v.action]) ? clientLabelMap[v.action] : (v.action||'?');
                  const vColor = ['Internal Approved','Sent for Your Review'].includes(vLabel)?'#6c58f0':['Client Approved'].includes(vLabel)?'#22c47a':['Rejected','Revision Requested'].includes(vLabel)?'var(--red)':'var(--accent)';
                  const vDate=v.at?new Date(v.at):null;
                  const vFmt=vDate?`${String(vDate.getDate()).padStart(2,'0')} ${vDate.toLocaleString('en-IN',{month:'short'})} ${vDate.getFullYear()}, ${String(vDate.getHours()).padStart(2,'0')}:${String(vDate.getMinutes()).padStart(2,'0')} ${vDate.getHours()>=12?'PM':'AM'}`:'';
                  return (
                    <div key={i} style={{display:'flex',alignItems:'flex-start',gap:8,marginBottom:10}}>
                      <div style={{width:8,height:8,borderRadius:'50%',background:vColor,flexShrink:0,marginTop:5}}/>
                      <div style={{flex:1}}>
                        <div style={{fontSize:'0.7rem',fontWeight:600,color:vColor}}>{vLabel}</div>
                        {v.by&&<div style={{fontSize:'0.62rem',color:'var(--text3)'}}>by {v.by}</div>}
                        {vFmt&&<div style={{fontSize:'0.6rem',color:'var(--text3)',fontFamily:'inherit'}}>{vFmt}</div>}
                        {v.rejectionReason&&<div style={{fontSize:'0.62rem',color:'var(--red)',marginTop:2}}>↩ {v.rejectionReason}</div>}
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })()}
        </div>
      </div>
    </div>
  );
});


// ── InlineScriptVoice — auto-saves when recording stops, no Save button ──
function InlineScriptVoice({ voiceNotes, onSaved }) {
  const [state,   setState]   = React.useState('idle'); // idle|recording|saving
  const [timer,   setTimer]   = React.useState(0);
  const [localNotes, setLocalNotes] = React.useState(voiceNotes||[]); // local copy for instant UI update
  const mediaRef  = React.useRef(null);
  const chunksRef = React.useRef([]);
  const timerRef  = React.useRef(null);
  const fmtTime   = s => `${Math.floor(s/60)}:${String(s%60).padStart(2,'0')}`;

  // Sync localNotes when voiceNotes prop changes (after reload from server)
  React.useEffect(() => { setLocalNotes(voiceNotes||[]); }, [voiceNotes]);

  const allNotes   = localNotes.filter(n => n.tab === 'scripts');
  const latestNote = allNotes.length > 0 ? allNotes[allNotes.length - 1] : null;

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream, {
        mimeType: MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' : 'audio/ogg'
      });
      chunksRef.current = [];
      mr.ondataavailable = e => { if (e.data.size > 0) chunksRef.current.push(e.data); };
      mr.onstop = () => {
        stream.getTracks().forEach(t => t.stop());
        const blob = new Blob(chunksRef.current, { type: mr.mimeType });
        clearInterval(timerRef.current);
        setState('saving');
        const reader = new FileReader();
        reader.onload = async ev => {
          try {
            const note = {
              id: Date.now().toString(), tab: 'scripts', by: 'Me',
              at: new Date().toISOString(), audio: ev.target.result,
              duration: timer, share_with_client: false, // Internal approver decides sharing
            };
            const updated = [...(voiceNotes||[]), note];
            setLocalNotes(updated); // Instant UI update — no page refresh needed
            await onSaved(updated); // Save to server
          } catch(e) { alert('Save failed: ' + e.message); }
          finally { setState('idle'); setTimer(0); }
        };
        reader.readAsDataURL(blob);
      };
      mr.start();
      mediaRef.current = mr;
      setState('recording');
      setTimer(0);
      timerRef.current = setInterval(() => setTimer(t => t + 1), 1000);
    } catch(e) { alert('Microphone access denied.'); setState('idle'); }
  };

  const stop = () => { mediaRef.current?.stop(); clearInterval(timerRef.current); };

  const deleteNote = async (id) => {
    if (!window.confirm('Delete this voice note?')) return;
    const updated = (voiceNotes||[]).filter(n => n.id !== id);
    setLocalNotes(updated);
    await onSaved(updated);
  };

  return (
    <div style={{marginBottom:'12px',background:'var(--bg2)',border:'1.5px solid var(--border2)',borderRadius:'10px',overflow:'hidden'}}>
      {/* Header */}
      <div style={{display:'flex',alignItems:'center',gap:8,padding:'8px 14px',background:'var(--bg3)',borderBottom:'1px solid var(--border)'}}>
        <div style={{width:28,height:28,borderRadius:7,background:'rgba(239,68,68,0.08)',border:'1px solid rgba(239,68,68,0.2)',display:'flex',alignItems:'center',justifyContent:'center'}}>
          <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="#ef4444" strokeWidth="1.6" strokeLinecap="round"><rect x="5" y="1" width="6" height="9" rx="3"/><path d="M3 8a5 5 0 0010 0"/><line x1="8" y1="13" x2="8" y2="15"/><line x1="5" y1="15" x2="11" y2="15"/></svg>
        </div>
        <div>
          <span style={{fontSize:'0.76rem',fontWeight:700,color:'var(--text)'}}>Voice Note</span>
          <span style={{fontSize:'0.67rem',color:'var(--text3)',fontWeight:400,marginLeft:6}}>(Optional)</span>
        </div>
        <span style={{fontSize:'0.65rem',color:'var(--text3)',marginLeft:'auto',fontStyle:'italic'}}>Visible to internal approver · approver decides if it goes to client</span>
      </div>
      {/* Body */}
      <div style={{padding:'10px 14px'}}>
        {latestNote && (
          <div style={{marginBottom:'8px',display:'flex',alignItems:'center',gap:'8px',flexWrap:'wrap',padding:'6px 10px',background:'rgba(239,68,68,0.04)',border:'1px solid rgba(239,68,68,0.15)',borderRadius:'8px'}}>
            <div style={{width:6,height:6,borderRadius:'50%',background:'#ef4444',flexShrink:0,animation:'voicePulse 2s infinite'}}/>
            <audio controls src={latestNote.audio} style={{height:'28px',flex:1,minWidth:'140px',maxWidth:'260px'}} />
            <span style={{fontSize:'0.62rem',color:'var(--text3)',fontFamily:'inherit'}}>{latestNote.at?new Date(latestNote.at).toLocaleDateString('en-IN',{day:'2-digit',month:'short',hour:'2-digit',minute:'2-digit'}):''}</span>
            <button onClick={()=>deleteNote(latestNote.id)} title="Delete" style={{background:'none',border:'none',color:'#ef4444',cursor:'pointer',fontSize:'0.75rem',padding:'0 2px'}}>✕</button>
            {allNotes.length > 1 && <span style={{fontSize:'0.6rem',color:'var(--text3)',fontStyle:'italic'}}>{allNotes.length-1} older saved</span>}
          </div>
        )}
        {state==='idle' && (
          <button onClick={start} style={{display:'inline-flex',alignItems:'center',gap:'8px',padding:'6px 14px',background:'var(--bg3)',border:'1.5px dashed var(--border2)',borderRadius:'8px',cursor:'pointer',fontSize:'0.74rem',fontWeight:600,color:'var(--text2)',transition:'all 0.15s'}}
            onMouseOver={e=>{e.currentTarget.style.borderColor='#ef4444';e.currentTarget.style.color='#ef4444';e.currentTarget.style.background='rgba(239,68,68,0.04)';}}
            onMouseOut={e=>{e.currentTarget.style.borderColor='var(--border2)';e.currentTarget.style.color='var(--text2)';e.currentTarget.style.background='var(--bg3)';}}>
            <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"><rect x="5" y="1" width="6" height="9" rx="3"/><path d="M3 8a5 5 0 0010 0"/><line x1="8" y1="13" x2="8" y2="15"/><line x1="5" y1="15" x2="11" y2="15"/></svg>
            {latestNote ? 'Record Another Voice Note' : 'Record Voice Note'}
          </button>
        )}
        {state==='recording' && (
          <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
            <div style={{display:'flex',alignItems:'center',gap:'6px',padding:'6px 14px',background:'rgba(239,68,68,0.08)',border:'1px solid #ef4444',borderRadius:'8px'}}>
              <span style={{width:'8px',height:'8px',borderRadius:'50%',background:'#ef4444',display:'inline-block',animation:'voicePulse 1s infinite'}} />
              <span style={{fontSize:'0.74rem',fontWeight:700,color:'#ef4444'}}>Recording {fmtTime(timer)}</span>
            </div>
            <button onClick={stop} style={{padding:'6px 14px',background:'#ef4444',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'0.74rem',fontWeight:700}}>⏹ Stop & Save</button>
          </div>
        )}
        {state==='saving' && <span style={{fontSize:'0.72rem',color:'var(--text3)',fontStyle:'italic'}}>Saving…</span>}
      </div>
    </div>
  );
}


// ── BrandDetailsBlock — expanded by default, blue-green gradient bg ──
function BrandDetailsBlock({ wo, sc, isReadOnly, onUpdate }) {
  const client = wo.client && typeof wo.client === 'object' ? wo.client : {};
  const [website, setWebsite] = React.useState(() => sc?.brand_website || client.website || '');
  const [email,   setEmail]   = React.useState(() => sc?.brand_email   || client.email   || '');
  const [phone,   setPhone]   = React.useState(() => sc?.brand_phone   || client.phone   || '');
  const [address, setAddress] = React.useState(() => sc?.brand_address || client.address || '');
  const woIdRef = React.useRef(wo.id);
  React.useEffect(() => {
    if (wo.id !== woIdRef.current) {
      woIdRef.current = wo.id;
      setWebsite(sc?.brand_website || client.website || '');
      setEmail(sc?.brand_email     || client.email   || '');
      setPhone(sc?.brand_phone     || client.phone   || '');
      setAddress(sc?.brand_address || client.address || '');
    }
  }, [wo.id]);
  const upd = (field, val) => { if (!isReadOnly && onUpdate) onUpdate(wo.id, field, val); };
  return (
    <div style={{marginBottom:'12px',padding:'10px 14px',background:'var(--bg3)',border:'1px solid var(--border)',borderRadius:8}}>
      <div style={{fontSize:'0.68rem',fontWeight:600,color:'var(--text2)',textTransform:'uppercase',letterSpacing:'0.4px',marginBottom:'8px'}}>
        Brand Details
        <span style={{fontWeight:400,fontSize:'0.62rem',color:'var(--text3)',marginLeft:'6px',textTransform:'none',letterSpacing:0}}>Pre-filled from client · edit to override for this post</span>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px'}}>
        {[
          {label:'🌐 Website',    val:website,  set:setWebsite, field:'brand_website', ph:client.website||'www.example.com'},
          {label:'✉️ Email',      val:email,    set:setEmail,   field:'brand_email',   ph:client.email  ||'info@example.com'},
          {label:'📞 Contact No', val:phone,    set:setPhone,   field:'brand_phone',   ph:client.phone  ||'+91 00000 00000'},
          {label:'📍 Address',    val:address,  set:setAddress, field:'brand_address', ph:client.address||'Full address'},
        ].map(({label,val,set,field,ph})=>(
          <div key={field} className="form-group" style={{margin:0}}>
            <label className="form-label" style={{fontSize:'0.65rem',color:'#334155'}}>{label}</label>
            <input className="form-input" value={val} readOnly={isReadOnly}
              placeholder={ph}
              style={{background:isReadOnly?'rgba(255,255,255,0.6)':'#fff',fontSize:'0.82rem'}}
              onChange={e=>{set(e.target.value);upd(field,e.target.value);}} />
          </div>
        ))}
      </div>
    </div>
  );
}

// ── EntryCard — OUTSIDE main component to fix cursor bug ──
const EntryCard = React.memo(function EntryCard({
  wo, tab, sc,
  campaignTypes, platforms, outputFormats,
  selected, onToggleSel,
  onSave, onSubmitInternal, onApproveInternal, onApproveClient, onRejectEntry, onSkipToClient,
  onUpdateScript, onUpdatePlatforms, onUpdateFormats, onUpdateWorkflowType,
  onAddRef, onDeleteRef,
  onSaveVoiceNotes,
  saving,
  onActivate, isActive,
}) {
  const status   = sc?.approval_status || sc?.approvalStatus || 'Draft';
  const isReadOnly = status === 'Approved'
    || (tab === 'internal' && status === 'Pending Internal')
    || (tab === 'client'   && status === 'Pending Client');
  const canApprove = !isReadOnly || status === 'Pending Internal' || status === 'Pending Client';
  const isRejected = status === 'Rejected';
  const d  = wo.event_date || wo.date || wo.scheduled_date || '';
  const sd = wo.phase_start_date || wo.scheduling_date || '';
  const phaseDeadline = wo.phase_deadline || wo.event_date || wo.date || '';
  const cn = clientName(wo.client);
  const [rejectReason, setRejectReason] = useState('');
  const [showPlatEdit, setShowPlatEdit] = useState(false);
  const [showFmtEdit,  setShowFmtEdit]  = useState(false);
  const [showWfEdit,   setShowWfEdit]   = useState(false);
  const [pubOpen,      setPubOpen]      = useState(false);
  const [localPlats,   setLocalPlats]   = useState(null);
  const [voiceLang,    setVoiceLang]    = useState(getVoiceLang);

  

  const fmtDate = (dt) => { if(!dt) return '—'; const [y,m,day]=dt.split('-'); return `${day}-${m}-${y}`; };
  const dayName = (dt) => { if(!dt) return ''; return ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][new Date(dt+'T12:00:00').getDay()]; };

  const woPlats   = Array.isArray(wo.platforms) ? wo.platforms : [];
  // Convert to platform+name keys — handles legacy IDs, legacy name-only, and current platform+name
  const fmtKeyFn = (f) => f && f.platform ? `${f.platform} ${f.name||''}` : (f?.name||'');
  const woFmts = (() => {
    const raw = Array.isArray(wo.output_formats) ? wo.output_formats : [];
    return raw.map(v => {
      if (typeof v === 'number' || (typeof v === 'string' && /^\d+$/.test(v))) {
        // Legacy ID
        const found = (outputFormats||[]).find(f => String(f.id) === String(v));
        return found ? fmtKeyFn(found) : null;
      }
      // Check if it's already a platform+name key (contains a space after platform name)
      const asName = (outputFormats||[]).find(f => fmtKeyFn(f) === v);
      if (asName) return v; // already correct format
      // Legacy name-only — find matching format
      const byName = (outputFormats||[]).find(f => (f.name||'') === v);
      return byName ? fmtKeyFn(byName) : v;
    }).filter(Boolean);
  })();
  const ct        = wo.campaign_type_id ? campaignTypes.find(x=>String(x.id)===String(wo.campaign_type_id)) : null;
  const wfName    = wo.workflow_type || ct?.name || null;
  const refs      = sc?.references || [];

  return (
    <div style={{background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:10,marginBottom:'16px',overflow:'hidden',boxShadow:'0 1px 3px rgba(0,0,0,0.04)'}}>

      {/* ── Header ── */}
      <div style={{padding:'10px 16px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
        {!isReadOnly && (
          <input type="checkbox" checked={selected} onChange={()=>onToggleSel(wo.id)}
            style={{accentColor:'#6c58f0',width:'14px',height:'14px',cursor:'pointer',flexShrink:0}} />
        )}
        <span style={{fontWeight:700,color:'var(--accent)',fontSize:'0.85rem'}}>{wo.wo_number||`WO-${wo.id}`}</span>
        <span style={{padding:'2px 8px',background:'var(--accent)0d',border:'1px solid var(--accent)22',borderRadius:4,fontSize:'0.7rem',fontWeight:600,color:'var(--accent)'}}>{cn}</span>
        {d && <span style={{fontSize:'0.78rem',color:'var(--text3)',display:'flex',alignItems:'center',gap:4}}>
          <svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="3" width="12" height="11" rx="1.5"/><line x1="5" y1="1" x2="5" y2="4"/><line x1="11" y1="1" x2="11" y2="4"/><line x1="2" y1="7" x2="14" y2="7"/></svg>
          {dayName(d)}, {fmtDate(d)}
        </span>}
        {(wo.title||wo.day_name) && <span style={{fontWeight:600,fontSize:'0.88rem',color:'var(--text)'}}>{wo.title||wo.day_name}</span>}
        <div style={{marginLeft:'auto',display:'flex',alignItems:'center',gap:8}}>
          <span style={{padding:'3px 10px',background:`${STATUS_COLORS[status]||'var(--text3)'}0d`,border:`1px solid ${STATUS_COLORS[status]||'var(--border)'}33`,borderRadius:4,fontSize:'0.7rem',fontWeight:600,color:STATUS_COLORS[status]||'var(--text3)'}}>
            {STATUS_ICONS[status]||''} {status||'Draft'}
          </span>
        </div>
      </div>

      {/* ── Two-column body ── */}
      <div style={{display:'grid',gridTemplateColumns:'1fr 260px',alignItems:'start'}}>
        <div style={{borderRight:'1px solid var(--border)',minWidth:0}}>

      {/* ── Body ── */}
      <div style={{padding:'16px 20px'}}>

        {/* Stage Schedule / Approval Date Banner */}
        <StageDateBanner schedulingDate={sd} eventDate={phaseDeadline} tab={tab} sc={sc} wo={wo} />

        {/* Workflow Type + Platforms + Output Formats — editable badges */}
        <div style={{display:'flex',gap:'8px',marginBottom:'12px',flexWrap:'wrap',alignItems:'center'}}>

          {/* Workflow Type */}
          <div style={{position:'relative'}}>
            <span onClick={()=>{if(!isReadOnly){setShowWfEdit(v=>!v);setShowPlatEdit(false);setShowFmtEdit(false);}}}
              title={isReadOnly?wfName:'Click to change Workflow Type'}
              style={{display:'inline-flex',alignItems:'center',gap:'5px',padding:'3px 10px',
                background:wfName?'var(--accent)11':'#e8783011',
                border:wfName?'1px solid var(--accent)33':'1.5px dashed #e87830',
                borderRadius:'10px',fontSize:'0.72rem',fontWeight:600,
                color:wfName?'var(--accent)':'#e87830',cursor:isReadOnly?'default':'pointer'}}>
              {wfName?`🎯 ${wfName}`:'⚠️ Workflow Type not set'}
              {!isReadOnly&&<span style={{fontSize:'0.62rem',opacity:0.6}}>✎</span>}
            </span>
            {showWfEdit && !isReadOnly && (
              <div style={{position:'absolute',top:'100%',left:0,marginTop:'4px',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:'8px',boxShadow:'0 8px 24px rgba(0,0,0,0.2)',zIndex:100,minWidth:'200px',padding:'8px'}}>
                {campaignTypes.filter(x=>x.enabled!==false&&x.is_active!==false).map(ct=>(
                  <div key={ct.id} onClick={()=>{onUpdateWorkflowType(wo.id,ct.id,ct.name);setShowWfEdit(false);}}
                    style={{padding:'6px 10px',borderRadius:'6px',cursor:'pointer',fontSize:'0.8rem',fontWeight:500,color:'var(--text)',background:String(wo.campaign_type_id)===String(ct.id)?'var(--accent)11':'transparent'}}>
                    🎯 {ct.name}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Platforms */}
          <div style={{position:'relative'}}>
            <span onClick={()=>{if(!isReadOnly){setShowPlatEdit(v=>!v);setShowWfEdit(false);setShowFmtEdit(false);setLocalPlats(woPlats);}}}
              title={isReadOnly?undefined:'Click to edit Platforms'}
              style={{display:'inline-flex',alignItems:'center',gap:'5px',padding:'3px 10px',
                background:woPlats.length?'#3b7ef011':'#e8783011',
                border:woPlats.length?'1px solid #3b7ef033':'1.5px dashed #e87830',
                borderRadius:'10px',fontSize:'0.72rem',fontWeight:600,
                color:woPlats.length?'#3b7ef0':'#e87830',cursor:isReadOnly?'default':'pointer'}}>
              {woPlats.length?`📱 ${woPlats.length} platform${woPlats.length!==1?'s':''}`:'⚠️ Platforms not set'}
              {!isReadOnly&&<span style={{fontSize:'0.62rem',opacity:0.6}}>✎</span>}
            </span>
            {showPlatEdit && !isReadOnly && (
              <div style={{position:'absolute',top:'100%',left:0,marginTop:'4px',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:'8px',boxShadow:'0 8px 24px rgba(0,0,0,0.2)',zIndex:100,width:'280px',padding:'10px'}}>
                <div style={{fontSize:'0.72rem',fontWeight:700,color:'var(--text3)',marginBottom:'8px'}}>Select Platforms</div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'5px',marginBottom:'10px'}}>
                  {(platforms||[]).filter(p=>p.enabled!==false&&p.is_active!==false).map(p=>{
                    const checked=(localPlats||[]).includes(p.name);
                    return (
                      <label key={p.id} style={{display:'flex',alignItems:'center',gap:'6px',padding:'5px 8px',border:`1px solid ${checked?'var(--accent)':'var(--border)'}`,borderRadius:'6px',cursor:'pointer',fontSize:'0.75rem',background:checked?'var(--accent)0f':'var(--bg3)'}}>
                        <input type="checkbox" checked={checked} onChange={()=>setLocalPlats(prev=>(prev||[]).includes(p.name)?(prev||[]).filter(x=>x!==p.name):[...(prev||[]),p.name])}
                          style={{accentColor:'var(--accent)',width:'13px',height:'13px',flexShrink:0}} />
                        {p.name}
                      </label>
                    );
                  })}
                </div>
                <div style={{display:'flex',gap:'6px',justifyContent:'flex-end'}}>
                  <button onClick={()=>setShowPlatEdit(false)} className="btn btn-secondary" style={{fontSize:'0.72rem',padding:'4px 10px'}}>Cancel</button>
                  <button onClick={()=>{onUpdatePlatforms(wo.id,localPlats||[]);setShowPlatEdit(false);}} className="btn btn-primary" style={{fontSize:'0.72rem',padding:'4px 10px'}}>Save</button>
                </div>
              </div>
            )}
          </div>

          {/* Output Formats */}
          <div style={{position:'relative'}}>
            <span onClick={()=>{if(!isReadOnly){setShowFmtEdit(v=>!v);setShowWfEdit(false);setShowPlatEdit(false);}}}
              title={isReadOnly?undefined:'Click to edit Output Formats'}
              style={{display:'inline-flex',alignItems:'center',gap:'5px',padding:'3px 10px',
                background:woFmts.length?'#1db87a11':'#e8783011',
                border:woFmts.length?'1px solid #1db87a33':'1.5px dashed #e87830',
                borderRadius:'10px',fontSize:'0.72rem',fontWeight:600,
                color:woFmts.length?'#1db87a':'#e87830',cursor:isReadOnly?'default':'pointer'}}>
              {woFmts.length?`📐 ${woFmts.length} format${woFmts.length!==1?'s':''}`:'⚠️ Output Formats not set'}
              {!isReadOnly&&<span style={{fontSize:'0.62rem',opacity:0.6}}>✎</span>}
            </span>
            {showFmtEdit && !isReadOnly && (
              <OutputFormatsDropdown
                outputFormats={outputFormats}
                selected={woFmts}
                onChange={fmts=>onUpdateFormats(wo.id,fmts)}
                onClose={()=>setShowFmtEdit(false)}
              />
            )}
          </div>
        </div>

        {/* Rejection notice */}
        {isRejected && sc?.rejection_reason && (
          <div style={{padding:'8px 12px',background:'rgba(232,69,69,0.08)',border:'1px solid rgba(232,69,69,0.2)',borderRadius:'6px',fontSize:'0.78rem',color:'#e84545',marginBottom:'10px'}}>
            ↩ Rejected: {sc.rejection_reason}
          </div>
        )}

        {/* Voice input bar with language selector */}
        {!isReadOnly && (
          <div style={{display:'flex',alignItems:'center',gap:'8px',padding:'8px 12px',background:'var(--bg3)',border:'1px solid var(--border)',borderRadius:'8px',marginBottom:'12px',flexWrap:'wrap'}}>
            <span style={{fontSize:'0.68rem',fontWeight:600,color:'var(--text3)',letterSpacing:'0.4px'}}>VOICE INPUT</span>
            <VoiceLangBar lang={voiceLang} onLangChange={setVoiceLang} />
            <span style={{fontSize:'0.68rem',color:'var(--text3)',marginLeft:'auto'}}>Click 🎙️ to START · click again to STOP &amp; insert text</span>
          </div>
        )}

        {/* Script fields */}
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'10px'}}>
          <div style={{margin:0}}>
            <label style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:5}}>
              <span style={{fontSize:'0.68rem',fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.4px',display:'flex',alignItems:'center',gap:5}}>
                <span style={{width:2,height:12,borderRadius:1,background:'#3b7ef0',display:'inline-block'}}/>
                Caption (Main)
              </span>
              {!isReadOnly && <VoiceMicBtn lang={voiceLang} fieldLabel="Caption" onResult={t=>onUpdateScript(wo.id,'hook',(sc?.hook||'')+' '+t)} />}
            </label>
            <div style={{position:'relative'}}>
              <input id={`cc-hook-${wo.id}`} className="form-input" value={sc?.hook||''} readOnly={isReadOnly}
                placeholder="Enter your main caption / headline text..."
                style={{background:'var(--bg2)',borderColor:'var(--border2)',paddingBottom:20}}
                onChange={e=>onUpdateScript(wo.id,'hook',e.target.value)} />
              <span style={{position:'absolute',bottom:5,right:8,fontSize:'0.62rem',color:'var(--text3)',fontFamily:'inherit'}}>{(sc?.hook||'').length} / 220</span>
            </div>
          </div>
          <div style={{margin:0}}>
            <label style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:5}}>
              <span style={{fontSize:'0.68rem',fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.4px',display:'flex',alignItems:'center',gap:5}}>
                <span style={{width:2,height:12,borderRadius:1,background:'#8b5cf6',display:'inline-block'}}/>
                Sub-Caption
              </span>
              {!isReadOnly && <VoiceMicBtn lang={voiceLang} fieldLabel="Sub Caption" onResult={t=>onUpdateScript(wo.id,'message',(sc?.message||'')+' '+t)} />}
            </label>
            <div style={{position:'relative'}}>
              <input id={`cc-message-${wo.id}`} className="form-input" value={sc?.message||''} readOnly={isReadOnly}
                placeholder="Enter supporting sub-caption text..."
                style={{background:'var(--bg2)',borderColor:'var(--border2)',paddingBottom:20}}
                onChange={e=>onUpdateScript(wo.id,'message',e.target.value)} />
              <span style={{position:'absolute',bottom:5,right:8,fontSize:'0.62rem',color:'var(--text3)',fontFamily:'inherit'}}>{(sc?.message||'').length} / 220</span>
            </div>
          </div>
        </div>

        <div style={{marginBottom:'10px'}}>
          <label style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:5}}>
            <span style={{fontSize:'0.68rem',fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.4px',display:'flex',alignItems:'center',gap:5}}>
              <span style={{width:2,height:12,borderRadius:1,background:'#f59e0b',display:'inline-block'}}/>
              Body Text
            </span>
            {!isReadOnly && <VoiceMicBtn lang={voiceLang} fieldLabel="Body Text" onResult={t=>onUpdateScript(wo.id,'script',(sc?.script?sc.script+'\n':'')+t)} />}
          </label>
          <div style={{position:'relative'}}>
            <textarea id={`cc-script-${wo.id}`} className="form-textarea" readOnly={isReadOnly}
              value={sc?.script||''} placeholder="Write your full post body text — description, details, hashtags..."
              style={{minHeight:'90px',background:'var(--bg2)',borderColor:'var(--border2)',paddingBottom:22}}
              onChange={e=>onUpdateScript(wo.id,'script',e.target.value)} />
            <span style={{position:'absolute',bottom:7,right:8,fontSize:'0.62rem',color:'var(--text3)',fontFamily:'inherit'}}>{(sc?.script||'').length} / 2000</span>
          </div>
        </div>

        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'12px'}}>
          <div style={{margin:0}}>
            <label style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:5}}>
              <span style={{fontSize:'0.68rem',fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.4px',display:'flex',alignItems:'center',gap:5}}>
                <span style={{width:2,height:12,borderRadius:1,background:'#ec4899',display:'inline-block'}}/>
                Call to Action
              </span>
              {!isReadOnly && <VoiceMicBtn lang={voiceLang} fieldLabel="Call to Action" onResult={t=>onUpdateScript(wo.id,'cta',(sc?.cta||'')+' '+t)} />}
            </label>
            <div style={{position:'relative'}}>
              <input id={`cc-cta-${wo.id}`} className="form-input" value={sc?.cta||''} readOnly={isReadOnly}
                placeholder="e.g., DM us / Visit link / Share this..."
                style={{background:'var(--bg2)',borderColor:'var(--border2)',paddingBottom:20}}
                onChange={e=>onUpdateScript(wo.id,'cta',e.target.value)} />
              <span style={{position:'absolute',bottom:5,right:8,fontSize:'0.62rem',color:'var(--text3)',fontFamily:'inherit'}}>{(sc?.cta||'').length} / 100</span>
            </div>
          </div>
          <div style={{margin:0}}>
            <label style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:5}}>
              <span style={{fontSize:'0.68rem',fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.4px',display:'flex',alignItems:'center',gap:5}}>
                <span style={{width:2,height:12,borderRadius:1,background:'#14b8a6',display:'inline-block'}}/>
                Visual Direction
              </span>
              {!isReadOnly && <VoiceMicBtn lang={voiceLang} fieldLabel="Visual Direction" onResult={t=>onUpdateScript(wo.id,'visual',(sc?.visual||'')+' '+t)} />}
            </label>
            <div style={{position:'relative'}}>
              <input id={`cc-visual-${wo.id}`} className="form-input" value={sc?.visual||''} readOnly={isReadOnly}
                placeholder="e.g., Colors, mood, reference style..."
                style={{background:'var(--bg2)',borderColor:'var(--border2)',paddingBottom:20}}
                onChange={e=>onUpdateScript(wo.id,'visual',e.target.value)} />
              <span style={{position:'absolute',bottom:5,right:8,fontSize:'0.62rem',color:'var(--text3)',fontFamily:'inherit'}}>{(sc?.visual||'').length} / 150</span>
            </div>
          </div>
        </div>

        {/* Brand Details — expanded by default, distinct gradient bg */}
        {/* References — placed below CTA/Visual Direction */}
        {tab !== 'client' && (
          <ReferencesBlock woId={wo.id} refs={refs} canEdit={!isReadOnly} onAdd={onAddRef} onDelete={onDeleteRef} />
        )}

        {/* Script Voice Note — above Brand Details */}
        {tab==='scripts' && !isReadOnly && (
          <InlineScriptVoice voiceNotes={sc?.voice_notes||[]} onSaved={onSaveVoiceNotes} />
        )}

        <BrandDetailsBlock key={wo.id} wo={wo} sc={sc} isReadOnly={isReadOnly} onUpdate={onUpdateScript} />

        {/* Rejection input for approval tabs */}
        {(tab==='internal'||tab==='client') && !isReadOnly && (
          <div className="form-group" style={{marginBottom:'10px'}}>
            <label className="form-label">↩ Rejection Reason <span className="text-xs text-muted" style={{fontWeight:400,textTransform:'none'}}>(required to reject)</span></label>
            <input className="form-input" value={rejectReason} onChange={e=>setRejectReason(e.target.value)}
              placeholder="Describe what needs to be changed..." />
          </div>
        )}

        {/* Action buttons */}
        <div style={{display:'flex',gap:'10px',flexWrap:'wrap',alignItems:'center',paddingTop:4}}>
          {!isReadOnly && (
            <button onClick={()=>onSave(wo)} disabled={saving}
              style={{display:'inline-flex',alignItems:'center',gap:7,padding:'7px 16px',fontSize:'0.82rem',fontWeight:600,background:'var(--bg2)',color:'var(--text2)',border:'1px solid var(--border)',borderRadius:6,cursor:'pointer',transition:'all 0.15s',fontFamily:'inherit'}}
              onMouseOver={e=>{e.currentTarget.style.borderColor='var(--accent)';e.currentTarget.style.color='var(--accent)';}}
              onMouseOut={e=>{e.currentTarget.style.borderColor='var(--border)';e.currentTarget.style.color='var(--text2)';}}>
              {saving ? 'Saving…' : 'Save as Draft'}
            </button>
          )}

          {tab==='scripts' && (<>
            {(!status||status==='Draft'||status==='Rejected') && (
              <button onClick={()=>onSubmitInternal(wo)}
                style={{display:'inline-flex',alignItems:'center',gap:8,padding:'7px 18px',fontSize:'0.82rem',fontWeight:600,background:'#4f7cf7',color:'#fff',border:'none',borderRadius:6,cursor:'pointer',transition:'all 0.15s',fontFamily:'inherit'}}
                onMouseOver={e=>e.currentTarget.style.filter='brightness(1.08)'}
                onMouseOut={e=>e.currentTarget.style.filter='none'}>
                <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="15" y1="1" x2="7" y2="9"/><polygon points="15,1 10,15 7,9 1,6"/></svg>
                Submit for Internal Approval
              </button>
            )}
            {status==='Pending Internal' && (
              <span style={{display:'inline-flex',alignItems:'center',gap:6,padding:'7px 14px',fontSize:'0.78rem',fontWeight:600,color:'#e87830',background:'rgba(232,120,48,0.08)',border:'1px solid rgba(232,120,48,0.25)',borderRadius:8}}>
                <span style={{width:7,height:7,borderRadius:'50%',background:'#e87830',display:'inline-block',animation:'voicePulse 1.4s infinite'}}/>
                Awaiting Internal Review
              </span>
            )}
            {status==='Pending Client' && (
              <span style={{display:'inline-flex',alignItems:'center',gap:6,padding:'7px 14px',fontSize:'0.78rem',fontWeight:600,color:'#6c58f0',background:'rgba(108,88,240,0.08)',border:'1px solid rgba(108,88,240,0.25)',borderRadius:8}}>
                <span style={{width:7,height:7,borderRadius:'50%',background:'#6c58f0',display:'inline-block',animation:'voicePulse 1.4s infinite'}}/>
                Awaiting Client Approval
              </span>
            )}
            {status==='Approved' && (
              <span style={{display:'inline-flex',alignItems:'center',gap:6,padding:'7px 14px',fontSize:'0.78rem',fontWeight:700,color:'#16a34a',background:'rgba(22,163,74,0.08)',border:'1px solid rgba(22,163,74,0.25)',borderRadius:8}}>
                ✓ Approved & ready for scheduling
              </span>
            )}
          </>)}

          {tab==='internal' && !isReadOnly && (<>
            <button onClick={()=>onApproveInternal(wo)}
              style={{display:'inline-flex',alignItems:'center',gap:7,padding:'7px 16px',fontSize:'0.82rem',fontWeight:600,background:'#16a34a',color:'#fff',border:'none',borderRadius:6,cursor:'pointer',transition:'all 0.15s',fontFamily:'inherit'}}
              onMouseOver={e=>e.currentTarget.style.filter='brightness(1.08)'}
              onMouseOut={e=>e.currentTarget.style.filter='none'}>
              Approve
            </button>
            <button onClick={()=>{if(rejectReason.trim())onRejectEntry(wo,rejectReason);else alert('Enter rejection reason first.');}}
              style={{display:'inline-flex',alignItems:'center',gap:7,padding:'7px 16px',fontSize:'0.82rem',fontWeight:600,background:'var(--bg2)',color:'#ef4444',border:'1px solid rgba(239,68,68,0.3)',borderRadius:6,cursor:'pointer',transition:'all 0.15s',fontFamily:'inherit'}}
              onMouseOver={e=>{e.currentTarget.style.background='rgba(239,68,68,0.06)';e.currentTarget.style.borderColor='#ef4444';}}
              onMouseOut={e=>{e.currentTarget.style.background='var(--bg2)';e.currentTarget.style.borderColor='rgba(239,68,68,0.3)';}}>
              Reject
            </button>
            <button onClick={()=>onSkipToClient(wo)}
              style={{display:'inline-flex',alignItems:'center',gap:6,padding:'7px 14px',fontSize:'0.78rem',fontWeight:600,background:'var(--bg3)',color:'#6c58f0',border:'1px solid rgba(108,88,240,0.25)',borderRadius:6,cursor:'pointer',fontFamily:'inherit',transition:'all 0.15s'}}
              onMouseOver={e=>{e.currentTarget.style.background='rgba(108,88,240,0.08)';}}
              onMouseOut={e=>{e.currentTarget.style.background='var(--bg3)';}}>
              Skip to Client
            </button>
          </>)}

          {tab==='client' && !isReadOnly && (<>
            <button onClick={()=>onApproveClient(wo)}
              style={{display:'inline-flex',alignItems:'center',gap:7,padding:'7px 16px',fontSize:'0.82rem',fontWeight:600,background:'#16a34a',color:'#fff',border:'none',borderRadius:6,cursor:'pointer',transition:'all 0.15s',fontFamily:'inherit'}}
              onMouseOver={e=>e.currentTarget.style.filter='brightness(1.08)'}
              onMouseOut={e=>e.currentTarget.style.filter='none'}>
              Approve
            </button>
            <button onClick={()=>{if(rejectReason.trim())onRejectEntry(wo,rejectReason);else alert('Enter rejection reason first.');}}
              style={{display:'inline-flex',alignItems:'center',gap:7,padding:'7px 16px',fontSize:'0.82rem',fontWeight:600,background:'var(--bg2)',color:'#ef4444',border:'1px solid rgba(239,68,68,0.3)',borderRadius:6,cursor:'pointer',transition:'all 0.15s',fontFamily:'inherit'}}
              onMouseOver={e=>{e.currentTarget.style.background='rgba(239,68,68,0.06)';e.currentTarget.style.borderColor='#ef4444';}}
              onMouseOut={e=>{e.currentTarget.style.background='var(--bg2)';e.currentTarget.style.borderColor='rgba(239,68,68,0.3)';}}>
              Reject
            </button>
          </>)}
        </div>

        <VersionHistory sc={sc} isClient={tab==='client'} />
      </div>
      </div>{/* end left column */}

      {/* ── Right Panel ── */}
      <div style={{padding:'16px',display:'flex',flexDirection:'column',gap:16,background:'var(--bg3)'}}>

        {/* Publishing Summary — collapsible */}
        <div>
          <div onClick={()=>setPubOpen(v=>!v)}
            style={{display:'flex',alignItems:'center',justifyContent:'space-between',cursor:'pointer',padding:'4px 0',marginBottom:pubOpen?10:0}}>
            <span style={{fontSize:'0.68rem',fontWeight:600,color:'var(--text2)',textTransform:'uppercase',letterSpacing:'0.4px'}}>Publishing Summary</span>
            <svg viewBox="0 0 10 6" width="10" height="6" fill="none" stroke="var(--text3)" strokeWidth="1.8" strokeLinecap="round"
              style={{transform:pubOpen?'rotate(180deg)':'rotate(0deg)',transition:'transform 0.2s'}}>
              <path d="M1 1l4 4 4-4"/>
            </svg>
          </div>
          {pubOpen && woPlats.length>0 && (
            <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:8}}>
              <span style={{fontSize:'0.68rem',color:'var(--text3)',minWidth:72}}>Platforms</span>
              <div style={{display:'flex',gap:4,flexWrap:'wrap'}}>
                {woPlats.map(p=>(
                  <div key={p} title={p} style={{padding:'2px 6px',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:5,fontSize:'0.62rem',fontWeight:600,color:'var(--text2)'}}>
                    {p.slice(0,2).toUpperCase()}
                  </div>
                ))}
              </div>
            </div>
          )}
          {pubOpen && woFmts.length>0 && (
            <div style={{display:'flex',alignItems:'flex-start',gap:8,marginBottom:8}}>
              <span style={{fontSize:'0.68rem',color:'var(--text3)',minWidth:72,paddingTop:2}}>Formats</span>
              <div style={{display:'flex',gap:3,flexWrap:'wrap'}}>
                {woFmts.map((f,i)=>(
                  <span key={i} style={{padding:'2px 6px',background:'rgba(108,88,240,0.08)',border:'1px solid rgba(108,88,240,0.2)',borderRadius:8,fontSize:'0.6rem',fontWeight:600,color:'var(--accent2)'}}>
                    {f.length>18?f.slice(0,16)+'…':f}
                  </span>
                ))}
              </div>
            </div>
          )}
          {pubOpen && wfName && (
            <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:6}}>
              <span style={{fontSize:'0.68rem',color:'var(--text3)',minWidth:72}}>Campaign</span>
              <span style={{fontSize:'0.72rem',color:'var(--text2)',fontWeight:500}}>{wfName}</span>
            </div>
          )}
          {pubOpen && wo.client && (
            <div style={{display:'flex',alignItems:'center',gap:8}}>
              <span style={{fontSize:'0.68rem',color:'var(--text3)',minWidth:72}}>Client</span>
              <span style={{fontSize:'0.72rem',color:'var(--text2)',fontWeight:500}}>{cn}</span>
            </div>
          )}
        </div>

        <div style={{height:1,background:'var(--border)'}}/>

        {/* Approval Workflow */}
        <div>
          <div style={{fontSize:'0.68rem',fontWeight:600,color:'var(--text2)',textTransform:'uppercase',letterSpacing:'0.4px',marginBottom:10}}>Approval Workflow</div>
          {[
            {n:1,label:'Internal Approval',sub:status==='Pending Internal'?'Pending approval from internal team':sc?.internal_approved_at?`by ${sc.internal_approved_by||'team'}`:'Not started',done:['Pending Client','Approved'].includes(status)||!!sc?.internal_approved_at,active:status==='Pending Internal'},
            {n:2,label:'Client Approval',sub:status==='Pending Client'?'Pending client review':sc?.client_approved_at?`by ${sc.client_approved_by||'client'}`:'Awaiting internal',done:status==='Approved',active:status==='Pending Client'},
            {n:3,label:'Final Approved',sub:'Ready for scheduling',done:status==='Approved',active:false},
          ].map((step,si)=>(
            <div key={step.n} style={{display:'flex',alignItems:'flex-start',gap:8,marginBottom:si<2?12:0,position:'relative'}}>
              {si<2 && <div style={{position:'absolute',left:10,top:22,width:1.5,height:14,background:'var(--border)'}}/>}
              <div style={{width:22,height:22,borderRadius:'50%',flexShrink:0,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'0.65rem',fontWeight:800,
                background:step.done?'#22c47a':step.active?'var(--accent)':'var(--bg4)',
                color:step.done||step.active?'#fff':'var(--text3)',
                border:step.done||step.active?'none':'1.5px solid var(--border2)'}}>
                {step.done?'✓':step.n}
              </div>
              <div style={{flex:1,paddingTop:1}}>
                <div style={{fontSize:'0.76rem',fontWeight:600,color:step.done?'#22c47a':step.active?'var(--accent)':'var(--text2)'}}>{step.label}</div>
                <div style={{fontSize:'0.66rem',color:'var(--text3)',marginTop:1}}>{step.sub}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Version History */}
        {(sc?.versions||[]).length>0 && <>
          <div style={{height:1,background:'var(--border)'}}/>
          <div>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
              <span style={{fontSize:'0.68rem',fontWeight:600,color:'var(--text2)',textTransform:'uppercase',letterSpacing:'0.4px'}}>Version History</span>
              <span style={{fontSize:'0.62rem',color:'var(--text3)'}}>{sc.versions.length} submission{sc.versions.length!==1?'s':''}</span>
            </div>
            {[...sc.versions].reverse().slice(0,4).map((v,i)=>{
              const vColor=v.action==='Submitted'?'var(--accent)':v.action?.includes('Approved')?'#22c47a':'var(--red)';
              const vDate=v.at?new Date(v.at):null;
              const vFmt=vDate?`${String(vDate.getDate()).padStart(2,'0')} ${vDate.toLocaleString('en-IN',{month:'short'})} ${vDate.getFullYear()}, ${String(vDate.getHours()).padStart(2,'0')}:${String(vDate.getMinutes()).padStart(2,'0')} ${vDate.getHours()>=12?'PM':'AM'}`:'';
              return (
                <div key={i} style={{display:'flex',alignItems:'flex-start',gap:8,marginBottom:10}}>
                  <div style={{width:8,height:8,borderRadius:'50%',background:vColor,flexShrink:0,marginTop:5}}/>
                  <div style={{flex:1}}>
                    <div style={{fontSize:'0.7rem',fontWeight:600,color:vColor}}>{v.action}</div>
                    {v.by&&<div style={{fontSize:'0.62rem',color:'var(--text3)'}}>by {v.by}</div>}
                    {vFmt&&<div style={{fontSize:'0.6rem',color:'var(--text3)',fontFamily:'inherit'}}>{vFmt}</div>}
                    {v.rejectionReason&&<div style={{fontSize:'0.62rem',color:'var(--red)',marginTop:2}}>↩ {v.rejectionReason}</div>}
                  </div>
                </div>
              );
            })}
            {sc.versions.length>4&&(
              <button style={{width:'100%',padding:5,fontSize:'0.68rem',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:6,cursor:'pointer',color:'var(--text3)'}}>
                View All {sc.versions.length} Versions
              </button>
            )}
          </div>
        </>}
      </div>
      </div>{/* end two-column grid */}
    </div>
  );
});

// ── Main component ────────────────────────────────────────
class CCErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(e) { return { error: e }; }
  render() {
    if (this.state.error) {
      return (
        <div style={{padding:'40px',color:'#e84545',fontFamily:'monospace',fontSize:'0.8rem'}}>
          <h3>ContentCalendar Error</h3>
          <pre style={{whiteSpace:'pre-wrap'}}>{this.state.error?.message}</pre>
          <pre style={{whiteSpace:'pre-wrap',color:'var(--text3)',fontSize:'0.7rem'}}>{this.state.error?.stack?.slice(0,500)}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

function ContentCalendarInner() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const urlTab = searchParams.get('tab');
  const urlWo = searchParams.get('wo');
  const now = new Date();

  const { canTab, user, viewAsActive } = useAuth();
  const allowedCCTabs = [{id:'scripts',label:'📝 Scripts & Briefs'},{id:'internal',label:'🔒 Internal Approval'},{id:'client',label:'👔 Client Approval'},{id:'approved',label:'✅ Approved'}]
    .filter(t => { const cfg = (OPERATIONS_TABS.contentcalendar||[]).find(x=>x.id===t.id); return !cfg?.permissionKey || canTab(cfg.permissionKey); });
  const [tab,           setTab]           = useState(urlTab && allowedCCTabs.find(t=>t.id===urlTab) ? urlTab : (allowedCCTabs[0]?.id || 'scripts'));
  const [entries,       setEntries]       = useState([]);
  // Client day selections (visible only for client-role users)
  const [myDaySels, setMyDaySels] = useState([]);
  useEffect(() => { if (user?.role === "client" || viewAsActive) api.get("/my-day-selections").then(r => setMyDaySels(r.data?.data || [])).catch(() => {}); }, [user, viewAsActive]);
  const [scripts,       setScripts]       = useState({});
  const [clients,       setClients]       = useState([]);
  const [campaignTypes, setCampaignTypes] = useState([]);
  const [platforms,     setPlatforms]     = useState([]);
  const [outputFormats, setOutputFormats] = useState([]);
  const [activeWOId,   setActiveWOId]   = useState(null);
  // Auto-open WO from URL param
  const [urlWoHandled, setUrlWoHandled] = useState(false);
  const [loading,       setLoading]       = useState(true);
  const [scriptsLoaded, setScriptsLoaded] = useState(false);
  const [filterClient,  setFilterClient]  = useState('');
  const [filterWoScripts,  setFilterWoScripts]  = useState('');
  const [filterWoInternal, setFilterWoInternal] = useState('');
  const [filterWoClient,   setFilterWoClient]   = useState('');
  const [filterWoApproved, setFilterWoApproved] = useState('');
  const [filterWfScripts,  setFilterWfScripts]  = useState('');
  const [filterWfInternal, setFilterWfInternal] = useState('');
  const [filterWfClient,   setFilterWfClient]   = useState('');
  const [filterWfApproved, setFilterWfApproved] = useState('');
  const [yearF,         setYearF]         = useState('');
  const [monthsF,       setMonthsF]       = useState(new Set());
  const [showMonthDd,   setShowMonthDd]   = useState(false);
  const [hidePosted,    setHidePosted]    = useState(true);
  const [selected,      setSelected]      = useState(new Set());
  const [saving,        setSaving]        = useState({});

  // ── Load ─────────────────────────────────────────────────
  const load = useCallback(async () => {
    setLoading(true);
    setScriptsLoaded(false);
    try {
      // All calls in parallel simultaneously
      const [wo, cl, ct, pl, of_, scriptsRes] = await Promise.all([
        api.get('/work-orders'),
        api.get('/clients?active_only=false'),
        api.get('/campaign-types').catch(()=>({data:[]})),
        api.get('/platforms').catch(()=>({data:[]})),
        api.get('/output-formats').catch(()=>({data:[]})),
        api.get('/content-calendar/scripts').catch(()=>({data:{data:{}}})),
      ]);
      const wos = wo.data?.data || wo.data || [];
      setEntries(wos);
      setClients(cl.data?.data || cl.data || []);
      setCampaignTypes(ct.data?.data || ct.data || []);
      setPlatforms(pl.data?.data || pl.data || []);
      setOutputFormats(of_.data?.data || of_.data || []);

      const batchData = scriptsRes.data?.data || {};
      const smap = {};
      wos.forEach(w => { smap[w.id] = batchData[w.id] || {}; });
      setScripts(smap);
      setScriptsLoaded(true);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, []);

  // Auto-open WO from URL param after data loads
  useEffect(() => {
    if (urlWo && entries.length > 0 && !urlWoHandled) {
      const match = entries.find(e => e.wo_number === urlWo || String(e.id) === urlWo);
      if (match) { setActiveWOId(match.id); }
      setUrlWoHandled(true);
    }
  }, [urlWo, entries, urlWoHandled]);

  // ── Year/Month filter helpers ─────────────────────────────
  const currentYear = new Date().getFullYear();
  const yearOptions = [currentYear - 1, currentYear, currentYear + 1].map(String);
  const MONTH_NAMES_SHORT = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const toggleMonth = m => setMonthsF(prev => { const s = new Set(prev); s.has(m) ? s.delete(m) : s.add(m); return s; });

  useEffect(() => {
    if (!showMonthDd) return;
    const h = e => { if (!e.target.closest('[data-month-dd]')) setShowMonthDd(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [showMonthDd]);

  // ── Filters ───────────────────────────────────────────────
  const approvalStatus = (wo) => { const s=scripts[wo.id]; return s?.approval_status||s?.approvalStatus||'Draft'; };

  // Only show WOs whose workflow has a phase linked to Content Calendar
  const hasCCPhase = useCallback((wo) => {
    const ctId = wo.campaign_type_id || wo.campaign_type?.id;
    if (!ctId) return true; // no workflow assigned — show by default
    const ct = campaignTypes.find(c => c.id === ctId);
    if (!ct) return true; // campaign type not found in list — show by default
    let phases = ct.phases;
    if (typeof phases === 'string') try { phases = JSON.parse(phases); } catch(e) { return true; }
    if (!Array.isArray(phases) || phases.length === 0) return true; // no phases defined — show by default
    return phases.some(p => {
      const linked = (p.linked_page_id || p.linkedPageId || '').toLowerCase();
      return linked.startsWith('contentcalendar');
    });
  }, [campaignTypes]);

  const filterByMonth = (wo) => {
    const d = wo.event_date||wo.date||wo.scheduled_date||'';
    if (!d) return !yearF && monthsF.size === 0;
    if (yearF && d.slice(0, 4) !== yearF) return false;
    if (monthsF.size > 0) { const m = parseInt(d.split('-')[1], 10); if (!monthsF.has(m)) return false; }
    return true;
  };

  const baseEntries = entries.filter(wo => {
    if (!hasCCPhase(wo)) return false;
    if (!filterByMonth(wo)) return false;
    if (filterClient && clientName(wo.client)!==filterClient) return false;
    const activeWoFilter = tab==='scripts' ? filterWoScripts : tab==='internal' ? filterWoInternal : tab==='client' ? filterWoClient : filterWoApproved;
    if (activeWoFilter && !(wo.wo_number||'WO-'+wo.id).toLowerCase().includes(activeWoFilter.toLowerCase())) return false;
    const activeWfFilter = tab==='scripts' ? filterWfScripts : tab==='internal' ? filterWfInternal : tab==='client' ? filterWfClient : filterWfApproved;
    if (activeWfFilter) {
      const wfName = (wo.campaign_type?.name || wo.workflow_type || '').toLowerCase();
      if (!wfName.includes(activeWfFilter.toLowerCase())) return false;
    }
    return true;
  }).sort((a,b)=>(a.event_date||a.date||'').localeCompare(b.event_date||b.date||''));

  const tabEntries = !scriptsLoaded ? [] : baseEntries.filter(wo => {
    const st = approvalStatus(wo);
    if (tab==='scripts')  return !st||st==='Draft'||st==='Rejected';
    if (tab==='internal') return st==='Pending Internal';
    if (tab==='client')   return st==='Pending Client';
    if (tab==='approved') {
      if (st !== 'Approved') return false;
      if (hidePosted && wo.sch_state === 'posted') return false;
      return true;
    }
    return false;
  });

  const counts = !scriptsLoaded ? { scripts:0, internal:0, client:0, approved:0 } : {
    scripts:  baseEntries.filter(w=>{const s=approvalStatus(w);return !s||s==='Draft'||s==='Rejected';}).length,
    internal: baseEntries.filter(w=>approvalStatus(w)==='Pending Internal').length,
    client:   baseEntries.filter(w=>approvalStatus(w)==='Pending Client').length,
    approved: baseEntries.filter(w=>approvalStatus(w)==='Approved' && !(hidePosted && w.sch_state==='posted')).length,
  };

  // ── Script helpers ────────────────────────────────────────
  const updateScript = useCallback((woId, field, val) =>
    setScripts(s=>({...s,[woId]:{...(s[woId]||{}),[field]:val}})), []);

  const setStatus = (woId, status) =>
    setScripts(s=>({...s,[woId]:{...(s[woId]||{}),approval_status:status,approvalStatus:status}}));

  const saveScript = async (wo) => {
    setSaving(s=>({...s,[wo.id]:true}));
    try {
      const s = scripts[wo.id]||{};
      const res = await api.put('/content-calendar/'+wo.id+'/script',{
        hook:s.hook||'', message:s.message||'', script:s.script||'',
        visual:s.visual||'', cta:s.cta||'', references: s.references||[],
        brand_website: s.brand_website||'',
        brand_email:   s.brand_email  ||'',
        brand_phone:   s.brand_phone  ||'',
        brand_address: s.brand_address||'',
      });
      // Merge returned script (preserves approval_status from server)
      if (res.data?.script) {
        setScripts(prev=>({...prev,[wo.id]:{...prev[wo.id],...res.data.script}}));
      }
    } catch(e) { alert('Save failed: '+(e.response?.data?.message||e.message)); }
    finally { setSaving(s=>({...s,[wo.id]:false})); }
  };

  const submitInternal = async (wo) => {
    // Validate — at least Hook or Caption/Script must have content
    const s = scripts[wo.id]||{};
    if (!s.hook?.trim() && !s.script?.trim() && !s.message?.trim()) {
      alert('⚠️ Cannot submit — please add at least a Caption or Body Text before submitting for approval.');
      return;
    }
    try { await saveScript(wo); await api.post('/content-calendar/'+wo.id+'/send-to-internal'); setStatus(wo.id,'Pending Internal'); }
    catch(e) { alert('Failed: '+(e.response?.data?.message||e.message)); }
  };
  const approveInternal = async (wo, voiceNote) => {
    try {
      await api.post('/content-calendar/'+wo.id+'/approve-internal', voiceNote ? { voice_note: voiceNote } : {});
      setStatus(wo.id,'Pending Client');
    }
    catch(e) { alert('Failed: '+(e.response?.data?.message||e.message)); }
  };
  const approveClient = async (wo, voiceNote) => {
    try {
      const res = await api.post('/content-calendar/'+wo.id+'/approve-client', voiceNote ? { voice_note: voiceNote } : {});
      setStatus(wo.id, 'Approved');
    } catch(e) {
      // Check if approval actually went through despite the error (task generation may have failed)
      try {
        const check = await api.get('/content-calendar/'+wo.id+'/script');
        if (check?.data?.script?.approval_status === 'Approved') {
          setStatus(wo.id, 'Approved'); // Approval succeeded, task gen failed — that's ok
          return;
        }
      } catch(_) {}
      alert('Failed: '+(e.response?.data?.message||e.message));
    }
  };
  const rejectEntry = async (wo, reason, voiceNote) => {
    if (!reason?.trim()) { alert('Rejection reason is required.'); return; }
    try {
      await api.post('/content-calendar/'+wo.id+'/reject', {
        reason,
        ...(voiceNote ? { voice_note: voiceNote } : {}),
      });
      setScripts(s=>({...s,[wo.id]:{...(s[wo.id]||{}),approval_status:'Rejected',approvalStatus:'Rejected',rejection_reason:reason}}));
    } catch(e) { alert('Failed: '+(e.response?.data?.message||e.message)); }
  };
  const skipToClient = async (wo) => {
    try { await api.post('/content-calendar/'+wo.id+'/approve-internal'); setStatus(wo.id,'Pending Client'); setTab('client'); }
    catch(e) { alert('Failed: '+(e.response?.data?.message||e.message)); }
  };

  // ── Inline WO field updates ───────────────────────────────
  const updatePlatforms = async (woId, plats) => {
    try {
      await api.put('/work-orders/'+woId, { platforms: plats });
      // Update local state immediately for instant UI feedback
      setEntries(es=>es.map(e=>e.id===woId ? { ...e, platforms: plats } : e));
    } catch(e) { alert('Failed to save platforms'); }
  };
  const updateFormats = async (woId, fmts) => {
    try {
      await api.put('/work-orders/'+woId, { output_formats: fmts });
      setEntries(es=>es.map(e=>e.id===woId ? { ...e, output_formats: fmts } : e));
    } catch(e) { alert('Failed to save formats'); }
  };
  const updateWorkflowType = async (woId, ctId, ctName) => {
    try {
      await api.put('/work-orders/'+woId, { campaign_type_id: ctId });
      setEntries(es=>es.map(e=>e.id===woId
        ? { ...e, campaign_type_id: ctId, campaign_type: { ...(e.campaign_type||{}), id: ctId, name: ctName }, workflow_type: ctName }
        : e
      ));
    } catch(e) { alert('Failed to save workflow type'); }
  };

  // ── References ────────────────────────────────────────────
  const addRef = useCallback((woId, ref) => {
    setScripts(s=>{
      const sc = {...(s[woId]||{})};
      sc.references = [...(sc.references||[]), ref];
      return {...s,[woId]:sc};
    });
  }, []);
  const deleteRef = useCallback((woId, idx) => {
    setScripts(s=>{
      const sc = {...(s[woId]||{})};
      sc.references = (sc.references||[]).filter((_,i)=>i!==idx);
      return {...s,[woId]:sc};
    });
  }, []);

  // ── Selection ─────────────────────────────────────────────
  const toggleSel = useCallback((id)=>setSelected(s=>{const n=new Set(s);n.has(id)?n.delete(id):n.add(id);return n;}),[]);
  const selectAll = (checked)=>setSelected(checked?new Set(tabEntries.map(w=>w.id)):new Set());
  const clearSel  = ()=>setSelected(new Set());

  const bulkSubmitInternal = async () => {
    if (!selected.size){alert('Select at least one entry first');return;}
    let skipped = 0;
    for(const id of [...selected]){
      const wo=entries.find(w=>w.id===id);
      if(wo){
        const s=scripts[id]||{};
        if(!s.hook?.trim()&&!s.script?.trim()&&!s.message?.trim()){ skipped++; continue; }
        await submitInternal(wo);
      }
    }
    if(skipped>0) alert(`⚠️ ${skipped} entr${skipped===1?'y':'ies'} skipped — no content added yet.`);
    clearSel();
  };
  const bulkApprove = async () => {
    if (!selected.size){alert('Select at least one entry first');return;}
    for(const id of [...selected]){const wo=entries.find(w=>w.id===id);if(wo){if(tab==='internal')await approveInternal(wo);else await approveClient(wo);}}
    clearSel();
  };
  const bulkReject = async () => {
    if (!selected.size){alert('Select at least one entry first');return;}
    const reason=window.prompt(`Rejection reason for ${selected.size} item(s):`,'');
    if(!reason?.trim())return;
    for(const id of [...selected]){const wo=entries.find(w=>w.id===id);if(wo)await rejectEntry(wo,reason.trim());}
    clearSel();
  };

  // ── Print ─────────────────────────────────────────────────
  const doPrint = () => {
    const toprint = entries.filter(e=>{
      const d=e.event_date||e.date||'';
      if (!d) return false;
      if (yearF && d.slice(0,4)!==yearF) return false;
      if (monthsF.size>0){const m=parseInt(d.split('-')[1],10);if(!monthsF.has(m))return false;}
      return (!filterClient||clientName(e.client)===filterClient);
    }).sort((a,b)=>(a.event_date||a.date||'').localeCompare(b.event_date||b.date||''));
    const rows = toprint.map(e=>{
      const s=scripts[e.id]||{};
      const d=e.event_date||e.date||'';
      const [ey,em,ed]=d?d.split('-'):['','',''];
      const status=s.approval_status||s.approvalStatus||'Draft';
      return `<tr>
        <td>${e.wo_number||'WO-'+e.id}</td>
        <td>${ed?`${ed}-${em}-${ey}`:''}</td>
        <td>${clientName(e.client)}</td>
        <td>${e.title||e.day_name||''}</td>
        <td>${s.hook||''}</td>
        <td>${s.script||''}</td>
        <td>${s.cta||''}</td>
        <td>${status}</td>
      </tr>`;
    }).join('');
    const win=window.open('','_blank');
    const monthLabel = monthsF.size===0&&!yearF?'All':`${yearF||''}${monthsF.size>0?' '+[...monthsF].sort((a,b)=>a-b).map(m=>MONTH_NAMES_SHORT[m-1]).join(', '):''}`.trim();
    win.document.write(`<!DOCTYPE html><html><head><title>Content Briefs — ${monthLabel}</title>
    <style>@page{size:A4 landscape;margin:12mm}body{font-family:sans-serif;font-size:10px;}
    h2{font-size:14px;margin-bottom:4px;}table{width:100%;border-collapse:collapse;}
    th{background:#f0f2f7;padding:6px 8px;border:1px solid #ddd;text-align:left;font-size:9px;text-transform:uppercase;}
    td{padding:8px;border:1px solid #ddd;vertical-align:top;}
    .print-btn{position:fixed;top:12px;right:12px;padding:7px 16px;background:#3b7ef0;color:#fff;border:none;border-radius:6px;cursor:pointer;font-size:12px;}
    @media print{.print-btn{display:none;}}
    </style></head><body>
    <button class="print-btn" onclick="window.print()">🖨️ Print / Save PDF</button>
    <h2>📝 Content Briefs — ${monthLabel||'All'} · ${filterClient||'All Clients'}</h2>
    <p style="font-size:9px;color:#666;margin-bottom:10px;">Generated: ${new Date().toLocaleString('en-IN')}</p>
    <table><thead><tr>
      <th>WO#</th><th>Date</th><th>Client</th><th>Event</th><th>Hook</th><th>Caption/Script</th><th>CTA</th><th>Status</th>
    </tr></thead><tbody>${rows}</tbody></table>
    </body></html>`);
    win.document.close();
  };

  const uniqueClients = [...new Set(entries.map(w=>clientName(w.client)).filter(Boolean))];

  // ── Shared approval card props ──────────────────────────────
  const saveVoiceNotes = async (woId, voiceNotes) => {
    try {
      const res = await api.put('/content-calendar/'+woId+'/script', { voice_notes: voiceNotes });
      if (res.data?.script) setScripts(prev=>({...prev,[woId]:{...prev[woId],...res.data.script}}));
    } catch(e) { alert('Failed to save voice note: '+(e.response?.data?.message||e.message)); }
  };

  const approvalCardProps = (wo) => ({
    wo, tab, sc: scripts[wo.id]||{},
    campaignTypes, platforms, outputFormats,
    selected: selected.has(wo.id),
    onToggleSel: toggleSel,
    onApproveInternal: approveInternal,
    onApproveClient: approveClient,
    onRejectEntry: rejectEntry,
    onSkipToClient: skipToClient,
    onAddRef: addRef,
    onDeleteRef: deleteRef,
    onSaveScript: async (wo, extra) => {
      try {
        const s = scripts[wo.id]||{};
        const res = await api.put('/content-calendar/'+wo.id+'/script',{
          hook:s.hook||'', message:s.message||'', script:s.script||'',
          visual:s.visual||'', cta:s.cta||'', references:s.references||[],
          ...extra,
        });
        if (res.data?.script) setScripts(prev=>({...prev,[wo.id]:{...prev[wo.id],...res.data.script}}));
      } catch(e) { alert('Save failed: '+(e.response?.data?.message||e.message)); }
    },
    onSaveVoiceNotes: (voiceNotes) => saveVoiceNotes(wo.id, voiceNotes),
  });

  // ── Save voice notes helper ──────────────────────────────


  // ── Shared card props ─────────────────────────────────────
  const cardProps = (wo) => ({
    wo, tab, sc: scripts[wo.id]||{},
    campaignTypes, platforms, outputFormats,
    selected: selected.has(wo.id),
    onToggleSel: toggleSel,
    onSave: saveScript,
    onSubmitInternal: submitInternal,
    onApproveInternal: approveInternal,
    onApproveClient: approveClient,
    onRejectEntry: rejectEntry,
    onSkipToClient: skipToClient,
    onUpdateScript: updateScript,
    onUpdatePlatforms: updatePlatforms,
    onUpdateFormats: updateFormats,
    onUpdateWorkflowType: updateWorkflowType,
    onAddRef: addRef,
    onDeleteRef: deleteRef,
    onSaveVoiceNotes: (vn) => saveVoiceNotes(wo.id, vn),
    saving: !!saving[wo.id],
    onActivate: () => setActiveWOId(id => id === wo.id ? null : wo.id),
    isActive: activeWOId === wo.id,
  });

  // ── Render ────────────────────────────────────────────────
  return (
    <div>
      {/* ── Sticky header ── */}
      <div style={{position:'sticky',top:'-24px',zIndex:30,background:'var(--bg)',margin:'-24px -24px 0',padding:'24px 24px 0'}}>
        <div style={{display:'flex',gap:0,marginBottom:'16px',borderBottom:'2px solid var(--border)',alignItems:'flex-end'}}>
          {[
            {id:'scripts',  label:'📝 Scripts & Briefs',   badge:counts.scripts,  badgeStyle:''},
            {id:'internal', label:'🔒 Internal Approval',  badge:counts.internal, badgeStyle:'background:#e8783022;color:#e87830;border:1px solid #e8783044;'},
            {id:'client',   label:'👔 Client Approval',    badge:counts.client,   badgeStyle:'background:#6c58f022;color:#6c58f0;border:1px solid #6c58f044;'},
            {id:'approved', label:'✅ Approved',            badge:counts.approved, badgeStyle:'background:#1db87a22;color:#1db87a;border:1px solid #1db87a44;'},
          ].filter(t => { const cfg = (OPERATIONS_TABS.contentcalendar||[]).find(x=>x.id===t.id); return !cfg?.permissionKey || canTab(cfg.permissionKey); }).map(t=>(
            <button key={t.id} onClick={()=>{setTab(t.id);clearSel();}} style={{
              padding:'8px 20px',fontSize:'0.82rem',fontWeight:700,border:'none',background:'none',cursor:'pointer',
              color:tab===t.id?'var(--accent)':'var(--text3)',
              borderBottom:tab===t.id?'3px solid var(--accent)':'3px solid transparent',
              marginBottom:'-2px',whiteSpace:'nowrap',
            }}>
              {t.label}
              {t.badge>0&&(
                <span className="nav-badge" style={{marginLeft:'4px',...(t.badgeStyle?Object.fromEntries(t.badgeStyle.split(';').filter(Boolean).map(s=>{const[k,v]=s.split(':');return[k.trim().replace(/-([a-z])/g,(_,l)=>l.toUpperCase()),v?.trim()];})):{})}}>
                  {t.badge}
                </span>
              )}
            </button>
          ))}

          {/* Year/Month filters + Content Planner button */}
          <div style={{display:'flex',gap:'6px',marginLeft:'auto',alignItems:'center',paddingBottom:'6px',flexWrap:'wrap'}}>
            <button onClick={()=>navigate('/planning?step=4')} style={{padding:'4px 12px',fontSize:'0.75rem',fontWeight:700,borderRadius:'20px',border:'1px solid #6c58f0',background:'#6c58f0',color:'#fff',cursor:'pointer',marginRight:'6px'}}>
              🗓️ ← Monthly Planner
            </button>
            <select style={{padding:'5px 10px',fontSize:'0.78rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)',cursor:'pointer',width:'auto'}} value={yearF} onChange={e=>setYearF(e.target.value)}>
              <option value="">All Years</option>
              {yearOptions.map(y=><option key={y} value={y}>{y}</option>)}
            </select>
            {/* Multi-month dropdown */}
            <div data-month-dd style={{position:'relative'}}>
              <button onClick={()=>setShowMonthDd(v=>!v)}
                style={{padding:'5px 10px',fontSize:'0.78rem',borderRadius:6,cursor:'pointer',
                  display:'flex',alignItems:'center',gap:5,whiteSpace:'nowrap',
                  background:monthsF.size>0?'#6c58f022':'var(--bg2)',
                  border:`1px solid ${monthsF.size>0?'#6c58f0':'var(--border)'}`,
                  color:monthsF.size>0?'#6c58f0':'var(--text)'}}>
                📅 {monthsF.size===0?'All Months':[...monthsF].sort((a,b)=>a-b).map(m=>MONTH_NAMES_SHORT[m-1]).join(', ')}
                <span style={{fontSize:'0.6rem',marginLeft:2}}>▾</span>
              </button>
              {showMonthDd&&(
                <div style={{position:'absolute',top:'110%',right:0,zIndex:200,
                  background:'var(--bg)',border:'1px solid var(--border)',borderRadius:8,
                  boxShadow:'0 8px 24px rgba(0,0,0,0.15)',padding:10,minWidth:200}}>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:4}}>
                    {MONTH_NAMES_SHORT.map((name,i)=>{const m=i+1;const on=monthsF.has(m);return(
                      <button key={m} onClick={()=>toggleMonth(m)}
                        style={{padding:'5px 8px',fontSize:'0.73rem',fontWeight:on?700:500,
                          borderRadius:6,border:`1px solid ${on?'#6c58f0':'var(--border)'}`,
                          background:on?'#6c58f0':'var(--bg2)',
                          color:on?'#fff':'var(--text2)',cursor:'pointer'}}>
                        {name}
                      </button>
                    );})}
                  </div>
                  <div style={{display:'flex',justifyContent:'space-between',marginTop:8,gap:6}}>
                    <button onClick={()=>setMonthsF(new Set())}
                      style={{flex:1,padding:'4px',fontSize:'0.68rem',borderRadius:6,cursor:'pointer',
                        border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text3)'}}>Clear</button>
                    <button onClick={()=>setShowMonthDd(false)}
                      style={{flex:1,padding:'4px',fontSize:'0.68rem',fontWeight:700,borderRadius:6,
                        cursor:'pointer',border:'none',background:'#6c58f0',color:'#fff'}}>Done</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ── Per-tab filter toolbar inside sticky header ── */}
        {tab==='scripts' && (
          <div style={{padding:'8px 16px',borderTop:'1px solid var(--border)',background:'var(--bg2)',boxShadow:'0 2px 8px rgba(0,0,0,0.06)',marginBottom:16}}>
            {/* Toolbar row — same style as Internal Approval */}
            <div style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'8px',flexWrap:'wrap'}}>
              <label style={{display:'flex',alignItems:'center',gap:'6px',cursor:'pointer',fontSize:'0.82rem',fontWeight:600}}>
                <input type="checkbox" onChange={e=>selectAll(e.target.checked)} style={{accentColor:'#6c58f0',width:'14px',height:'14px'}} /> Select All
              </label>
  
            <select style={{padding:'5px 10px',fontSize:'0.78rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)',cursor:'pointer',width:'auto'}} value={filterClient} onChange={e=>setFilterClient(e.target.value)}>
                <option value="">All Clients</option>
                {uniqueClients.map(c=><option key={c} value={c}>{c}</option>)}
              </select>
            <select style={{padding:'5px 10px',fontSize:'0.78rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)',cursor:'pointer',width:'auto'}} value={filterWfScripts} onChange={e=>setFilterWfScripts(e.target.value)}>
              <option value="">All Workflow Types</option>
              {campaignTypes.map(ct=><option key={ct.id||ct} value={ct.name||ct}>{ct.name||ct}</option>)}
            </select>
              <div style={{position:'relative',display:'flex',alignItems:'center'}}>
                <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="var(--text3)" strokeWidth="1.5" style={{position:'absolute',left:8,pointerEvents:'none'}}><circle cx="6.5" cy="6.5" r="4.5"/><line x1="10" y1="10" x2="14" y2="14"/></svg>
                <input value={filterWoScripts} onChange={e=>setFilterWoScripts(e.target.value)}
                  placeholder="WO number..." style={{padding:'5px 10px',paddingLeft:26,width:130,fontSize:'0.78rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)'}} />
                {filterWoScripts && <span onClick={()=>setFilterWoScripts('')} style={{position:'absolute',right:8,cursor:'pointer',color:'var(--text3)',fontSize:'0.8rem'}}>✕</span>}
              </div>
              <span className="badge badge-gray" style={{fontSize:'0.7rem'}}>{tabEntries.length} entr{tabEntries.length!==1?'ies':'y'}</span>
              {selected.size>0 && <span className="badge badge-blue" style={{fontSize:'0.72rem'}}>{selected.size} selected</span>}
              <div style={{marginLeft:'auto',display:'flex',gap:'8px',alignItems:'center'}}>
                <button className="btn btn-secondary" style={{fontSize:'0.78rem'}} onClick={doPrint}>🖨️ Print</button>
                <button onClick={bulkSubmitInternal}
                  style={{display:'inline-flex',alignItems:'center',gap:8,padding:'7px 16px',fontSize:'0.78rem',fontWeight:700,background:'linear-gradient(135deg,#4f7cf7,#7c5cf6)',color:'#fff',border:'none',borderRadius:8,cursor:'pointer',boxShadow:'0 2px 8px rgba(79,124,247,0.35)',transition:'all 0.15s',fontFamily:'inherit'}}
                  onMouseOver={e=>{e.currentTarget.style.transform='translateY(-1px)';e.currentTarget.style.boxShadow='0 4px 16px rgba(79,124,247,0.45)';}}
                  onMouseOut={e=>{e.currentTarget.style.transform='translateY(0)';e.currentTarget.style.boxShadow='0 2px 8px rgba(79,124,247,0.35)';}}>
                  <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="15" y1="1" x2="7" y2="9"/><polygon points="15,1 10,15 7,9 1,6"/></svg>
                  Submit Selected for Internal Approval
                </button>
              </div>
            </div>
          </div>
        )}
      </div>{/* end sticky header */}

      {/* ── Client Day Selections (visible only for client-role users) ── */}
      {(user?.role === 'client' || viewAsActive) && myDaySels.length > 0 && (
        <div style={{margin:'0 0 16px',padding:'16px',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:'var(--radius-sm)'}}>
          <div style={{fontWeight:700,fontSize:'0.95rem',marginBottom:'12px',color:'var(--text)'}}>📋 My Day Selections</div>
          {myDaySels.map(req => {
            const monthLabel = req.month ? new Date(req.month + '-01').toLocaleDateString('en-US', { month: 'long', year: 'numeric' }) : req.month;
            const statusColors = { pending: { bg: '#fef3c7', color: '#92400e', label: 'Pending' }, submitted: { bg: '#d1fae5', color: '#065f46', label: 'Submitted' }, agency_filled: { bg: '#dbeafe', color: '#1e40af', label: 'Agency filled' } };
            const st = statusColors[req.status] || statusColors.pending;
            return (
              <div key={req.id} style={{background:'var(--bg)',border:'1px solid var(--border)',borderRadius:'8px',padding:'12px 16px',marginBottom:'8px'}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'8px'}}>
                  <span style={{fontWeight:600,fontSize:'0.88rem',color:'var(--text)'}}>{monthLabel}</span>
                  <span style={{fontSize:'0.72rem',padding:'2px 8px',borderRadius:'4px',background:st.bg,color:st.color,fontWeight:600}}>{st.label}</span>
                </div>
                {req.status === 'submitted' || req.status === 'agency_filled' ? (
                  <div>
                    <div style={{fontSize:'0.8rem',color:'var(--text2)',marginBottom:'4px'}}>Selected days ({(req.selections||[]).length}/{req.allowance}):</div>
                    <div style={{display:'flex',flexWrap:'wrap',gap:'4px'}}>
                      {(req.selections||[]).map((d,i) => (
                        <span key={i} style={{fontSize:'0.75rem',padding:'3px 8px',background:'rgba(59,126,240,0.08)',border:'1px solid rgba(59,126,240,0.2)',borderRadius:'6px',color:'var(--accent)'}}>{d.name} ({d.date})</span>
                      ))}
                    </div>
                    {req.client_note && <div style={{fontSize:'0.78rem',color:'var(--text3)',marginTop:'6px',fontStyle:'italic'}}>Note: {req.client_note}</div>}
                  </div>
                ) : (
                  <div style={{fontSize:'0.8rem',color:'var(--text3)'}}>Awaiting your selection — check WhatsApp/Email for the selection link.</div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* ── Scripts tab content ── */}
      {tab==='scripts' && (
          <div style={{padding:'16px'}}>
            {(loading || !scriptsLoaded)?(
              <div style={{padding:'40px',textAlign:'center',color:'var(--text3)'}}>Loading content calendar...</div>
            ):tabEntries.length===0?(
              <div style={{padding:'32px',textAlign:'center',color:'var(--text3)'}}>
                <div style={{fontSize:'2rem',marginBottom:'8px'}}>📝</div>
                <div className="fw-700">No entries {yearF||monthsF.size>0?'for selected period':'yet'}</div>
                <div className="text-xs text-muted" style={{marginTop:'6px'}}>Generate entries from Monthly Planner → Step 3.</div>
                <button onClick={()=>navigate('/planning')} style={{marginTop:'12px',padding:'6px 16px',fontSize:'0.78rem',fontWeight:700,background:'#6c58f0',color:'#fff',border:'none',borderRadius:'6px',cursor:'pointer'}}>🗓️ Go to Monthly Planner</button>
              </div>
            ):tabEntries.map((wo)=><EntryCard key={wo.id} {...cardProps(wo)} />)}
          </div>
      )}

      {/* ── Internal Approval tab ── */}
      {tab==='internal' && (
        <div>
          {/* Toolbar */}
          <div style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'16px',flexWrap:'wrap',padding:'10px 16px',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:'var(--radius)'}}>
            <label style={{display:'flex',alignItems:'center',gap:'6px',cursor:'pointer',fontSize:'0.82rem',fontWeight:600}}>
              <input type="checkbox" onChange={e=>selectAll(e.target.checked)} style={{accentColor:'#e87830',width:'14px',height:'14px'}} /> Select All
            </label>
            <select style={{padding:'5px 10px',fontSize:'0.78rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)',cursor:'pointer',width:'auto'}} value={filterClient} onChange={e=>setFilterClient(e.target.value)}>
              <option value="">All Clients</option>
              {uniqueClients.map(c=><option key={c} value={c}>{c}</option>)}
            </select>
            <select style={{padding:'5px 10px',fontSize:'0.78rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)',cursor:'pointer',width:'auto'}} value={filterWfInternal} onChange={e=>setFilterWfInternal(e.target.value)}>
              <option value="">All Workflow Types</option>
              {campaignTypes.map(ct=><option key={ct.id||ct} value={ct.name||ct}>{ct.name||ct}</option>)}
            </select>
            <div style={{position:'relative',display:'flex',alignItems:'center'}}>
              <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="var(--text3)" strokeWidth="1.5" style={{position:'absolute',left:8,pointerEvents:'none'}}><circle cx="6.5" cy="6.5" r="4.5"/><line x1="10" y1="10" x2="14" y2="14"/></svg>
              <input value={filterWoInternal} onChange={e=>setFilterWoInternal(e.target.value)}
                placeholder="WO number..." style={{padding:'5px 10px',paddingLeft:26,width:130,fontSize:'0.78rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)'}} />
              {filterWoInternal && <span onClick={()=>setFilterWoInternal('')} style={{position:'absolute',right:8,cursor:'pointer',color:'var(--text3)',fontSize:'0.8rem'}}>✕</span>}
            </div>

            {selected.size>0 && (
              <span className="badge badge-blue" style={{fontSize:'0.72rem'}}>{selected.size} selected</span>
            )}
            <div style={{marginLeft:'auto',display:'flex',gap:'8px'}}>
              <button onClick={bulkApprove}
                style={{padding:'6px 16px',fontSize:'0.78rem',fontWeight:700,background:'#1db87a',color:'#fff',border:'none',borderRadius:'6px',cursor:'pointer'}}>
                ✅ Approve Selected
              </button>
              <button onClick={bulkReject}
                style={{padding:'6px 16px',fontSize:'0.78rem',fontWeight:700,background:'#e84545',color:'#fff',border:'none',borderRadius:'6px',cursor:'pointer'}}>
                ✕ Reject Selected
              </button>
            </div>
          </div>
          {tabEntries.length===0?(
            <div className="card" style={{padding:'48px',textAlign:'center'}}>
              <div style={{fontSize:'2.5rem',marginBottom:'12px'}}>🔒</div>
              <div className="fw-700">No Internal Approvals Pending</div>
              <div className="text-xs text-muted" style={{marginTop:'6px'}}>Scripts submitted from Content Briefs will appear here.</div>
            </div>
          ):tabEntries.map(wo=><ApprovalCard key={wo.id} {...approvalCardProps(wo)} />)}
        </div>
      )}

      {/* ── Client Approval tab ── */}
      {tab==='client' && (
        <div>
          {/* Toolbar */}
          <div style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'16px',flexWrap:'wrap',padding:'10px 16px',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:'var(--radius)'}}>
            <label style={{display:'flex',alignItems:'center',gap:'6px',cursor:'pointer',fontSize:'0.82rem',fontWeight:600}}>
              <input type="checkbox" onChange={e=>selectAll(e.target.checked)} style={{accentColor:'#6c58f0',width:'14px',height:'14px'}} /> Select All
            </label>
            <select style={{padding:'5px 10px',fontSize:'0.78rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)',cursor:'pointer',width:'auto'}} value={filterClient} onChange={e=>setFilterClient(e.target.value)}>
              <option value="">All Clients</option>
              {uniqueClients.map(c=><option key={c} value={c}>{c}</option>)}
            </select>
            <select style={{padding:'5px 10px',fontSize:'0.78rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)',cursor:'pointer',width:'auto'}} value={filterWfClient} onChange={e=>setFilterWfClient(e.target.value)}>
              <option value="">All Workflow Types</option>
              {campaignTypes.map(ct=><option key={ct.id||ct} value={ct.name||ct}>{ct.name||ct}</option>)}
            </select>
            <div style={{position:'relative',display:'flex',alignItems:'center'}}>
              <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="var(--text3)" strokeWidth="1.5" style={{position:'absolute',left:8,pointerEvents:'none'}}><circle cx="6.5" cy="6.5" r="4.5"/><line x1="10" y1="10" x2="14" y2="14"/></svg>
              <input value={filterWoClient} onChange={e=>setFilterWoClient(e.target.value)}
                placeholder="WO number..." style={{padding:'5px 10px',paddingLeft:26,width:130,fontSize:'0.78rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)'}} />
              {filterWoClient && <span onClick={()=>setFilterWoClient('')} style={{position:'absolute',right:8,cursor:'pointer',color:'var(--text3)',fontSize:'0.8rem'}}>✕</span>}
            </div>
            {selected.size>0 && (
              <span className="badge badge-blue" style={{fontSize:'0.72rem'}}>{selected.size} selected</span>
            )}
            <div style={{marginLeft:'auto',display:'flex',gap:'8px'}}>
              <button onClick={bulkApprove}
                style={{padding:'6px 16px',fontSize:'0.78rem',fontWeight:700,background:'#1db87a',color:'#fff',border:'none',borderRadius:'6px',cursor:'pointer'}}>
                ✅ Approve Selected
              </button>
              <button onClick={bulkReject}
                style={{padding:'6px 16px',fontSize:'0.78rem',fontWeight:700,background:'#e84545',color:'#fff',border:'none',borderRadius:'6px',cursor:'pointer'}}>
                ✕ Reject Selected
              </button>
            </div>
          </div>
          {tabEntries.length===0?(
            <div className="card" style={{padding:'48px',textAlign:'center'}}>
              <div style={{fontSize:'2.5rem',marginBottom:'12px'}}>👔</div>
              <div className="fw-700">No Client Approvals Pending</div>
              <div className="text-xs text-muted" style={{marginTop:'6px'}}>Internally approved scripts will appear here for client sign-off.</div>
            </div>
          ):tabEntries.map(wo=><ApprovalCard key={wo.id} {...approvalCardProps(wo)} />)}
        </div>
      )}

      {/* ── Approved tab ── */}
      {tab==='approved' && (
        <div>
          <div style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'16px',flexWrap:'wrap',padding:'10px 16px',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:'var(--radius)'}}>
            <select style={{padding:'5px 10px',fontSize:'0.78rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)',cursor:'pointer',width:'auto'}} value={filterClient} onChange={e=>setFilterClient(e.target.value)}>
              <option value="">All Clients</option>
              {uniqueClients.map(c=><option key={c} value={c}>{c}</option>)}
            </select>
            <select style={{padding:'5px 10px',fontSize:'0.78rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)',cursor:'pointer',width:'auto'}} value={filterWfApproved} onChange={e=>setFilterWfApproved(e.target.value)}>
              <option value="">All Workflow Types</option>
              {campaignTypes.map(ct=><option key={ct.id||ct} value={ct.name||ct}>{ct.name||ct}</option>)}
            </select>
            <div style={{position:'relative',display:'flex',alignItems:'center'}}>
              <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="var(--text3)" strokeWidth="1.5" style={{position:'absolute',left:8,pointerEvents:'none'}}><circle cx="6.5" cy="6.5" r="4.5"/><line x1="10" y1="10" x2="14" y2="14"/></svg>
              <input value={filterWoApproved} onChange={e=>setFilterWoApproved(e.target.value)}
                placeholder="WO number..." style={{padding:'5px 10px',paddingLeft:26,width:130,fontSize:'0.78rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)'}} />
              {filterWoApproved && <span onClick={()=>setFilterWoApproved('')} style={{position:'absolute',right:8,cursor:'pointer',color:'var(--text3)',fontSize:'0.8rem'}}>✕</span>}
            </div>
            <span className="text-xs text-muted" style={{alignSelf:'center'}}>{tabEntries.length} approved entr{tabEntries.length!==1?'ies':'y'}</span>
            <button onClick={()=>setHidePosted(v=>!v)}
              style={{padding:'5px 12px',fontSize:'0.78rem',fontWeight:600,borderRadius:6,cursor:'pointer',whiteSpace:'nowrap',
                border:`1px solid ${hidePosted?'var(--border)':'#1db87a'}`,
                background:hidePosted?'var(--bg2)':'#1db87a22',
                color:hidePosted?'var(--text2)':'#1db87a'}}>
              {hidePosted ? '👁 Show Posted' : '🙈 Hide Posted'}
            </button>
          </div>
          {tabEntries.length===0?(
            <div className="card" style={{padding:'40px',textAlign:'center'}}>
              <div style={{fontSize:'2rem',marginBottom:'8px'}}>✅</div>
              <div className="fw-700">No approved content yet</div>
              <div className="text-xs text-muted" style={{marginTop:'6px'}}>Entries approved by client will appear here.</div>
            </div>
          ):tabEntries.map(wo=><EntryCard key={wo.id} {...cardProps(wo)} />)}
        </div>
      )}
    </div>
  );
}

export default function ContentCalendar(props) {
  return <CCErrorBoundary><ContentCalendarInner {...props} /></CCErrorBoundary>;
}